export const allowedProfiles = [
  "901448", // DANIELA MALENDY ESPINOSA ROJAS
  "901449", // ALAN JAFET CERVANTES ALVAREZ
  "901443", // DULCE MEZA GARCIA
  "901447", // OCTAVIO RIOJA ROMERO
  "901066", // EMMANUEL ROMERO
  "901046", // JOSE ANTONIO MALDONADO
  "901178", // DIANA VILLANUEVA
  "901195", // OSCAR BETANCOUR
  "900721", // MOISES MONCADA
  "901129", // BLANCA REYNA MORALES
  "901329", // MITCA B  CRUZ
 	"77629", // SANDRA IVETTE HERNANDEZ CHAVEZ
  "78153", //LAURA ANGELICA SANCHEZ SERRANO	
"77662", //JOSE ROGER CASTILLO VILLALOBOS	
"77627", //KAREN MICHELLE MARTINEZ SILVA
"77629", //JOANNA MARTINEZ CONTRERAS	        
"77626", //CLAUDIA MARIA GONZALEZ MARTINEZ	
"77624", //MARIANA YAZMIN CORREA GUERRERO	
"77621", //GESTION DE NEGOCIOS	
"0", // . AGENTES LIBRES LATINO
"137", // . LATINOAMERICANA .
"162", // LAHUD GUIJARRO Y ASOCIADOS S C
"193", // GRUPO INTEGRAL NUCLEO TRESMIL S.C.
"277", // EXSE GRUPO ESPECIALISTA S.C
"295", // SUSANA VELASCO ROMERO
"296", // RITA LETICIA MARTINEZ LOPEZ
"312", // MERIT AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"320", // ELSA DIAZ DE FERNANDEZ
"347", // MANZUR Y ASOCIADOS S.C.
"350", // JORGE ALBERTO GUERRERO VELAZQUEZ
"364", // GRUPO SR AGENTE DE SEGUROS SA DE CV
"370", // FELIX ZAVALA PROFESIONALES EN RIESGOS S C
"378", // PROVYN PROTECCION EN VIDA Y NEGOCIOS SC.
"382", // JUAN LIBORIO ESPINOSA PEREZ
"385", // SALVADOR ALVAREZ RUIZ
"387", // JOSE LUIS JACINTO MORALES
"395", // SOBERON AGENTE DE SEGUROS Y DE FIANZAS SA
"404", // APSELP  AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"426", // J. JESUS LOPEZ SEGURA
"429", // GSI ENLACE PATRIMONIAL SA DE CV
"431", // EXPERTA CONSULTORES SA DE CV
"433", // SIS SERVICIOS INTELIGENTES S.C.
"443", // GARZA DE YTA CONSULTORES S.C.
"444", // MIGUEL ANGEL PEREZ JIMENEZ
"445", // JUAN LIBORIO ESPINOSA PEREZ
"447", // TORRES MIRELES ASESORES EN SEGUROS S.A. DE C.V.
"448", // CASTILLO Y ASOC. PREVENCION DE RIESGO SC
"452", // JUAN ISIDRO NAVARRETE TREJO
"454", // ERNESTO CANO IBARRA
"463", // MVA ADMINISTRACION PATRIMONIAL SA DE CV
"466", // JORGE EDUARDO JIMENEZ ZEPEDA
"471", // RAMON JAVIER HERMAN MARTINEZ
"476", // V.R. RISK SOLUTIONS S.C.
"478", // ALEJANDRO MORA MADRAZO
"480", // MULTISERVICIOS PROFESIONALES DE ESPECIALIDADES SC
"481", // H&L RISK ANALYSIS S.A. DE C.V.
"484", // ASESORES EN SEGUROS RED UNITAS S.A. DE C.V.
"486", // VICTOR ABIEL TAPIA MEDINA
"488", // RAMON JAVIER HERMAN MARTINEZ
"489", // GRUPO ABS AGENTE DE SEGUROS Y FIANZAS SA. DE C.V.
"493", // JOSE GERARDO HERNANDEZ PEREZ
"497", // GSI ENLACE PATRIMONIAL SA DE CV
"500", // RODRIGO HERNANDEZ GONZALEZ
"503", // GOSEGUROS AGENTE DE SEGUROS S.A. DE C.V.
"504", // PROMO RISK MEXICO S.A. DE C.V.
"506", // ASESORES GENERALES ASOCIADOS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"507", // EDGAR OCTAVIO UCEDA MORENO
"508", // BRUXU AGENTE DE SEGUROS Y FIANZAS SA DE CV.
"509", // GRUPO CIDAR BUSINESS BROKERS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"511", // AS PROFESIONALES EN RIESGOS S.A. DE C.V.
"512", // JUAN CARLOS SILVA CHAGOYA
"514", // PUBLICIDAD HUMANA S.A. DE C.V.
"517", // BENEFICIOS A LOS TRABAJADORES MEXICANOS AGENTE DE SGUROS Y DE FIANZAS SA CV
"519", // JORGE ALEJANDRO AGUILA ESQUIVEL
"521", // PROTECCION TECNICA MEXICO AGENTE DE SEGUROS Y DE FIANZAS SA
"522", // ALBERTO EDMUNDO MANZOTTI MAGANA
"524", // EIKOS AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"527", // SERGIO BUCIO MENDOZA
"528", // FERNANDO ANTONIO DE JESUS WILHELM FERRIZ
"530", // CORPORATIVO SLIMPLAN AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"532", // TRIGARANTE ONLINE AGENTE DE SEGUROS SA DE CV
"534", // ESTRATEGIA EN PROTECCION AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"535", // AFIRMA AGENTE DE SEGUROS SA DE CV
"536", // BITUAJ AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"537", // AARON JUAN LIVERANT GOLDBERG
"541", // JOSE GERARDO HERNANDEZ PEREZ
"542", // J. JESUS LOPEZ SEGURA
"545", // CGY LICITACIONES DIRECTAS
"546", // INSTITUTO POLITECNICO NACIONAL
"547", // EXPORTADORA DE SAL SA DE CV
"548", // GOBIERNO DEL ESTADO DE SINALOA
"549", // LICITACIONES APSELP ESPECIAL
"551", // COLEGIO DE ESTUDIOS CIENTIFICOS Y TECNOL DEL EDO DE MEX
"553", // MARTHA ALICIA PALOMARES *
"554", // JOSE MANUEL ALONSO AVILA
"567", // TAXIS COTIZACIONES JRCASTILLO
"569", // INTERCAM AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"570", // JOSE DE JESUS ORTEGA ESCAMILLA
"571", // BAGUES Y BAGUES SUCESORES SA DE CV
"574", // PORFIRIO MANUEL BUENO MELENDEZ
"575", // GMACZ  AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"577", // MUCHAS GRACIAS AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"579", // APSELP  AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"581", // ADMINISTRACION DE SERVICIOS DE ALOJAMIENTO SA DE CV
"582", // CLAUDIA LILIANA MOLINA DOMINGUEZ
"583", // GRUPO CIE
"584", // JULIO OCEGUEDA JACOBO
"585", // COMISION FEDERAL DE ELECTRICIDAD
"586", // MUNICIPIO DE SLP
"588", // GRACIELA URIAS CABALLERO
"589", // SEGURIDAD PLANEADA AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"590", // JORGE EDUARDO JIMENEZ ZEPEDA
"592", // ROGELIO ALONSO QUIROZ CONTRERAS
"593", // JESUS GALLEGOS MONTOYA
"594", // ONLIFE AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"595", // PVN LICITACIONES I
"596", // MUNICIPIO HUIXQUILUCAN
"598", // JAAE LICITACIONES DIRECTAS
"599", // GOBIERNO DEL ESTADO DE SAN LUIS POTOSI
"610", // GRUPO ASESOR EN NEGOCIOS SOSTENIBLES S.C.
"615", // MEGADIVERSOS SECURUS SA DE CV
"617", // LUIS ALFONSO MONDRAGON AGUIRRE
"618", // ALFREDO JOEL ROCHA GONZALEZ
"619", // GOSEGUROS LICITACIONES
"620", // MIGUEL ANGEL BALDERRAMA RODRIGUEZ
"621", // VIDA EMPLEADOS
"624", // ADRIANA BARAJAS ROJAS
"625", // DANIEL EMILIO PELAEZ GARCIA
"628", // ADMINISTRADORA DE RIESGOS Y PLANEACION PATRIMONIAL S.C.
"629", // EFRAIN HERNANDEZ MEDINA
"630", // GRUPO GATT REDUCCION DE RIESGOS S.C.
"631", // ALBERTO ANDRIANO ESTRADA
"632", // GG SERVICIOS DE ASESORIA INTEGRAL EN SEGUROS Y FIANZAS SA DE C.V.
"633", // JUAN SILVA *
"634", // OROZCO ASESORES AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"636", // A.F. PENSAR
"637", // RG MEDIATOR & BROKER S.C.
"638", // PROTSEGURA S.C.
"639", // A.F. PENSAR
"640", // GASTOS MEDICOS DXN
"641", // ARIMECHU S.C.
"642", // ASEGURATE BIEN S.C.
"643", // FRANCISCO ANDRES JIMENEZ MEZA
"644", // JOSE MIGUEL ZAVALA CAMARGO
"645", // VEST AGENTE DE SEGUROS SA DE CV
"646", // CONDESEG CONSULTING AND LOGISTICAL SERVICES S. DE RL DE CV
"647", // OPTIMA ADMINISTRACION DE RIESGOS S.C.
"648", // ISIIX INTELIGENCIA EN SEGUROS INSTITUCIONALES E INDIVIDUALES AGENTE DE SEGUROS
"649", // TRASCENDER VIVIR PARA SERVIR S.C
"653", // SOLUCION ACTIVA ET S.C.
"654", // CLAUDIA LEGARDA HERNANDEZ
"655", // DURAMAZ RIESGOS PROFESIONALES SA DE CV
"656", // GRUPO FID AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"657", // RAFAEL VERAZA PEÐALOZA
"658", // INTERMEDIACION NEXUS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"659", // GRUPO PROMOTORA MASIVA DE SEGUROS AGENTE DE SEGUROS SA DE CV
"660", // CONSUELO AZAMAR PEREZ
"661", // GTORRE CONSULTORES SOCIEDAD CIVIL
"662", // TAHMEK SOLUCIONES S. DE R.L. DE C.V.
"663", // LATINO SOCIOS
"664", // SERGIO MONTOYA CLETO
"665", // PATRIMONIO DE CALIDAD
"666", // FRANCISCO JOEL BALTODANO RODRIGUEZ
"667", // INBAL IBARRA HERNANDEZ
"668", // LIFE TRUTSWORTHY SOLUTIONS S.C.
"669", // INNOVAZIONE AGENTE DE SEGUROS SA DE CV
"670", // SANDRA PAULINA MORALES ALCANTARA
"671", // GUILLERMO PASTRANA MUNGUIA
"672", // MAP  AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"673", // GUSTAVO NORIEGA TAVERA
"674", // GUILLERMO PASTRANA MUNGUIA
"675", // INVERVA AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"676", // MARIO CONRADO HERRERA OROZCO
"677", // FRATERNI VIDAPLAN S.C. 
"678", // JACQUELINE ARMENDARIZ PORTILLO
"679", // MUNICIPIO DE GUANAJUATO
"681", // ENEDELIA DE LEON SANCHEZ
"682", // PROMOTORIA LIDERES Y ASESORES S.A. DE C.V.
"683", // JOS╔ LUIS ANDRADE DUR┴N
"684", // MARIA ELIZABETH MUNGUIA TELLES
"685", // FORMACION INTEGRAL DE ASESORES SC
"686", // SISTEMA PARA EL DESARROLLO INTEGRAL DE LA FAMILIA DE LA CIUDAD DE MEXICO
"687", // ASESOR═A PATRIMONIAL ML SC
"688", // GRUPO PYLC AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"689", // MACOOLEY BROKERS AGENTE DE SEGUROS S.A. DE C.V.
"690", // LICONSA S.A. DE C.V.
"691", // MARIO ALFREDO MENDIOLA MARTINEZ
"692", // GERARDO HERNANDEZ LICITACIONES 
"693", // ERICKA LIZETH LOREDO RODRIGUEZ
"694", // SAFENOW AGENTE DE SEGUROS  S.A. DE C.V.
"695", // JAIME CASTILLO TRINIDAD
"697", // PROMOTORIA JOLGU Y ASOCIADOS S.A. DE C.V.
"698", // ROBERTO VARGAS CISNEROS
"699", // CLEMENTE ALAN TORRES EGUIARTE
"702", // BESSON AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"703", // LUIS CARLOS ALATORRE ALVAREZ MALO
"707", // JORGE APOLONIO GONZALEZ MATA
"708", // ART AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"709", // RR PERFIL SERVICIOS S.C.
"710", // VICTOR MANUEL FLORES GUTIERREZ
"711", // BRENDA ZUÐIGA GUTIERREZ
"713", // INCUMBRA MARKET CLUB S.C.
"714", // CYNTHIA ELENA ORDAZ JURADO
"715", // DI VITA ASESORES S.C.
"716", // HAMSA RISK CONSULTING S.A. DE C.V.
"717", // FERNANDO NOVELO STUBBE
"718", // JUAN CARLOS GARCIA BONILLA
"719", // SEGURISK AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"720", // BTG CONSULTORES DE RIESGO S.C.
"721", // GERARDO EMANUEL REVELES CHAVEZ
"722", // ROCCO AMAURI CORDOVA GONZALEZ
"724", // RENE FABIAN CAPIN COTA
"725", // ALBERTO SACAL MOTOLA
"726", // OSCAR GONZALEZ LEGORRETA
"727", // CARLOS VALDES MARTIN
"728", // ALIANZA PROFESIONAL GLEAVES & RUIZ S.C.
"729", // ALVARO AMBROSI CORTES
"730", // JOSE MANUEL HUERTA MARTINEZ
"731", // ANDRES PORTILLA CESPEDES
"732", // CESAR EDUARDO HERNANDEZ BARRAGAN
"733", // ENRIQUE JESUS TALAVERA RUIZ
"734", // FLORENTINO HERNANDEZ VAZQUEZ
"735", // ANTONIO NUÐEZ CORREA
"736", // ANTONIO ANAYA GARCIA
"737", // GUILLERMO GARCIA ROJAS
"738", // GRUPO JAVELLY S.A. DE C.V. 
"739", // ALEJANDRO SANCHEZ DEL CASTILLO
"740", // UNIVERSIDAD NACIONAL AUTËNOMA DE M╔XICO
"741", // PROMOTORES ARI S.A. DE C.V.
"742", // POLIC═A INDUSTRIAL BANCARIA DEL ESTADO DE HIDALGO
"743", // MANUEL BASUALDO LOPEZ
"744", // LUIS ROBERTO BELTRAN RIVERA
"745", // ALVARO RAMIRO CAMPOS GOROCICA
"746", // ASESORES VISE S.A. DE C.V.
"747", // MUNICIPIO DE CHALCO
"748", // MARIO ALBERTO GONZALEZ OCHOA
"749", // ESTEBAN LEON LARA
"750", // MANUEL RODRIGUEZ CARRASCO
"751", // PI & PI AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V. 
"752", // IAN MAURICIO GUAJARDO RODRIGUEZ
"753", // VICTOR MANUEL GARCIA TREJO
"754", // MANUEL RAFAEL GONZALEZ CASTILLA
"755", // RODOLFO REYES GOMEZ
"756", // CERTUS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"757", // CENTRO DE INVESTIGACIONES Y ESTUDIOS SUPERIORES EN ANTROPOLOG═A SOCIAL
"758", // GRUPO CORISE AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"759", // KALIDA CONSULTOR EN RIESGOS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"760", // FRANCISCO RUIZ QUINTERO
"761", // JIRO Y ASOCIADOS AGENTE DE SEGUROS Y FIANZAS S.A. DE C.V.
"762", // JOSE LUIS RAUL NAVARRETE SANCHEZ
"763", // OTONIEL FLORES MORENO
"764", // KABELAE S.C. 
"765", // BLANCA ISELA VASQUEZ BRACAMONTES
"766", // BENJAMIN FRANCISCO VALENZUELA VILLALOBOS
"767", // BIA A.P. AGENTE DE SEGUROS Y DE FIANZAS
"768", // JONATAN ALAN PEÐA SERVIN
"769", // LUIS DARIO CASTAÐEDA CRUZ
"770", // HECTOR ANTONIO GAMEROS ENRIQUEZ
"771", // PARA DESPACHO .
"772", // GRUPO MANZANO MONROY SAS DE CV
"773", // OCG AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"774", // AGENCIA PATRIMONIAL ESPECIALIZADA PEÐA ELIAS S.C.
"775", // ONE COACH COBERTURAS INTERNACIONALES AGENTE DE SEGUROS S.A. DE C.V.
"777", // DIEGO ZAVREL MANCERA
"778", // COMPARA EN CASA AGENTE DE SEGUROS S.A. DE C.V.
"779", // GRUPO KIIMS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"780", // SICUREZZA AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"781", // CARLOS EDUARDO TOBIAS PINTO
"782", // IMPULSA DE MEXICO AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"783", // CLAUDIA ROSA MARIA MUÐOZ RUIZ
"784", // OSCAR FEREGRINO SANCHEZ PLIEGO
"785", // METRO I
"786", // METRO II
"787", // METRO V
"788", // METRO VI
"789", // METRO VII
"790", // LEON
"791", // CHIHUAHUA
"792", // PLUSVALIA AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"793", // JORGE ARMANDO AVALOS MOJARRO
"794", // FUTUREA ASESORES SC
"795", // VICTOR MANUEL HUERTA TORRUCO
"797", // JUAN PABLO GRANADOS HERNANDEZ
"798", // GUILLERMO PASTRANA MUNGUIA
"799", // ROCA PROMOTORES SOCIEDAD CIVIL PARTICULAR
"801", // GARCIA VINATIER Y ASOCIADOS SAS
"802", // ARIES ASESORES EN SEGUROS SC
"803", // YARA LIBIA OCHOA MORENO
"804", // NANCY YADIRA HERNANDEZ CAZARES
"805", // CARLOS ALBERTO ALVAREZ GONZALEZ
"806", // R&C BLINDAJE PATRIMONIAL
"807", // EMBAJADORES FINANCIEROS SC
"808", // JUAN CARLOS LLAMAS REYNOSO
"809", // BCCL CORPORATIVO EMPRESARIAL AGENTE DE SEGUROS SA DE CV
"810", // SICUREZZA AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"811", // DIANA FRANCO RODEA
"812", // ASF PRISMA MEXICO AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"813", // ENTRENAMIENTO EMPRESARIAL EFECTIVO S.C
"814", // ENTRENAMIENTO EMPRESARIAL EFECTIVO S.C
"815", // ALEJANDRO CHAVEZ ESPINOLA
"816", // CERTUS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"817", // KAIKER ASESORES S DE RL DE CV
"818", // DINGLER PROMOTORES SC
"819", // HECTOR MARTINEZ AGUILAR
"820", // FERNANDEZ CONSULTORES GRUPO DESARROLLADOR SC
"821", // LAURA VILLANUEVA LUNA
"822", // GRUPO METROPOLI AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"823", // PROMOTORES PALOMARES S.A. DE C.V.
"824", // JOSE ALFREDO LOPEZ MEZA
"825", // SOLO LO MEJOR, AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"1847", // JOAQUIN RAUL ANCONA FERNANDEZ
"4210", // JOSE DE JESUS ANTONI DE LA TORRE JIMENEZ
"4383", // JORGE ALBERTO GUERRERO VELAZQUEZ
"4512", // JOSE MANUEL SERRANO .
"5302", // RICARDO LUNA SANCHEZ
"5340", // JIRO Y ASOCIADOS AGENTES DE SEGUROS Y FIANZAS S A DE C V
"5435", // ROBERTO MARTINEZ VASQUEZ
"5446", // ANA REBECA HERNANDEZ SNYDER
"5455", // AARON JUAN LIVERANT GOLDBERG
"5461", // MARIO ROGELIO HERRERA REYES
"5480", // CRG  AGENTE DE SEGUROS Y DE FZAS SA DE CV
"5571", // ANGEL PSIHAS LOPEZ
"5671", // LINO FLORES CABELLO
"5690", // BEATE INGRID DOLGOW RUOFF
"5696", // MARGARITA HURTADO GONZALEZ
"5707", // MA. ELENA LEMUS PAYEN
"5711", // MARIA DE JESUS L CHAVARIN CORONA
"5714", // CRISANTA OCAMPO MOCTEZUMA
"5724", // MARIA DEL CARMEN SANCHEZ DOMINGUEZ
"5750", // MA DEL SOCORRO LAHUD MARTINEZ
"5751", // J.  JESUS HERNANDEZ HERNANDEZ
"5752", // JOSE MIGUEL MARMOLEJO PUENTE
"5776", // ALFREDO JAVKIN MARTIN DEL CAMPO
"5782", // JOSE ANTONIO JIMENEZ ESQUIVEL
"5798", // BERNARDINO VAZQUEZ SUAREZ
"5856", // JOSE ALFONSO ORTEGA NAVA
"5858", // MIGUEL ANDRES ALBRAND DEMICHELIS
"5900", // JOSE DE JESUS JORGE SANCHEZ ACOSTA
"5914", // JAVIER LAHUD MARTINEZ
"5926", // MAURO IGNACIO BARRAGAN GARZON
"5934", // ROSA ELVIRA SAMPSON ANGUIANO
"5936", // JOSE LUIS RAMIREZ AGUILAR
"5950", // ARTURO SERGIO DE LA PENA MARCHAND
"5973", // RAYA ROBINSON KRANC
"5978", // MA DE LOURDES TAPIA GUARDADO
"5997", // ENRIQUE HALFON BARRIENTOS
"6022", // RAUL OCHOA BOLIVAR
"6026", // MARIA ERNESTINA GONZALEZ MADERO
"6067", // JORGE RAUL FELIX VILLA
"6074", // JOSE ANTONIO ZURUTUZA AGUILA
"6082", // ALMA MIREYA CATALAN DOMINGUEZ
"6097", // JOSE LUIS GUADIANA GARZA
"6169", // ALBERTO EDMUNDO MANZOTTI MAGANA
"6175", // JOSE RAMON CHAPA LOPEZ
"6177", // ALBERTO CACHON REGUILLO
"6191", // CARPIO & BAQUEIRO AGENTE DE SEGUROS SA DE CV
"6205", // ERIKA DIANA HERNANDEZ MOSQUEDA
"6217", // CLAUDIO CALVA JOHNSTONE
"6222", // RAFAEL ALFONSO DE ALBA MARTINEZ
"6229", // JOSE ESCOTO HERNANDEZ
"6257", // HECTOR JAVIER ALMEIDA OROZCO
"6264", // RICARDO NORENA VILLARIAS
"6269", // GILBERTO MEDRANO TORRES
"6271", // BLANCA PATRICIA VAZQUEZ BRAVO
"6291", // MALAQUIAS SALVADOR SALAMANCA GARCIA
"6300", // JOSE ISIDORO LEVY BEHAR
"6303", // MARIO ALAMILLA FRANCO
"6305", // EDUARDO NUNEZ-MORA MASEDA
"6320", // MA DEL CARMEN SANCHEZ DE LA VEGA SIERRA
"6323", // ABRAHAM ALBERTO LEVY MANZUR
"6324", // ADOLFO MARTINEZ RODRIGUEZ
"6325", // MARIO ARTURO GARCIA HERNANDEZ
"6331", // RICARDO MIGUEL ALMOREJO FRANCO
"6333", // MA BIBIANA DE LA PENA PEREZ DE LA VEGA
"6335", // ARTURO KIBRIT STERN
"6336", // ROCIO DIAZ CASTANEDA
"6337", // EVA MARCUSCHAMER MILLER
"6358", // NISSIM MANSUR Y TAWIL
"6362", // MARON MANZUR ASSAD
"6423", // GUADALUPE MA DEL C OLGUIN RIVERA
"6432", // SONIA MA. GUADALUPE IBARRA OTERO
"6434", // CARLOS BLANCAS ALVAREZ
"6436", // JOSE VICTOR SAUL RAMIREZ PEREZ
"6470", // MARIA ELIZABETH BRAVO ALONSO
"6472", // EFREN GERMAN FLORES Y ROMERO
"6473", // PABLO RIVERO-BORRELL SOLORZANO
"6478", // ALEJANDRO FLORES SANCHEZ
"6479", // BERTHA ANGELICA VELAZQUEZ CENTENO
"6488", // OSCAR MANUEL PINZON VELARDE
"6489", // MANUEL CLEMENTE PINZON AVILA
"6501", // BLANCA MARGARITA SPEZIA DIAZ
"6514", // GREGORIA MARTINEZ ALCANTARA
"6521", // JIRO Y ASOCIADOS AGENTE DE SEGUROS Y FIANZAS SA DE CV
"6527", // JULIAN ALFREDO ALEJO CRUZ
"6528", // HECTOR HUGO LAHUD MARTINEZ
"6536", // FRANCISCO JAVIER RUIZ MORALES
"6537", // JOSE NIEVES CRUZ
"6543", // ROBERTO MAURICIO SANTOYO LEON
"6568", // WILLIAM SANDOVAL TORRES
"6569", // ALFONSO MASCARUA URRUTIA
"6575", // ARTURO REYNOSO CARDENAS
"6576", // ALFREDO MENA CEBALLOS
"6581", // CIRINO ZUNIGA BADILLO
"6583", // EDUARDO LOPEZ RAMIREZ
"6587", // GLORIA ALVARADO FRANCO
"6588", // GRACIELA GONZALEZ DUARTE
"6591", // EFREN GARCIA LOPEZ
"6592", // JOSE DE JESUS MIRANDA RAMIREZ
"6597", // JUAN PABLO PIÐA VILLARREAL
"6598", // JOSE ANTONIO LEZAMA OROZCO
"6599", // MIGUEL ANGEL MILIAR ZEPEDA
"6605", // VICTOR MANUEL PALACIOS ORTEGA
"6606", // EIKOS AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"6607", // CARLOS RAMIREZ PEREZ
"6608", // ROSA MARIA BALDERAS MOSQUEDA
"6609", // GRUPO CASTILLO AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"6611", // ENRIQUE ANGEL MIGUEL SANCHEZ CONEJO
"6612", // MARGARITA HERRERA MELENDEZ
"6614", // MARIA EUGENIA SANCHEZ ARANDA
"6615", // MARIA FRANCISCA GARCIA CONTRERAS
"6616", // JOSE ALBERTO HERNANDEZ SAMANO
"6628", // LUIS MANUEL SALAZAR VAZQUEZ
"6633", // ADA CARMEN ESTRELLA REYES
"6643", // PABLO CAMACHO GARCIA
"6645", // BENJAMIN LEVI TAJFELD
"6648", // ANGEL ARROYO ROSALES
"6651", // EMMA RIVERA CASTREJON
"6657", // ALEJANDRO MURRIETA BRIONES
"6659", // ERNESTO CEBALLOS MORALES
"6661", // MIGUEL ANGEL MALDONADO MURILLO
"6668", // RITA LETICIA MARTINEZ LOPEZ
"6673", // SALTIEL ARTURO CARRANCO BLANCA
"6680", // ATLANTIC AGENTE DE SEGUROS Y FIANZAS SA DE CV
"6688", // LUIS OJEDA SILVA
"6693", // PAULO NIÐO PEREZ
"6698", // MERIT AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"6702", // PATRICIA FERNANDA CONEJO MORENO
"6708", // JOSE RAMON GARCIA PEREDA
"6709", // DANIEL JAVKIN SUNG
"6712", // RENE CEJUDO MIYAZAWA
"6721", // JOSE LUIS HEREDIA VAZQUEZ SANTAELLA
"6725", // JUAN BERNARDO GAAL RODRIGUEZ
"6740", // PATRICIA RIVERA CASTREJON
"6742", // JOSE LUIS JACINTO MORALES
"6751", // MARIO LUIS GARCIA MORFIN
"6753", // JESUS MANZANO SOSA
"6777", // REYNA LOPEZ VAZQUEZ
"6778", // DINORA GUADALUPE ALCOCER SARDANETA
"6779", // JOSE ALFREDO LOPEZ LOPEZ
"6780", // LUIS HUMBERTO VAZQUEZ MONTERROSAS
"6797", // JUANA SILVIA OCHOA CASTILLO
"6832", // VR INTEGRA AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"6837", // HUMBERTO JEREZ JIMENEZ
"6838", // JACOBO MAURICIO RANGEL CONTRERAS
"6855", // MARIO FLORES MARTINEZ
"6856", // ANGEL HERNANDEZ NAVARRO
"6857", // JOSE GERARDO HERNANDEZ PEREZ
"6863", // ANA BEATRIZ SHAFER HERNANDEZ
"6868", // HECTOR ABEL AGUILAR GARCIA
"6890", // NOST AGENTE DE SEGUROS S.A DE C.V
"6907", // LICITACIONES METRO I
"6912", // ROSA MARIA NAJERA SANTAMARIA
"6916", // ARTURO URIOSTEGUI PALACIOS
"6917", // SALVADOR ALVAREZ RUIZ
"6929", // GRUTA AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"6931", // MA. GPE. BERENICE GONZALEZ LARA
"6932", // JUVENAL GARNICA RAMOS
"6940", // MARIO FERNANDEZ RAMIREZ
"6944", // RISKMANAGEMENT AGTE. DE SEGUROS Y DE FIANZAS SA DE CV
"6947", // MIGUEL ANGEL SOUZA ROBLES
"6959", // ADDY ROSA DE FATIMA GONZALEZ PEREZ
"6962", // ERNESTINA VELA OTERO
"6963", // JOSE LUIS GONZALEZ ALONSO
"6976", // ALBERTO FRANCISCO AL LE LORIER FAUTSCH
"6982", // MA. DE LOS ANGELES RAYO BUSTOS
"6990", // RAYMUNDO OSORIO CRUZ
"6992", // MANUEL SANCHEZ MONTALVO
"6993", // FERNANDO OLVERA PICHARDO
"6994", // ROLANDO ALATORRE CARDENAS
"6995", // SERGIO BUCIO MENDOZA
"7010", // J. JESUS LOPEZ SEGURA
"7014", // EUGENIO PRADO LUCERO
"7015", // FLAVIO MENDOZA MARTINEZ
"7017", // JUAN LIBORIO ESPINOSA PEREZ
"7021", // MINERVA RENATA CASTELAN PULIDO
"7022", // MARIA DEL CARMEN ALCAZAR BARRANCO
"7023", // GLORIA ANTONIO CEQUERA
"7034", // LUIS MARIO CERQUEDA BECERRA
"7040", // YOLANDA ANGELES SANCHEZ
"7042", // MARIO GARCIA URENDA
"7049", // MARIA DE LOURDES GAONA MALVAEZ
"7061", // YOLANDA FUENTES HERNANDEZ
"7067", // SERGIO ALBERTO CRUZ ZUNIGA
"7070", // TEODORO CORNEJO QUIRINO
"7073", // PABLO GARCIA ROJAS
"7088", // JOHANATHAN JOSUE DIAZ MONDRAGON
"7090", // SILVIA HERNANDEZ POSADAS
"7096", // GUSTAVO ENRIQUE RODRIGUEZ HUERTA
"7097", // RAFAEL SANTOS GIL ARELLANO
"7104", // JOSE REFUGIO ORTIZ FLORES
"7105", // VICTOR GARDUNO YEPEZ
"7106", // GILBERTO DOMINGUEZ MARTINEZ
"7110", // ISRAEL PASTORA SALAZAR
"7122", // RAFAEL LINO BARRON MORALES
"7139", // JUAN JESUS HERNANDEZ LUNA
"7142", // VIRGINIA CHAVEZ GARCIA
"7143", // CAROLINA QUIJAS TREJO
"7149", // MONICA CANARIOS MENDOZA
"7152", // RICARDO MARTINEZ GONZALEZ
"7157", // ANGEL MIGUEL ROMANO TOVO
"7158", // RAYMUNDO TITO MARTINEZ ORTEGA
"7162", // EDGAR ALONSO CARRASCO GOMEZ
"7163", // ROCIO VALLEJO MORA
"7167", // MARTHA BEATRIZ QUERO AGUILAR
"7169", // ARMANDO FERMIN CAMPOS SANCHEZ
"7175", // MARIA DEL CARMEN LUA REYES
"7177", // LUIS ALFONSO ARVIZU MARIN
"7186", // APSELP  AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"7191", // HUMBERTO OROPEZA SANCHEZ
"7195", // TERESITA DEL NINO JE MEDINA HERNANDEZ
"7200", // RAUL VAZQUEZ RAMIREZ
"7203", // MANUEL RIVAS TAMAYO
"7207", // FRANCISCO JAVIER PAZ NAVARRETE
"7208", // SILVIA LETICIA SERNA CUELLAR
"7210", // ALBERTO TELLEZ SALAZAR
"7212", // NORMA MARISELA CARRASCO GOMEZ
"7214", // JOSE DE JESUS VELARDE FIGUEROA
"7219", // HERNAN JOSE VIANA MENDEZ
"7220", // JOSE LEOPOLDO ORNELAS MORENO
"7235", // MANUEL CISNEROS PEREZ
"7241", // RAUL VELEZ ACENA
"7247", // JOSE LUIS ANZALDO GONZALEZ
"7249", // DAVID CERVERA AMEZCUA
"7258", // EDUARDO CONSTANTINO NAVARRO LOPEZ
"7266", // JOSE LUIS MORA GAYTAN
"7273", // JUAN MANUEL LIMON ALVARADO
"7276", // SOFIA DEL ROSARIO RAMON HERNANDEZ
"7277", // FERNANDO FILIBERTO GARCIA MIRANDA
"7282", // GUILLERMINA SAAVEDRA ALVAREZ
"7283", // RAYMUNDO MANUEL ROSAS CHAVEZ
"7285", // SOTERO MARTINEZ DELGADO
"7287", // FERNANDO ANTONIO J WILHELM FERRIZ
"7298", // LUIS DARIO CASTAÐEDA CRUZ
"7301", // JOSE ANTONIO GAMIZ GOMEZ
"7308", // MARIA ELENA IBANEZ BONILLA
"7311", // ALBERTO RAMOS CELORIO
"7312", // BLANCA ESTELA MIRELES SERRATOS
"7314", // MARIA LUISA MARTINEZ HERNANDEZ
"7315", // JIRO Y ASOCIADOS AGENTE DE SEGUROS Y FIANZAS S.A DE C.V
"7318", // ALFREDO MENA CEBALLOS
"7320", // HECTOR MANUEL JIMENEZ AGUIRRE
"7324", // MARTIN ALEJO RODRIGUEZ DOMINGUEZ
"7325", // LUIS JUSTINO VARGAS PENA
"7328", // MARIA ELBA GARCIA GARCIA
"7329", // JOSE MANUEL FALFAN TORIZ
"7330", // JUAN SILVA .
"7331", // JOSE GULBERTO AVALOS CRUZ
"7333", // ALBERTO SACAL MOTOLA
"7334", // ERNESTO CANO IBARRA
"7336", // ALEJANDRO PALENCIA LOPEZ
"7340", // ROSA GEORGINA GONZALEZ MIRANDA
"7342", // JORGE EDUARDO JIMENEZ ZEPEDA
"7346", // CARLOS MACIAS ORTIZ
"7348", // MARIA MARTHA PATRICI MORON CHAVARRIA
"7349", // ALFREDO JAVKIN MARTIN DEL CAMPO
"7357", // MARIO ALBERTO CRUZ MORENO
"7358", // ADRIAN HERNANDEZ NUNEZ
"7359", // BRUXU AGENTE DE SEGUROS Y FIANZAS SA DE CV.
"7361", // JORGE JOSE LUIS CALDERON MARTINEZ
"7362", // JOSEFINA CRAULES ORTEGA
"7364", // ARTURO URRUTIA HERNANDEZ
"7365", // JUAN MANUEL RAMOS GARNICA
"7369", // GABRIEL ESTEBAN BOU PEREZ
"7372", // CESAR FLORES SANCHEZ
"7373", // IGNACIO CARDONA PEREZ
"7377", // JAVIER ESPINOSA HERRERA
"7381", // JUAN CARLOS SANDOVAL PARRA
"7387", // MANUEL AGUSTIN ESQUINO ACEVEDO
"7388", // VICTOR EDUARDO HERRERA OVIEDO
"7391", // MA. REYNA LILIA RAMIREZ HERNANDEZ
"7392", // MARIA DE LA PAZ MURILLO ESCOBEDO
"7401", // BERTA ALICIA GUILLEN ROJAS
"7412", // RODOLFO HUERTA DURAN
"7415", // ROSAURA MATAMOROS FRANCO
"7421", // OSCAR RENE SANDOVAL MOLINA
"7422", // AGUSTIN RIEGO GAONA
"7425", // JUAN MANUEL CANDANEDO GONZALEZ
"7426", // RAMIRO PEREZ PRIEGO
"7428", // JOSE DE JESUS MARES ACOSTA
"7436", // EULOGIO ALDAMA ESCALERA
"7439", // MARIA LORENA CASTELL DE ORO DEL CASTILLO
"7442", // JOSE JUAN FABELA LOPEZ
"7444", // VICTOR RODOLFO MARTINEZ QUIROZ
"7445", // SANDRA YVONNE GALICIA SANCHEZ
"7455", // SOBERON AGENTE DE SEGUROS Y DE FIANZAS SA
"7456", // RICARDO LOPEZ SALAZAR
"7464", // BELEN LOPEZ GONZALEZ
"7466", // MIGUEL ANGEL PEREZ JIMENEZ
"7467", // EFRAIN JESUS HERNANDEZ TREJO
"7469", // RAFAEL MURILLO SILVA
"7470", // JUSTO AVILA ORTIZ
"7471", // CYNTHIA GARZA DE YTA
"7472", // MERCEDES PATRICIA ARCOS AGUIRRE
"7473", // RUBEN ANDA HERNANDEZ
"7475", // ANA MARTHA PALACIOS BURGUETE
"7478", // GERARDO MARTIN MIGUEL LOPEZ
"7480", // DANIEL ANTONIO NUNEZ RUBIO
"7481", // LUIS ENRIQUE MENDOZA BERLANGA
"7484", // MANUEL ANTONIO VILLEGAS JASSO
"7485", // MARIA LIDIA ALMEIDA RUELAS
"7487", // DANIEL ACOSTA MORALES
"7488", // JUAN LIBORIO ESPINOSA PEREZ
"7494", // AIDA MARIA MAGDALENA HERNANDEZ TELLO
"7499", // JOSE ANTONIO TRUJILLO BELIO
"7502", // DAVID SACAL MOTOLA
"7503", // REFUGIO ARMANDO TAMAYO REYES
"7505", // JUAN ISIDRO NAVARRETE TREJO
"7508", // ANA DE LA MORA SANCHEZ
"7509", // ROSAURA TRINIDAD  RAMIREZ OBREGON
"7510", // JUAN GREGORIO SANDOVAL BARBOSA
"7511", // HERMAN BARBERENA OLIVARES
"7516", // LUIS CARMONA GOMEZ
"7521", // MARTHA ALICIA PARAMO MUGUIRO
"7529", // JESSICA OSORIO TORRES
"7531", // EMIGDIO GALINDO GUERRERO
"7542", // ARTURO ANUAR MANZUR VELAZQUEZ
"7543", // RODOLFO TAMEZ AVILA
"7546", // DAVID SANCHEZ RICO
"7549", // ERNESTO ARMANDO VELAZQUEZ RANGEL
"7550", // VICTOR MANUEL VILLEGAS RIEGO
"7559", // ROBERTO ORLANDO GUERRA SERVIN
"7561", // ROBERTO BARRAN MUÐOZ
"7564", // ANA MARIA BELTRAN VIERA
"7566", // MODESTO GARCIA GONZALEZ
"7567", // MIGUEL CIRILO RAFAEL
"7572", // THELMA VELASCO GUTIERREZ
"7573", // JULIO OCEGUEDA JACOBO
"7574", // ALFONSO VAZQUEZ LOPEZ
"7575", // MARIA TERESA V. GONZALEZ PATIÐO
"7582", // MANUEL SANCHEZ MONTALVO
"7584", // JUAN JOSE LOPEZ GUILLEN
"7585", // MA ROSALIA HERNANDEZ CORONADO
"7590", // IRMA MERGOLD ZERMEÐO
"7592", // ARACELI AGUILERA *
"7602", // FERNANDO ANTONIO J WILHELM FERRIZ
"7605", // EDUARDO AYALA OSCOY
"7606", // JULIO EDUARDO CAMACHO ZARZOSA
"7607", // FRANCISCO ISIDORO LOA GARZA
"7609", // FRANCISCO JAVIER AGUILA JIMENEZ
"7610", // ALFREDO MENA CEBALLOS
"7611", // MARTHA HUERTA RIVERA
"7615", // JUAN REYES NICOLAS
"7621", // ANDREA CORONA ESPINOSA
"7625", // JOSE GILBERTO VELAZQUEZ HERNANDEZ
"7627", // ELIDA CRUZ HUERTA
"7628", // OCTAVIO RODRIGUEZ ORTIZ
"7629", // AGUSTIN FELIX OLVERA
"7636", // RICARDO RAMIREZ VENEGAS
"7637", // SILVIA MARISOL HAMUD TORRES
"7639", // JOSE AGAPITO GONZALEZ VIDAL
"7640", // MA. C. PATRICIA RODRIGUEZ HERNANDEZ
"7642", // MARIA SILVIA CARDENAS BECERRA
"7644", // MVA JISER CONSULTORES AGENTE DE SEGUROS Y FIANZAS
"7649", // RAUL MUÐOZ AGUIRRE
"7654", // ADOLFO MANDUJANO LUNA
"7656", // JOEL CRUZ DEL ANGEL
"7660", // APSELP  AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"7661", // MARIA CONSUELO MEDINA TOVAR
"7663", // MARIA REYNA PATRICIA PAVON MARTINEZ
"7667", // GERARDO TAMES VAZQUEZ
"7669", // JUSTO AVILA ORTIZ
"7673", // LIZBETH NAJERA MENDOZA
"7675", // ANA LUISA BERAZA SANCHEZ
"7676", // ALMA IVONNE ARRIOLA MARTINEZ
"7678", // RENE RIVAS BURGOS
"7681", // MARIA ROXANA VAZQUEZ VERDIGUEL
"7682", // MAURICIO RAMIREZ ESTEBAN
"7683", // FRANCISCO RODRIGUEZ TOVAR
"7684", // MARIA LUISA MORGADO REYES
"7686", // MA. CONCEPCION MARTIN DEL CAMPO DE ALBA
"7687", // ANGEL PSIHAS LOPEZ
"7691", // ENRIQUE CORONA GUERRA
"7692", // MRE ASESORES AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"7695", // HUGO FRANCISCO ARANGO MIRANDA
"7700", // LUIS EMILIANO DELGADO FLORES
"7703", // ASESORIA INTEGRAL EN SEGUROS AGENTE DE SEGUROS S.A.
"7704", // FERNANDO HILARIO MARTINEZ MARQUEZ
"7706", // JESUS DE LA CRUZ GUZMAN
"7710", // ALFREDO MENA CEBALLOS
"7712", // MARTHA ALICIA MOTTA LIZARRAGA
"7713", // MARIA DE LOURDES GARCIA GALLO
"7715", // JORGE RODRIGO CHAO RUIZ GAYTAN
"7717", // EDUARDO SERGIO AYALA AGUIRRE
"7718", // HERNAN ARTURO QUIJANO MARTINEZ
"7725", // CYNTHIA GARZA DE YTA
"7730", // LUIS VIDAL SANCHEZ DE LA O
"7731", // CESAR ERNESTO SANDOVAL RODAS
"7735", // LAURA ALICIA ARROYO SANCHEZ
"7736", // ROBERTO RAMIREZ NEGRETE
"7738", // HECTOR BAYARDO PEREZ ARCE
"7746", // MERCEDES RAMIREZ HURTADO
"7749", // LETICIA CASADO PEREZ
"7750", // PCP AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"7752", // MARGARITA CANTORAL MORALES
"7753", // RAMON JAVIER HERMAN MARTINEZ
"7756", // JOSE ALFREDO CASTRO MONTOYA
"7760", // JOSE RIVERA MENDOZA
"7761", // ANTONIO ALCANTARA SANCHEZ
"7763", // CARLOS HECTOR RUIZ PEREZ
"7764", // MIGUEL ANGEL MONTAÐO RODRIGUEZ
"7768", // ALEJANDRO MORA MADRAZO
"7773", // PATRICIA ESTHER TROCHEZ CAMPOS
"7775", // BENEFICIOS A LOS TRABAJADORES MEXICANOS AGENTE DE SGUROS Y DE FIANZAS SA CV
"7777", // ARTURO ALEJANDRO GALICIA OCHOA
"7778", // VICTOR MANUEL ESCOBEDO ALVAREZ
"7779", // AMADOR BORBOA GUTIERREZ
"7784", // CARLOS PATCHEN SALMERON
"7785", // DAVID ALONSO TREJO GARCIA
"7790", // LUZ MARIA RIVERA MARTINEZ
"7793", // JAIME CHAVEZ LOPEZ
"7794", // JOSE LUIS SORIANO AGUILAR
"7797", // BENJAMIN BOTELLO VAZQUEZ
"7798", // JESUS ZARATE MORALES
"7800", // PAVON Y MORALES AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"7802", // APSELP  AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"7803", // JUAN JOSE SALAS PLASCENCIA
"7806", // INGRID SOSA PENEDO
"7809", // JOSE MANUEL CABRERA GALLEGOS
"7810", // PROTG AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"7811", // ALMA GRISEL ROSAS CONDE
"7812", // ALBERTO FERNANDEZ HAIDAR
"7815", // VICTOR MANUEL LEYVA FRANCO
"7816", // PEDRO ABSALON BAUTISTA ESPONDA
"7819", // GLORIA MARLENE VARGAS LARA
"7820", // KALAN AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"7821", // OLGA ORTIZ VELA
"7822", // CARLOS DONJUAN AGUIRRE
"7824", // OSWALDO ALONSO PEREZ BOYTES
"7825", // RUBEN JOAQUIN LEON FIGUEROA
"7826", // SANDRA ISELA BENAVIDES GOMEZ
"7828", // CORPORATIVO SLIMPLAN AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"7830", // MARIA GUADALUPE LOPEZ MORENO
"7831", // LUZ MARIA CABRERA MONRROY
"7832", // MARIA ALEJANDRA GUARNEROS ESCOBAR
"7833", // JUAN MANUEL GARCIA QUINTANA
"7834", // MARIA GUADALUPE GUZMAN AGUILAR
"7835", // ANTONIO EDUARDO TORRES TAZZER
"7836", // MATILDE MORATA GALLARDO
"7837", // CARLOS ARMANDO GRANDE TIRADO
"7840", // ROBERTO GRANADOS MAYA
"7842", // ADRIAN HERNANDEZ ARJONA
"7845", // MATIAS AMBROSIO VALDEZ ARREDONDO
"7846", // JOSE DANIEL RODRIGUEZ GRAJEDA
"7848", // JESUS AGUSTIN GUTIERREZ GARCIA
"7856", // JENNIFER ORNELAS AVALOS
"7858", // ADOLFO CARRILLO GONZALEZ
"7859", // MARIA LETICIA NAVA MARTINEZ
"7860", // ALBERTO GABRIEL TOCHIMANI TECUAPETLA
"7868", // YAIR JAIME CASTILLO BELTRAN
"7869", // FRANCISCO RENE CARBAJAL PATIÐO
"7870", // BETTY SARUE SAED
"7871", // MARIA EUGENIA GARCIA GONZALEZ
"7878", // IVONNE OLIVARES MONROY
"7880", // PAULA ELSA FRANCO TORRES
"7881", // MARIA DEL CARMEN CONSTANTINO RAMIREZ
"7883", // JOSE EMILIO CUELI LOPEZ
"7884", // LUIS ANTONIO MACIAS CAMACHO
"7885", // LUIS ANTONIO CASTRO DOMINGUEZ
"7888", // ARMANDO RICAVAR CISNEROS
"7889", // GABRIEL SAUCEDO HUMARA
"7890", // HECTOR MANUEL JIMENEZ AGUIRRE
"7891", // MARIA DEL CARMEN GOMEZ SALAS GUZMAN
"7897", // MARIA DEL CARMEN GOMEZ SALAS GUZMAN
"7899", // MARIBEL ZAMORA GALINDO
"7901", // JUAN LENIN RAMON HERNANDEZ
"7911", // MARIA DEL ROSARIO RIOS PASTEN
"7913", // ELSA YAZMIN LOPEZ RIVAS
"7914", // JOSE CARLOS IRABIEN VAZQUEZ
"7915", // JORGE VILLARREAL QUEZADA
"7917", // MOISES MARCOVICH KATZ
"7919", // JOSE CARLOS HERNANDEZ IBARRA
"7920", // ALEJANDRO MORA MADRAZO
"7923", // JAIME FERNANDO FARRUGIA DE ALBA
"7924", // ENRIQUE BAEZ BARRERA
"7925", // RODOLFO ALFONSO SANTANA LOPEZ
"7928", // KARLA DOLORES MARTINEZ MEDINA
"7929", // JOSE LUIS GONZALEZ LEON
"7931", // ROSA NELLY NOTARIO QUEJ
"7934", // JOSE MIGUEL ZAVALA CAMARGO
"7938", // JAIME HERNANDEZ SANCHEZ
"7940", // ISAAC MONTEJANO HERNANDEZ
"7941", // CELSO HUMBERTO TROCHEZ CAMPOS
"7944", // VICTOR ABIEL TAPIA MEDINA
"7945", // SAUL UBALDO TEJEDA BELLO
"7946", // CARLOS LARRAÐAGA AGUILAR
"7954", // ENRIQUE ROJAS LARA
"7957", // MARIA VICTORIA ESPINOSA PALOMINO
"7960", // MARIO ANTONIO IBARRA VILLEGAS
"7962", // JORGE ESPINOSA MENDOZA
"7963", // ESPECIALISTAS EN GRANDES RIESGOS AGENTE DE SEGUROS SA DE CV
"7965", // HILDA NEGRETE BLANCAS
"7967", // SILVIA MARTINEZ SANTILLAN
"7971", // MARIA ELENA LAZCANO MARQUEZ
"7972", // LILIANA LEAL CORNEJO
"7974", // ESTHER LAZARO LOPEZ
"7976", // MANUEL BELTRAN FLORES
"7977", // ELEUTERIO RIVERA MAYA
"7978", // MANUEL PIZANO HARO
"7979", // SERGIO FERMIN MENDEZ CHIO
"7980", // ABRAHAM PATIÐO CASTILLO
"7981", // CRISTINA GUTIERREZ ARROYO
"7983", // BLANCA ISELA CARDONA CABRIALES
"7987", // LUIS GUILLERMO ENRIQUEZ-DE-RIVERA Y-ROJAS
"7988", // MARTIN GERARDO GUERRA OYERVIDES
"7992", // GLORIA ESTELA LIMON ROJO
"7993", // HECTOR MANUEL JIMENEZ AGUIRRE
"7997", // PASTORA OLIVIA TROCHEZ CAMPOS
"7999", // CRISTOBAL JOSE SANCHEZ MUÐIZ
"8003", // IRENE DE LA ROSA MENDOZA
"8004", // JULIAN RUIZ BLANCO
"8005", // MA. ELENA CERVANTES REYES
"8007", // MARIA RUFINA MELENDEZ RAMIREZ
"8008", // FRANCISCO JOSE RAUL RIOS DORANTES
"8012", // JOSE MIGUEL DAVILA LEAL
"8013", // J. JESUS ROMERO FRANCO
"8014", // JUVENTINO ROMAN BRITO
"8020", // JOSE ALFREDO CASTRO MONTOYA
"8021", // MARIA DEL CARMEN SANCHEZ MOLINA
"8023", // AFIRMA AGENTE DE SEGUROS SA DE CV
"8030", // CARLOS VICENTE RAMOS GARCIA
"8031", // JOAQUIN ANGEL MIRANDA DE BLAS
"8032", // OCTAVIO RODRIGUEZ ORTIZ
"8041", // TAG AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"8043", // CESAREO ARMANDO LOZANO RODRIGUEZ
"8045", // FELIPE FRANCO NAVARRETE
"8046", // HUGO ARTURO RANGEL NUÐEZ
"8049", // JUAN RICARDO PEREZ FLORES
"8050", // OCTAVIO RODRIGUEZ ORTIZ
"8051", // FELIPE FRANCO NAVARRETE
"8060", // WILBERT SOLIS JIMENEZ
"8064", // ROSELIA RODRIGUEZ LOPEZ
"8065", // RUBEN ALONSO CANO
"8067", // JUAN RAFAEL GARCIA FUENTES
"8068", // CARLOS DAVID HERNANDEZ RUBIO
"8076", // HECTOR RAMON GARCIA CORRALES
"8079", // MIGUEL ANGEL GARCIA LIMON
"8080", // HECTOR MANUEL JIMENEZ AGUIRRE
"8082", // ALEJANDRO MORA MADRAZO
"8083", // JULIAN CRISTOBAL LONA GONZALEZ
"8084", // JOSE RICARDO PICAZO ISLAS
"8085", // FRANCISCO JAVIER VILCHIS VIVERO
"8088", // RICARDO VIAZCAN MILLA
"8093", // VIRGINIA HERNANDEZ GARCIA
"8094", // OBEB MUÐOZ LOPEZ
"8101", // SIGIFREDO OCHOA *
"8103", // GERARDO ORTIZ SUAREZ
"8104", // JOSE MANUEL LOPEZ LOPEZ
"8106", // ELIZETH RIOS RIVERA
"8107", // JORGE ALFREDO ROJO GARDUÐO
"8108", // MARTHA PATRICIA MEDINA FLORES
"8114", // JOSE FORTINO OSUNA LIZARRAGA
"8119", // FERNANDO MENDOZA GAMEZ
"8121", // JOSE LUIS MORA GAYTAN
"8122", // JOSE LUIS MORA GAYTAN
"8123", // MARIA CRISTINA MONTIEL ORTIZ
"8124", // ANA MARIA AGUILAR SANTOS
"8126", // TRIGARANTE ONLINE AGENTE DE SEGUROS SA DE CV
"8128", // ALEJANDRO HERNANDEZ REYES
"8131", // RAMON JAVIER HERMAN MARTINEZ
"8136", // MARTIN ORTEGA VARGAS
"8138", // TERESA DE LOURDES LUGO LOPEZ
"8142", // HILDA GONZALEZ ORTIZ
"8143", // MARIA DE LA LUZ NAVARRO SALDIVAR
"8149", // PROMOTORA DE MICROSERVICIOS AGENTE DE SEGUROS Y FIANZA S.A. DE C.V.
"8150", // ARTURO MENA GALLARDO
"8151", // CARLOS ORLANDO LEIJA ESCAMILLA
"8153", // PROVYN PROTECCION EN VIDA Y NEGOCIOS SC.
"8154", // JORGE ANTONIO RODRIGUEZ TOVAR
"8157", // SALVADOR GUTIERREZ SOLIS
"8158", // ALEXANDER VALDES GARCIA
"8159", // ALDO ALVAREZ QUIJAS
"8161", // ADRIANA CABRERO JASSO
"8162", // CARLOS MERCADO CANDELARIA
"8164", // ERIKA GUADALUPE ANDRADE ALCIBAR
"8165", // MISAEL ORTIZ OLVERA
"8166", // GOSEGUROS AGENTE DE SEGUROS S.A. DE C.V.
"8167", // HERMELINDA FLORES PATIÐO
"8168", // JOSE LUIS MORA GAYTAN
"8169", // ERIKA REYNOSO RIOS
"8170", // JOSE GERARDO HERNANDEZ PEREZ
"8173", // MARIA DEL ROCIO CERVANTES RIVERA
"8174", // JAVIER RODRIGUEZ RAMOS
"8175", // SEGUDIRECTO AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8176", // OMAR CARMONA MEZA
"8177", // RAMON JAVIER HERMAN MARTINEZ
"8178", // JORGE CABRAL VALDES
"8179", // ALMA CRISTINA PAZ GARCIA
"8180", // DURAMAZ CLAVE DIRECTA
"8181", // JOSE JUAN PIÐA PRIETO
"8182", // CARMEN ROMANO AGUIRRE
"8184", // ENRIQUE HERNANDEZ OSORNO
"8186", // VICENTE RICARDO MONDRAGON CABALLERO
"8188", // RAMON ALBERTO LUCIO MANCERA
"8191", // MARTIN SOLIS LOPEZ
"8193", // RAUL ANTONIO SOLIS BRAVO
"8198", // LUIS ROBERTO MORA MORALES
"8200", // IRL AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8201", // PAULINA FERNANDA MENDOZA AVILA
"8202", // HUGO DOMINGUEZ TOUSSAINT
"8203", // JOSE ALI GONZALEZ RAFAEL
"8206", // JUAN ISAAC VILLARREAL SANDOVAL
"8208", // DAVID MARTINEZ CAMARILLO
"8209", // JESUS ELISEO ESPINOZA MENDEZ
"8210", // TAXIS COTIZACIONES JRCASTILLO
"8211", // JUAN CARLOS SILVA CHAGOYA
"8214", // RAUL VASCO RIOS
"8215", // IGOR GRAJALES HERNANDEZ
"8216", // BERZAIN DOMINGUEZ ROMERO
"8217", // VICTOR HUGO DONIS JARQUIN
"8218", // JUAN CARLOS AGUILAR GOMEZ
"8220", // IRL AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8223", // MA. ESTELA GARCIA ANAYA
"8224", // BITUAJ AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8225", // ORLANDO DURAN PEÐA
"8228", // EDITH CELIS MENDEZ
"8229", // JUAN MANUEL MENDOZA MARTINEZ
"8230", // WILLEBALDO PEREZ BARENAS
"8232", // AMIR CORTES LAGUNA
"8233", // GRUPO CIDAR BUSINESS BROKERS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8235", // ESTRATEGIA EN PROTECCION AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8236", // CARPIO & BAQUEIRO AGENTE DE SEGUROS SA DE CV
"8237", // LAURA ESTELA FIGUEROA FIERRO
"8238", // ESPECIALISTAS EN GRANDES RIESGOS AGENTE DE SEGUROS S.A. DE C.V.
"8241", // JORGE ADALBERTO REYNA ARECHIGA
"8243", // JORGE ALEJANDRO AGUILA ESQUIVEL
"8244", // RAUL ALBERTO MARTINEZ MONROY
"8245", // NOHEMI MANZANO VALDEZ
"8246", // MISAEL CAZARES TURCOTT
"8248", // ERNESTO BAEZ FUENTES
"8249", // NADIA YESICA GUERRA LEON
"8252", // MILED ANTONIO DIEZ DE SOLLANO ASSAD
"8254", // NOHEMI MANZANO VALDEZ
"8255", // LUIS ARTURO LARA GRIMALDO
"8256", // ERICK MICHAEL HERNANDEZ AGUILAR
"8257", // GERARDO DIAZ GARCIA
"8258", // ENRIQUE MELGAREJO GONZALEZ
"8259", // RICARDO MENDOZA OSORIO
"8260", // JAIME ROBERTO AGUADO MARTINEZ
"8261", // EDUARDO MORENO PEREZ
"8262", // JOSE LUIS TORRES ORTIZ
"8264", // ALEJANDRO GONZALEZ CORCHADO
"8267", // ALEJANDRO MARTINEZ HOYUELA
"8268", // MARTHA LETICIA DEL VALLE TRABANCO
"8270", // MIGUEL MARTINEZ MONDRAGON
"8272", // STEPHANIE IVONE RIOS AGUILAR
"8273", // JESUS ENRIQUE GUERRERO BURGOS
"8275", // MUCHAS GRACIAS AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"8277", // REY ALEJANDRO RODRIGUEZ HERNANDEZ
"8280", // ASESORES GENERALES ASOCIADOS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8282", // ENEIDA FERNANDEZ RIVERA
"8287", // FRIDA GUADALUPE JIMENO SANTANA
"8290", // ELVIA RAMIREZ CONTRERAS
"8293", // JORGE PACHECO MARIN
"8296", // EDGAR OCTAVIO UCEDA MORENO
"8297", // CLAUDIA TAPIA PONCE
"8298", // YAOPOL QUINAMETZIN GUZMAN MARTINEZ
"8299", // BETA AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"8300", // CYNTHIA CAROLINA MARTINEZ LUGO
"8301", // HECTOR LUGO CORNEJO
"8302", // JESUS ANTONIO SOLORZANO VAZQUEZ
"8305", // EGA MEXICO AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"8306", // LAURA BRITO JUAREZ
"8307", // MIRIAM LORENA KIRWAN ALCANTARA
"8308", // ALBERTO PATIÐO FLORES
"8311", // ARACELY GARCIA GONZALEZ
"8315", // FEDERICO ALFREDO N┌ÐEZ MEDINA
"8318", // FRANCISCO GERMAN ESTRADA Y MORELOS
"8319", // JOSE MANUEL LOZORNIO RODRIGUEZ
"8321", // JUVENTINO GERARDO GUTIERREZ GONZALEZ
"8322", // ENRIQUE MARIO GUERRERO ARAIZA
"8323", // GERARDO SANCHEZ ALMANZA
"8326", // ALMA LILIA CARDENAS ACOSTA
"8327", // MARIA DOLORES UGARTE AGUIRRE
"8329", // DAVID MIGUEL ZEPEDA CASAS
"8330", // CPS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8331", // MIGUEL ANGEL PAYAN GALAN
"8332", // ERNESTO CRUZ ESPINOZA
"8333", // BRENDA LILIANA RAMIREZ VARELA
"8334", // CLAUDIA ELENA MACIAS COLLAZO
"8336", // ANTONIO CUELI LOPEZ
"8338", // WILLIAM CASTRO LOPEZ
"8339", // MA. IRMA MORALES RODRIGUEZ
"8342", // PEDRO VELAZQUEZ MEDINA
"8343", // EUSTACIO CRUZ SALAS
"8344", // JESUS LIZARRAGA VELAZQUEZ
"8347", // WENDY VIRIDIANA MONDRAGON LARA
"8349", // JOSE INES CORONADO ALCARAZ
"8350", // ILDEFONSO DE JESUS SANCHEZ MARTINEZ
"8351", // GABRIELA ALEJANDRA GUTIERREZ REYNOSO
"8352", // ANABEL IBARRA CASTAÐEDA
"8353", // PROTECCION TECNICA MEXICO AGENTE DE SEGUROS Y DE FIANZAS SA
"8356", // CARLOS RODRIGUEZ VILLAFUERTE
"8357", // JULIO CESAR GALLEGOS GARCIA
"8358", // MARIO PIÐA PRIETO
"8359", // BRYAN ALONSO RAMOS MENDIAS
"8360", // GERARDO FLORES VARGAS
"8361", // ROBERTO BRYANT CURTI SOLIS
"8362", // LUIS MARTINEZ CONSULTORES & LM CONSULTORES AGENTE DE SEGUROS Y DE FIANZAS SACV
"8363", // LUIS ALEJANDRO ROCHA LOYA
"8364", // HECTOR GABRIEL VALDIVIA CALDERON
"8365", // MARGARITA DELIA SANCHEZ RINCON
"8370", // SEGURIDAD PLANEADA AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8371", // FABIOLA BERENICE RODRIGUEZ LOYOLA
"8372", // MERY ESTELA PENAGOS RODRIGUEZ
"8373", // RICARDO CERON GUTIERREZ
"8374", // GRUPO CIE * *
"8378", // NORMA ANGELICA MATHIEU GUTIERREZ
"8381", // ISRAEL QUIROZ ZAVALA
"8383", // FRANCISCO CABRERA ESPARZA
"8384", // MARTHA ALICIA PALOMARES *
"8385", // PORFIRIO MANUEL BUENO MELENDEZ
"8387", // JORGE CARLOS GAMEZ RODRIGUEZ
"8390", // FRANCA GARRIDO ESPINOSA
"8395", // LEON LICITACIONES 8395 GH
"8396", // LEON LICITACIONES 8396 JL
"8398", // CGY LICITACIONES DIRECTAS
"8399", // INSTITUTO POLITECNICO NACIONAL
"8400", // EXPORTADORA DE SAL SA DE CV
"8401", // GOBIERNO DEL ESTADO DE SINALOA
"8402", // LICITACIONES APSELP ESPECIAL
"8406", // CARLOS ALBERTO ALBORES SANCHEZ
"8407", // COLEGIO DE ESTUDIOS CIENTIFICOS Y TECNOL DEL EDO DE MEX
"8410", // JOSE ANTONIO SANCHEZ DE TAGLE VALENCIA
"8412", // MANUEL HUMBERTO RODRIGUEZ DELGADO
"8417", // EMMANUEL CASTRO RAMOS
"8418", // NORMA CECILIA PADILLA PORRAS
"8419", // ERIK GERARDO ZAMUDIO RIOS
"8422", // LETICIA CRUZ NAVAS
"8423", // JOSE MANUEL ALONSO AVILA
"8424", // LUIS ALFONSO TORRE ACERETO
"8425", // CEGLDR LICITACIONES DIRECTAS
"8426", // MANUEL OCTAVIO VELA CASTRO
"8427", // GABRIEL CLAUDIO HERNANDEZ RESENDIZ
"8428", // JORGE CHAVEZ VILLALPANDO
"8429", // LOURDES URANGA ARAGON
"8432", // ROGELIO APARICIO VAZQUEZ
"8433", // INTERCAM AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"8435", // JOFRA ORTEGA LEYVA
"8436", // JOSE DE JESUS ORTEGA ESCAMILLA
"8437", // MARIA MAGDALENA HERNANDEZ ZAVALA
"8439", // SOLEDAD DEL CARMEN BARRAZA SILVA
"8440", // PAMELA OMAÐA CASTAÐEDA
"8441", // JUAN ANTONIO A. DELA MORA OLVERA
"8444", // VICTOR MANUEL PALACIOS DIAZ
"8445", // OMAR PLASCENCIA PERDOMO
"8446", // OSCAR BERNARDINO ZARAGOZA ESTRADA
"8448", // ANDREA FERIA PALACIOS
"8449", // MIGUEL ANGEL CHOQUE MOCHICA
"8450", // JUAN CARLOS ORTIZ PRIETO
"8451", // SERGIO EDUARDO ARRIAGA FISCHER
"8452", // VICTOR HUGO VAZQUEZ DAVILA
"8453", // CONCEPCION ARENAS DE LA ROSA
"8454", // DULCE MARIA RAMIREZ BRAÐA
"8455", // LORENA AIDA CRUZ LOPEZ
"8457", // ENRIQUE BOUQUET VARGAS
"8458", // ASESORES GENERALES ASOCIADOS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8459", // PORFIRIO PRUDENCIO GUERRERO
"8460", // DAVID MURILLO HERNANDEZ
"8461", // ROSA MENDEZ LOPEZ
"8462", // ADRIAN GABRIEL PALACIOS PASTOR
"8463", // HECTOR LASTIRI FRIAS
"8465", // MA CARELIA ORDAZ HUANTE
"8466", // AMBROSIO GUTIERREZ LOPEZ
"8467", // BAGUES Y BAGUES SUCESORES SA DE CV
"8468", // ADRIANA LORENA CASTAÐON MEDINA
"8469", // LUIS ARCE ACUÐA
"8472", // VICTOR MANUEL PATIÐO MARTINEZ
"8473", // PEDRO SIECK MARIN
"8475", // CLUB DE PROTECCION LATINO
"8476", // MISAEL CAZARES TURCOTT
"8477", // ALEJANDRO RAMIREZ FLORES
"8479", // JORGE ALBERTO GUERRERO VELAZQUEZ
"8481", // ROBERTO CARLOS JIMENEZ QUINTIN
"8482", // MDA  AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"8483", // ALMA ROSA PEREZ ORTIZ
"8487", // JOAQUIN ALFONSO MEJIA GOMEZ
"8488", // MANUEL JIMENEZ SERRALDE
"8490", // RAUL DIAZ ANDALUZ
"8491", // JORGE RUEDA ISLAS-BUSTAMANTE
"8492", // BERNABE CASTILLO TENORIO
"8494", // ANA ELENA AVILA CUEVAS
"8495", // JOSE ARTURO OROZCO HERNANDEZ
"8496", // MASH AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8499", // RAQUEL ACEVES VALLE
"8500", // GMACZ  AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"8503", // FERNANDO PASCUAL RAMIREZ GARCIA
"8504", // JOSE ALFREDO RAMOS AGUIRRE
"8505", // JUAN CARLOS AGUILAR GOMEZ
"8506", // GILDARDO GONZALEZ PAREDES
"8507", // HUGO VICTORIO OTERO
"8508", // VICTOR MANUEL TOVAR PEREZ
"8509", // GUILLERMINA MERAZ AGUILERA
"8510", // HELGA ELIZABETH RUIZ VARELA
"8511", // JOSE ALBERTO GALICIA CRUZ
"8512", // PAOLA MICHEL REA ARVIZU
"8513", // SERGIO IVAN MIRANDA VERGARA
"8514", // YORDANNA FABIOLA PEREZ IBAVEN
"8518", // JOSE ROLDAN PERALES
"8523", // APSELP  AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8524", // HONORIA VILLEGAS TORIBIO
"8525", // FRANCISCO IVAN HERNANDEZ DOMINGUEZ
"8527", // SMART RESOLVIENDO TU VIDA AGENTE DE SEGUROS S.A. DE C.V.
"8529", // ANDRES ALCANTARA QUINTANA
"8530", // MODESTO JIMENEZ RAMIREZ
"8531", // ADMON SERV DE ALOJAMIENTO
"8532", // CLAUDIA LILIANA MOLINA DOMINGUEZ
"8533", // LIDIA CID AMARO
"8534", // REYNA GUADALUPE LEDEZMA FUENTES
"8535", // JORGE ALBERTO ILLANA LARA
"8536", // ERNESTO LOPEZ LEZAMA
"8538", // ENRIQUE BUENROSTRO GARCIA
"8539", // CARLOS ANTONIO MARTINEZ PEREZ TELLO
"8541", // ARMANDO LERMA GUERRA
"8544", // SANDRA SILVA CRUZ
"8547", // MIGUEL ANGEL CASTILLO CAMPOSECO
"8549", // GRACIELA URIAS CABALLERO
"8550", // COMISION FEDERAL DE ELECTRICIDAD
"8551", // MIRNA DEL SOCORRO MARTINEZ LOPEZ
"8552", // JUANA ESTELA RIVAS FLORES
"8553", // OSCAR VALDIVIA ROJAS
"8554", // YESMITH ORTEGA MIRANDA
"8555", // MUNICIPIO DE SLP
"8556", // MIRIAM ERICKA HERNANDEZ MECALCO
"8557", // JOSE AMBROSIO TECUATL GARCIA
"8562", // VALENTE BECERRA RAMIREZ
"8563", // MARCELA ROCA LANCE
"8565", // GRUPO ABS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8566", // JESUS LOPEZ GARCIA
"8567", // JESUS ALEJANDRO PAMANES OLVERA
"8569", // ALEJANDRO NICOLAS AGUIRRE OVIEDO
"8571", // BLANCA ELENA CHAVEZ NUÐEZ
"8572", // ELVIA PAOLA ORTIZ BIXLER
"8573", // FELIPE OLIVARES GUERRERO
"8574", // JAVIER ARMANDO RAMIREZ MORALES
"8575", // MARIA DE LA LUZ LOPEZ DE RIVERA HIDALGO
"8576", // VICTOR EDUARDO SALCEDO ARTEAGA
"8577", // ADRIAN MEDINA CIENFUEGOS
"8578", // MARIA ENRIQUETA HACHMEISTER BOTAS
"8579", // JOSE LUIS LOPEZ HERRERA
"8580", // IRL AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8581", // NORMA ANGELICA LOPEZ CASTRO
"8582", // FROYLAN GARCIA RUIZ
"8583", // CESAR DANIEL DE AVILA MEDINA
"8585", // UNIVERSIDAD NACIONAL AUTONOMA DE MEXICO
"8586", // GLORIA ISELA LOZANO ROSALES
"8587", // MANUEL BASUALDO LOPEZ
"8588", // ANDREA ADAME CARBAJAL
"8589", // ADMINISTRACION PATRIMONIAL AGENTE DE SEGUROS SA DE CV
"8590", // JORGE EDUARDO JIMENEZ ZEPEDA
"8591", // ALMA LILIA CARDENAS ACOSTA
"8592", // LUIS GERONIMO MARTINEZ
"8594", // JOSE CARLOS CASTRO LOPEZ
"8598", // JORGE EDUARDO MENDOZA HARTMANN
"8599", // GOBIERNO DEL ESTADO DE SAN LUIS POTOSI
"8600", // GOSEGUROS AGENTE DE SEGUROS S.A. DE C.V.
"8603", // JOSE ANTONIO GARCIA CERVANTES
"8604", // JORGE ENRIQUE NEVAREZ FIERRO
"8605", // ARACELI FLORES AGUILAR
"8606", // MARIA GUADALUPE SANCHEZ DOMINGUEZ
"8607", // ADOLFO FRANCISCO REBOLLAR LARA
"8609", // GRUPO ABS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8610", // ROBERTO MORENO DE-LA-O
"8611", // ENRIQUE GONZALEZ VELAZQUEZ
"8612", // PABLO ANDRES MOLINA GUTIERREZ
"8616", // JOSE PABLO SAINZ CRUZ
"8617", // DIONICIO GARCIA HERAS
"8618", // KAREN DIANA CHAVEZ NAVA RAMIREZ
"8619", // LEONARDO MOLINA ROMERO
"8620", // UNIVERSIDAD AUTONOMA DE LA CIUDAD DE MEXICO
"8621", // JORGE AZIEL CRUZ ROMERO
"8622", // RAQUEL ROBLES MARTINEZ
"8623", // CARLOS ARTURO VILLA VILLALPANDO
"8624", // KAREN DIANA CHAVEZ NAVA RAMIREZ
"8626", // NAZARETH GONZALEZ JASSO
"8628", // ANTONIO OSUNA RAYGOZA
"8629", // KAREN DIANA CHAVEZ NAVA RAMIREZ
"8631", // HUGO ANTONIO SOLIS RAMIREZ
"8633", // JAIME MARTINEZ MUNGUIA
"8634", // GALDINO REYES MONTERO
"8635", // ROSARIO CORTEZ OSORIO
"8636", // VICTOR ARTURO AREVALO ALBARRAN
"8637", // MANUEL GAVIÐO RODRIGUEZ
"8639", // LUIS CARLOS HORCASITAS HERNANDEZ
"8640", // FERMIN EMERSON RAMIREZ ROJAS
"8641", // CINDY DEL ROSARIO PREZA DURAN
"8645", // FRANCISCO JONATHAN LOPEZ MARTINEZ
"8646", // JESUS GALLEGOS MONTOYA
"8647", // MA. GUADALUPE PEREZ FRAUSTO
"8648", // ROBERTO UGALDE RIVERA
"8649", // AMANDA ELODIA GARCIA OLACHEA
"8651", // LUCIANO RAMIREZ GABINO
"8657", // ANDREA YANEZ TORRES
"8659", // ONLIFE AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"8660", // MARTHA MARIA RENDON RODRIGUEZ
"8662", // CARLOS MARIO VIVANCO MAESE
"8664", // ELVA KARINA RODRIGUEZ ACOSTA
"8666", // JAIME ARTURO REQUENA NOYOLA
"8667", // CARPIO & BAQUEIRO AGENTE DE SEGUROS SA DE CV
"8668", // MUNICIPIO HUIXQUILUCAN
"8669", // IVAN GARCIA RAMOS
"8670", // CARLOS RAFAEL HERNANDEZ CHIMAL
"8671", // SANDRA SILVA CRUZ
"8672", // CRISTINA DEL REFUGIO ROBLES CASTELLANOS
"8673", // CAROLINA CERVANTES SANCHEZ
"8674", // LAURA JULIETA LOPEZ BARCENA
"8676", // JOSE RAFAEL NIEMBRO GARCIA
"8678", // CLAUDIA MARIANA MIRANDA ALBARRAN
"8679", // CECILIO RICARDO COLLAZO PORTILLO
"8680", // AARON GARCIA VEGA
"8681", // MAYELIN CALZADILLA LOPEZ
"8682", // RICARDO JAVIER BARBOSA LOPEZ
"8684", // INES MARIA PEREZ VALENCIA
"8685", // MA. ROSARIO ENRIQUEZ SOTO
"8686", // PROTECTORA DE BOSQUES DEL ESTADO DE MEXICO
"8687", // NORMA ANGELICA BALLESTEROS ANGEL
"8689", // SAUL FLORES PORTUGUEZ
"8690", // GUADALUPE FLORES CID
"8691", // MAURICIO ALEJANDRO FERNANDEZ MADRID
"8693", // ANGELICA GUADALUPE GONZALEZ OLIVARES
"8694", // VERONICA MENDOZA MUNIZ
"8696", // JUAN GARNICA GUERRERO
"8698", // MARCO ANTONIO RUANO FUENTES
"8699", // JOSE DE JESUS RODRIGUEZ VELA
"8701", // MARIA LUISA LEYVA GUZMAN
"8702", // VIRIDIANA NOHEMY CASTELLANOS HERNANDEZ
"8703", // EMMA MUNOZ RODRIGUEZ
"8704", // GERARDO CERVANTES SAGRERO
"8705", // ARIADNE SAUCEDO VILLALON
"8708", // JUAN GUILLERMO BOURET GONZALEZ
"8709", // ARTURO GUILLERMO SANCHEZ MARQUEZ
"8710", // VERONICA ROMAN SANDOVAL
"8717", // MARIA GUADALUPE ARIAS MARTINEZ
"8718", // RICARDO ANTONIO LARA MANICA
"8719", // AGUSTIN RAMIREZ REBOLLEDO
"8720", // GLOBAL PROCESS AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"8721", // ISAIAS SALVADOR GONZALEZ BENITEZ
"8722", // MARIA GUADALUPE DEL GARCIA MERCADO
"8723", // ISIDRO ENRIQUE MEDINA REYNAGA
"8724", // LEONARDO RAMIRO LOSADA GAMONEDA
"8725", // IRL AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8726", // JUAN OSCAR GARCIA BANDA
"8727", // AMADO CERVANTES CERVANTES
"8728", // VIRIDIANA CONDE LOPEZ
"8730", // MIGUEL ANGEL MORALES LAGUNES
"8732", // BLANCA IVETTE PASTEN GALICIA
"8733", // MIGUEL ANGEL QUINTERO VELEZ
"8734", // VIRIDIANA PINEDA SANCHEZ
"8736", // ENRIQUE GAYTAN PUENTE
"8737", // MARIA CRISTINA PEREZ DEL-POZO
"8738", // SERGIO ALBERTO MENDOZA ROBLEDO
"8739", // ANA PATRICIA SANCHEZ GARCIA
"8740", // DAVID CAZARES ALVARADO
"8741", // JOSE MIGUEL RODRIGUEZ PALENCIA
"8742", // ANTONIO ALBURQUERQUE OTERO
"8743", // JORGE LUIS PIMENTEL RAMOS
"8744", // MARIA DEL ROSARIO ELOTLAN HERNANDEZ
"8745", // ANA MARIA GARCIA GARCIA
"8746", // MARIO EDUARDO PEREA RAMOS
"8748", // PABLO ENRIQUE CHAVIRA MAYNEZ
"8750", // FERNANDO QUIROZ MADRIGAL
"8751", // MIRNA VERONICA HERNANDEZ MEZA
"8752", // JOSE LUIS ESTRADA ARANZOLO
"8753", // BRENDA BERENICE RODRIGUEZ ROMERO
"8755", // MARTHA LILIA GARCIA GARCIA
"8756", // HECTOR JIMENEZ SALAZAR
"8757", // JULIO CESAR AVILA MONTAÐO
"8758", // MUNICIPIO DE IRAPUATO GUANAJUATO
"8760", // RAUL CEDILLO MERCADO
"8761", // MUNICIPIO DE CELAYA GUANAJUATO
"8762", // SISTEMA PARA EL DESARROLLO INTEGRAL DE LA FAMILIA DEL ESTADO DE MORELOS
"8763", // INSTITUTO DE SALUD DEL ESTADO DE MEXICO
"8764", // PODER JUDICIAL EESTADO DE MEXICO
"8765", // INSTITUTO NACIONAL DE BELLAS ARTES Y LITERATURA
"8766", // COLEGIO DE BACHILLERES DEL ESTADO DE HIDALGO
"8767", // SERVICIO DE ADMINISTRACION TRIBUTARIA
"8768", // EDITH GONZALEZ MONTES
"8769", // TOBIAS SOD FRANCKABUSKY
"8770", // JOSE OCTAVIO MENDOZA ILLESCAS
"8771", // SOFIA NOEMI CARDENAS SALMERON
"8772", // TOMAS IRINEO GARCIA SANCHEZ
"8773", // SAMUEL VEGA RAMIREZ
"8774", // HILDA CRUZ TELIO
"8775", // EQUINOX AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"8776", // CYNTHIA LEY MORGAN
"8777", // ISRAEL ADIEL GOMEZ RANGEL
"8779", // ANGELICA YADIRA HERNANDEZ LOPEZ
"8786", // PEDRO RENATO SOTO BERNAL
"8787", // TERESA DE JESUS RODRIGUEZ VALDIVIA
"8788", // HAIDEE BERENICE VAZQUEZ GONZALEZ
"8789", // ADRIAN EMIR GONZALEZ MARIN
"8790", // ERNESTO RASCON MELENDEZ
"8791", // MARGARITA HERNANDEZ ESPIRITU
"8792", // SILVIA ESCALANTE WONG
"8794", // LUIS ALBERTO GONZALEZ CALDERON
"8795", // VICTOR MANUEL COGGIOLA ARRONIZ
"8797", // ALEJANDRO JOSE BERUMEN QUEZADA
"8798", // JOSE ARTURO SARABIA AGUILAR
"8799", // MARTIN MASCOTE CONTRERAS
"8800", // CARLOS GERARDO MEDINA MARTINEZ
"8801", // FRANCISCO CANDELARIO HERNANDEZ BARBOZA
"8802", // LOURDES MARCELA ACOSTA DE LUNA
"8803", // YEFRIND TOMAS RODRIGUEZ ESPINOZA
"8804", // PATRICIO EDUARDO DEL CALLEJO TORRENTERA
"8805", // EDNA MARBEL MANRIQUEZ MONROY
"8806", // VLADIMIR SANCHEZ ZARATE
"8807", // DULCE AIDEE CORDOBA PEREZ
"8808", // JUAN JESUS ROMAN GAONA
"8809", // ANGEL GABINO FERNANDEZ AZCANIO
"8810", // CARLOS JONATHAN LEYVA VICTORINO
"8811", // MONICA ESTELA CASTRO MENDOZA
"8812", // DINORA MARIA DE LOUR NAVA BARRAGAN
"8813", // MONTSERRAT DE LA PEÐA VILLELA
"8814", // YACNARA ALEXABETH SANCHEZ MARTINEZ
"8815", // JAIME LANDA VERTIZ
"8816", // MIBO AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"8817", // VALERIA ALEJANDRA ZAMORA GARCIA
"8818", // MARCELA MARTINEZ CARMONA
"8819", // SANTIAGO ORTEGA GONZALEZ
"8821", // BENJAMIN AGUIRRE RODRIGUEZ
"8822", // JUAN FUENTES CAMACHO
"8823", // RICARDO HERRERA MARQUEZ
"8824", // CLARA CASTELLANOS CASTAN
"8825", // MARIO ADRIAN MEJIA MARTINEZ
"8826", // MIRIAM MORENO VELASCO
"8827", // CYNTHIA IRENE HEREDIA NIEDA
"8828", // MARIA DE LA LUZ GONZALEZ VIÐAS
"8829", // JOSE CARLOS IBARRA HERNANDEZ
"8830", // ENRIQUE DAVID MONTES DE OCA TORRES
"8831", // IRERI VAZQUEZ LOPEZ
"8833", // JUAN ALEJANDRO DE LOS SANTOS HERNANDEZ
"8834", // MARIA IVETTE VELAZQUEZ NADURILLE
"8835", // JOSE RAFAEL DE LA GARZA TELLEZ
"8836", // LUZ AURORA ARREOLA JIMENEZ
"8838", // GEMA LILIA AGUILAR BARRADAS
"8839", // CARLOS GUILLERMO RAMIREZ FLORES
"8840", // VICTOR HUGO VENEGAS ANDRADE
"8841", // DUSTANO ZENON VILLEGAS DE JESUS
"8842", // JORGE HERNANDEZ VARGAS
"8843", // TELMA MERCEDES DON LUCAS GOMEZ
"8844", // AURI YAMILY RIVERO ALCOCER
"8845", // JORGE MEDINA HERNANDEZ
"8846", // MACI ASESORES AGENTE DE SEGUROS SA DE CV
"8847", // MIGUEL ANGEL PEÐA HERRERA
"8848", // MUNICIPIO HUIXQUILUCAN
"8849", // FRANCISCO JAVIER FIERRO FLORES
"8850", // MOISES ALDAZ MARTINEZ
"8851", // JACQUELINE ARMENDARIZ PORTILLO
"8852", // MARIA GUADALUPE HERNANDEZ MONTAÐO
"8853", // FEDERICO FERNANDEZ ARREDONDO
"8854", // JOSE ANTONIO DOMINGUEZ GOMEZ
"8856", // LIDIA DURAN MARTINEZ
"8857", // ALMA LILIA CARDENAS ACOSTA
"8858", // LUIS ROBERTO MORA MORALES
"8859", // SARA LILIA MORA MORALES
"8860", // ANTONIO MONTOYA MOLINA
"8861", // JUANA CECILIA RAMIREZ JACINTO
"8862", // JOSE JUAN MANUEL PONCE DE LEON TANDA
"8863", // ESTEBAN ACOSTA RIVERO
"8864", // CLAUDIA SUSANA HERNANDEZ VAZQUEZ
"8866", // SARA LILIA MORA MORALES
"8867", // MARIA GUADALUPE RICO CUEVAS
"8868", // MAYER BALDERAS DOMINGUEZ
"8869", // DAYANE BALDERAS DOMINGUEZ
"8870", // DAVID ALEJANDRO DELGADO GARCIA
"8871", // BLANCA BRIGIDA AGUIRRE CASTRO
"8873", // LILIANA KARINA GARCIA PAREDES
"8874", // DAVID GONZALEZ DURAN
"8876", // LUIS ANTONIO LOPEZ OVIEDO
"8877", // MARIA DE JESUS MENDOZA ALVARADO
"8878", // ALLENDE CORDOVA CACHO
"8879", // VELIA MANRIQUEZ LOPEZ
"8880", // LAZARO MARTIN PACHECO CAMARA
"8881", // LUZ MARCELA VALERIO AMBRIZ
"8882", // JOSE ANTONIO OLIVER MARTINEZ
"8883", // FELIPE CONTRERAS ARIAS
"8885", // PATRICIA HERNANDEZ CRUZ
"8886", // ANGELINA DOMINGUEZ BAÐOS
"8887", // HERMES URDIALES MENDOZA
"8888", // ALFREDO JOEL ROCHA GONZALEZ
"8889", // RUBEN ZENDEJAS PEREZ
"8890", // FELIPE ESTEVA ABARCA
"8892", // JOSE LUIS FALCON ANAYA
"8893", // CONCEPCION ANTONIO SOTO AGUIÐAGA
"8894", // GRACIANO HUESCA OCHOA
"8895", // MARIA DE LOURDES SUAREZ HERNANDEZ
"8896", // UVIEL RAMOS GRAJEDA
"8897", // KATIA MORALES CRUCES
"8898", // MARTHA GUTIERREZ SERVIN
"8899", // FREDDY ISAIAS RODRIGUEZ MALDONADO
"8900", // GLADYS SALINAS OSORIO
"8901", // LUIS HAZAEL CRUZ VELAZQUEZ
"8902", // GLORIA ROCHER TOACHE
"8903", // RAMIRO PORTILLO REGALADO
"8904", // J. DOLORES MARTINEZ BERMUDEZ
"8905", // GERARDO GARCIA RODRIGUEZ
"8907", // JESUS DANIEL ORDUÐA PINEDA
"8908", // ANA PATRICIA MORALES GUTIERREZ
"8909", // OSCAR ALBERTO GOMEZ Y GOMEZ
"8910", // NESTOR ADRIAN ROMERO TIRADO
"8911", // DAVID GUZMAN SORIANO
"8912", // MAYRA PATRICIA ARMAS MARTINEZ
"8913", // GABRIEL MEDINA ASENCIO
"8914", // JOSE ROBERTO RAMIREZ OCHOA
"8915", // ALMA IRENE LOPEZ MORENO
"8916", // MARIA MAYA ARMENTA
"8917", // GRACIELA PATRICIA RAMIREZ SERNA
"8918", // NICOLAS HERMENEGILDO MORA
"8919", // JESUS ROBERTO FERNANDEZ COLCHADO
"8920", // JESUS ANTONIO PACHECO RENTERIA
"8921", // JUAN PABLO OJEDA VALENZUELA
"8922", // JAIME CUEVAS CORRALES
"8923", // ROBERTO MARTINEZ BURGOS
"8924", // FRANCISCO ARTURO BOCARDO BENAVIDES
"8925", // DELIA MARGARITA FLORES MEDINA
"8926", // GUSTAVO LADRON DE GUEVARA TRUJILLO
"8927", // JOSE GUSTAVO LARA ORDAS
"8928", // ALEJANDRO REQUENES OCHOA
"8929", // HORTENCIA CATALINA MORALES DOMINGUEZ
"8930", // YULENI VENTURA HERNANDEZ
"8931", // DAVID SOTO DIAZ
"8932", // SAUL MONTAÐO JARILLO
"8933", // ALLAN DE JESUS YERVES PENICHE
"8934", // ISABEL MORALES ANTONIO
"8935", // ADRIANA ALONSO ESCOBEDO
"8936", // JESUS ERNESTO ACOSTA ALVAREZ
"8937", // SEGU PRO AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"8938", // JORGE SANCHEZ MARTINEZ
"8939", // SALVADOR EDMUNDO LEDESMA ORTIZ
"8940", // ANA GABRIELA CAVAZOS URIAS
"8941", // DAVID GONZALEZ VAZQUEZ
"8942", // GERARDO LUPERCIO STEFFANI
"8943", // MIGUEL ANGEL BALDERRAMA RODRIGUEZ
"8944", // MIGUEL ANGEL IBARRA RIVERA
"8945", // JULIETA PATRICIO TREJO
"8946", // EDUARDO CASTRO SALINAS
"8947", // LOURDES MARIANA DELGADO OTERO
"8948", // LUIS FERNANDO CHAVEZ VALLINA
"8949", // DOMINGO ISLAS GARCIA
"8950", // IRMA ALPUCHE OSORIO
"8951", // CARLOS ALBERTO CAVAZOS TORRES
"8952", // JORGE ELADIO CALDERON RODRIGUEZ
"8953", // CLAUDIA ESTELA GOMEZ ACEVES
"8954", // MIGUEL ADRIAN CHAVEZ FLORES
"8955", // LILIA MARQUEZ PEREZ
"8956", // JOSE DAVID MIRANDA AGUILAR
"8957", // JOSE LUIS SANTA MARIA LANDA
"8958", // LEONEL ZARATE PAVON
"8959", // SERGIO ALBERTO FUENTES LAGARDA
"8960", // LUIS GUILLERMO ARZATE CASTREJON
"8961", // FELIPE ANTONIO MORENO RUIZ
"8962", // VIDA INDIVIDUAL
"8963", // LUVIA ALEJANDRA TIRADO GUERRERO
"8964", // ADRIANA ITURRALDE PEREZ
"8965", // ANGEL MARCELO HERNANDEZ GOMEZ
"8966", // MANUELA HERNANDEZ CARDENAS
"8967", // SANDRA YANIRA CRUZ DIAZ
"8968", // MA. LUISA HERRERA ARREDONDO
"8969", // HECTOR LOREDO RUBIO
"8971", // JOSE RENE MARTINEZ NUÐEZ
"8972", // BARBARA ABIGAIL OLVERA FUENTES
"8973", // MARGARITA MENDEZ GARCIA
"8974", // ASEGURADO TOTAL AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"8975", // YAZMIN GUADALUPE RAMIREZ ZAMORA
"8976", // FERNANDO ALBERTO SERNA ARENAS
"8977", // JUAN CARLOS AGUILAR MANCHA
"8978", // MARISSA TOLEDO FLORES
"8979", // INESIRIS ESMEDICHE MARTINEZ
"8980", // ANA CECILIA DEL ANGEL PEREZ
"8981", // JULIO CESAR CERECEDO AGUILAR
"8982", // EDWIN AUGUSTO VALLEJO JUAREZ
"8983", // EFRAIN PAYAN LICON
"8984", // JULIAN MORALES VILLA
"8986", // MOISES HERNANDEZ LUCIANO
"8987", // MAGALI OROPEZA LOPEZ
"8988", // SALVADOR MORALES VAZQUEZ
"8990", // ASSURANCE AGENTE DE SEGUROS SA
"8991", // JACIEL MENDOZA RICO
"8992", // NORA ALVAREZ MENDEZ
"8993", // JESUS GUEVARA VELARDE
"8994", // CLAUDIA QUIJAS GONZALEZ
"8995", // RODOLFO FIGUEROA OROPEZA
"8996", // JOSE CARLOS MENDOZA JUAREZ
"8997", // MARIA ALEJANDRA GONZALEZ GONZALEZ
"8998", // DAYAN VALLEJO HERNANDEZ
"8999", // JOSUE ROA MUÐOZ
"9010", // LUIS ALONSO MOYA FRANCO
"9011", // VICTOR HUGO AYALA CANCINO
"9012", // RAUL RICARDO MARQUEZ JIMENEZ
"9013", // IIB AGENTE DE SEGUORS Y DE FIANZAS SA DE CV
"9014", // MARIA CRISTINA POMPA DE CARCER
"9015", // ALMA AZUCENA GUERRERO FARFAN
"9016", // SONIA THALIA GONZALEZ FONTAN
"9017", // MONSERRATT JUDITH CRUZ ENRIQUEZ
"9018", // RODOLFO ORTIZ GUARNEROS
"9019", // MANUEL ALCOCER MEDINA MORA
"9020", // JORGE MAURICIO VALDEZ OSORIO
"9021", // AURORA CAMPOS RODRIGUEZ
"9022", // MIGUEL ARMANDO RUIZ GARFIO
"9023", // NANCY YADIRA OLMEDO GALINDO
"9024", // ERNESTO ERIK GARCIA CASTRO
"9025", // DANIEL EMILIO PELAEZ GARCIA
"9026", // MARIANO MARTIN GARCIA RAMIREZ
"9028", // SERGIO ALONSO CASILLAS JARAMILLO
"9029", // LUIS AGUILAR VILLASEÐOR
"9030", // ROSA JANNET CARRILLO HERNANDEZ
"9031", // HECTOR RAUL CORTES NODAL
"9032", // MARYSOL CUERVO ROSAS
"9033", // JESUS REYNALDO PARRA GONZALEZ
"9034", // CIMA AGENTE DE SEGUROS SA DE CV
"9036", // VICTOR MANUEL LOZANO CARRISOZA
"9037", // FERNANDO HERRERA CORRAL
"9038", // DAVID ORLANDO ESQUIVEL CARVAJAL
"9039", // RUBEN SALGADO SILVA
"9040", // FERNANDO DEL RIO SANTIAGO
"9041", // VIRIDIANA GUADALUPE OBANDO CASANOVA
"9042", // LUIS ENRIQUE JUAREZ MENDEZ
"9043", // LUIS ANGEL DIAZ CORDERO
"9044", // CARLOS RODRIGO VAZQUEZ ROSETE
"9045", // JAVIER OJEDA RAMIREZ
"9046", // KARLA CRISTINA ROSALES CERVANTES
"9047", // JAVIER MARTINEZ HERNANDEZ
"9048", // PEDRO GARCIA SANCHEZ
"9049", // ISABEL MARTINEZ VASQUEZ
"9050", // INTERR CONSULTORES AGENTES DE SEGUROS Y FIANZAS SA DE CV
"9051", // RODOLFO REYES GOMEZ
"9052", // DIANA CASTRO CAMARA
"9053", // VIRIDIANA CARAZA CRUZ
"9054", // IRMA GARCIA HERNANDEZ
"9055", // ISELA GUADALUPE RUIZ GIL
"9056", // MARIA DEL CARMEN PEREZ CORREA
"9057", // ROBERTO SANCHEZ REYNOSO
"9058", // PRAXEDIS RIVAS ENRIQUEZ
"9059", // HECTOR MONTES LUJAN
"9060", // JOSUE RAFAEL RODRIGUEZ BECERRA
"9061", // EVANGELINA GALVAN MENDOZA
"9062", // EFRAIN HERNANDEZ MEDINA
"9063", // PABLO ENRIQUE CASTRO CASTRO
"9064", // AURELIANO LAGARDA LEON
"9065", // DANIEL FERNANDEZ RAMIREZ
"9066", // RAUL GERARDO RIOS SIGALA
"9067", // MAURICIO FABIAN MAYO DOMINGUEZ
"9068", // MARICELA ESCAMILLA CIENFUEGOS
"9069", // GUILIAN OLVERA TRUJEQUE
"9070", // ALBERTO ANDRIANO ESTRADA
"9071", // MARIO HERRERA LEYVA
"9072", // VICENTE MAURICIO MORALES ALVARADO
"9073", // NORMA ELIZABETH ZAMARRIPA BANDA
"9074", // FERNANDO DANIEL VASALLO ALVARADO
"9075", // JORGE JAVIER FERNANDEZ GALINA
"9076", // HECTOR GUILLERMO DAVILA VALDEZ
"9077", // GERARDO DAVILA VALDES
"9078", // FERNANDO PEREZ LOPEZ
"9079", // RUBEN ARTURO AGUIÐAGA DELGADO
"9080", // FABIOLA CARRANZA SAENZ
"9081", // NELSON JOSE CEBALLOS CASTILLA
"9082", // REINA GUADALUPE POOL AVILA
"9083", // GRACE OLIVIA OROZCO TORRES ORTIZ
"9084", // JOSE ROMAN MARTINEZ CISNEROS
"9085", // CARLOS ROMAN SAUCEDA ALVAREZ
"9086", // BENJAMIN VAZQUEZ HERNANDEZ
"9087", // MARIA LETICIA REYNOSO MORENO
"9088", // JORGE LUIS MARTINEZ SALDAÐA
"9089", // JAVIER ALEJANDRO BARBOSA RODRIGUEZ
"9090", // NORMAN ALEJANDRO GARCES FIERROS
"9091", // LUIS FLORES VELA
"9092", // MARIA DE JESUS GARZA VEGA
"9093", // VICTOR MANUEL SANTIAGO CRUZ
"9094", // JONATHAN ADRIAN GUTIERREZ HOLGUIN
"9095", // JESUS HERRERA DE LA PAZ
"9096", // MARTHA PATRICIA HEREDIA JIMENEZ
"9097", // MARIA GRETHEL ALVAREZ MOGUEL
"9098", // IRAM NAVARRETE TREJO
"9099", // SOCORRO CABRERA ORTEGA
"9100", // JUAN PABLO GRANADOS HERNANDEZ
"9101", // ANABEL ALDERETE DELFIN
"9102", // ELISSA AMAYA SUBIAUR
"9103", // SANDRA VERONICA HEINZE CRUZ
"9104", // LORENZO VARGAS VARGAS
"9105", // JORGE RANGEL CAMACHO
"9106", // MARIA LUISA HERNANDEZ RIOS
"9107", // FRANCISCO COLIN ANAYA
"9108", // PEDRO ALFREDO RAMIREZ MORALES
"9109", // EMMA LETICIA ROJO ORTEGA
"9110", // ALMA LETICIA PERAZA MADRID
"9111", // ADRIANA BARAJAS ROJAS
"9112", // MARIA DE LOS ANGELES ARCE VARGAS
"9113", // ELIZABETH RAYMOND PAEZ
"9114", // RAUL PRIETO NAVARRETE
"9115", // SMART RESOLVIENDO TU VIDA AGENTE DE SEGUROS S.A. DE C.V.
"9116", // NICOLAS DEMOSTENES BETANZOS TRUJILLO
"9117", // OROZCO ASESORES AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9118", // JOSE LUIS CANO PEREZ
"9119", // SABINO DOMINGUEZ VASQUEZ
"9120", // CARMEN LUCIA FERNANDEZ FERNANDEZ
"9121", // MARIANA GEORGINA MORALES DIAZ
"9122", // BLADIMIRO LENIN CHAVEZ GALAN
"9123", // ROBIN RAMOS HINOJOSA
"9124", // JORGE IVAN SANDOVAL ARREOLA
"9125", // CRISTI GUADALUPE MARQUEZ RODRIGUEZ
"9126", // FERNANDO DAMIAN OCHOA ORTEGA
"9127", // ALVARO DE JESUS PEREZ HUERTA
"9128", // VICTOR CASTRO MEDINA
"9129", // MARIA DEL CARMEN JUAREZ VELASQUEZ
"9130", // NICOLAS VASCONCELOS MARCIAL
"9131", // GERARDO ESCAJEDA MARTINEZ
"9132", // FELIPE RAMIREZ LINARES
"9133", // JAVIER MARTIN GUZMAN REJON
"9134", // ALBERTO MOLINA CASTILLO
"9135", // MARIA AMAVILA MORENO DEL VALLE
"9136", // JONATHAN MARTINEZ ROIZ
"9137", // MARIA DE LOURDES HERNANDEZ AGUILERA
"9138", // IRMA DEL SOCORRO SEGOVIA HERNANDEZ
"9139", // MARIA ELIZABETH LOPEZ NUÐEZ
"9140", // VICTORIA EUGENIA VILLASEÐOR ZEPEDA
"9141", // LUIS RAUL FUENTES ARRIAGA
"9142", // RICARDO CONTRERAS IBARRA
"9143", // VICTOR MANUEL HERRERA ZENIL
"9144", // HECTOR JESUS FAUDOA GARCIA
"9145", // JOSE RAMON AMARAL PULIDO
"9146", // OMAR KARIM RODRIGUEZ SANCHEZ
"9147", // ANA KARINA MAY HERNANDEZ
"9148", // DANIEL IGNACIO MALDONADO CRUZ
"9149", // MARIA GUADALUPE CANO GUTIERREZ
"9150", // SALVADOR GODINEZ DELGADO
"9151", // RICARDO CELSO NAJERA CRUZ
"9152", // LEONARDO BARRIOS JURADO
"9153", // JORGE ANIBAL RIVAS ELIZALDE
"9154", // CLAUDIA ISABEL PORRAS RAMOS
"9155", // JOSE BENIGNO RODRIGUEZ MARRUFO
"9156", // SENON ROMERO MARQUEZ
"9157", // A.F. PENSAR AGENTE DE SEGUROS SA DE CV
"9158", // LUZ MARIA RUIZ VILLALOBOS
"9159", // ENRIQUE MEDRANO PONCE
"9160", // BERTHA ALICIA RAMIREZ *
"9161", // CARLOS ALBERTO RAMOS AGUILAR
"9162", // REBECA ARALY GRAJEDA CHACON
"9163", // CRISTOPHER SABAS SAVALA PEREZ
"9164", // MARIA ELVIRA CAMACHO PINEDA
"9165", // HECTOR ULISES OCHOA ZARATE
"9166", // ELIAS LOZANO MARTINEZ
"9167", // RICARDO JONAS MARTINEZ SALDIVAR
"9168", // ADRIANA JARETH LOREN PEÐA MARQUEZ
"9169", // MONICA PATRICIA GONZALEZ ZAMORA
"9170", // GUDELIA CAMPOS FUENTES
"9171", // JOSE FRANCISCO GUTIERREZ CORIA
"9172", // JESUS JAVIER HERNANDEZ ESCUDERO
"9173", // MONICA GALLARDO ARAGON
"9174", // SANDRA SILVA CRUZ
"9175", // KRISTIAN JOHAN ALEXI PALME AMOROS
"9176", // JORGE ARMANDO BAQUEDANO ALVARADO
"9177", // EDUARDO VAZQUEZ MORALES
"9178", // MOISES DE REYES CANUL CAHUM
"9179", // REBECA EUGENIA HERRERA SANTANA
"9180", // CESAR LEONARDO REYES CONTRERAS
"9181", // BENJAMIN MORALES CUETO
"9182", // REYNALDO ALVAREZ CRUZ
"9183", // JUANA PATRICIA MONTIEL RAMIREZ
"9184", // ALMA ROSA MONTES DE OCA OROZCO
"9185", // JESSICA MONSERRAT MARQUEZ MENDOZA
"9186", // FRANCISCO JAVIER LOPEZ CASTILLEJOS
"9187", // LUZVINA ESCUDERO DOMINGUEZ
"9188", // FAUSTO GARCIA PAEZ
"9189", // WILLIAM RENE RODRIGUEZ CHAVEZ
"9190", // JUAN ANTONIO SOTO ARIAS
"9191", // LEONIDES OSORIO GARFIAS
"9192", // CARMEN NAYELIT ALCANTARA MEDRANO
"9193", // DIMITRIS CORONADO RODRIGUEZ
"9194", // CESAR ALEJANDRO GONZALEZ RUIZ
"9195", // RICARDO ALVAREZ CASTAÐEDA
"9196", // ALEJANDRO CRUZ LEON
"9197", // ALLAN ALMAZAN QUINTERO
"9198", // GERARDO JOSE SEGUI CISNEROS
"9199", // KARINA AUREA CUERVO ROSAS
"9200", // JAVIER ALAFFITA VILLEGAS
"9201", // JUAN GERARDO GARCIA TORRES
"9202", // JOSE ADRIAN TORIBIO MONCADA SANCHEZ
"9203", // JUAN RAMON CERNUDA
"9204", // PAOLA CITLALI ALVAREZ ROSS
"9205", // LUIS FERNANDO MONROY LOPEZ
"9206", // SAUL SAMUEL SANCHEZ ORTEGA
"9207", // FERNANDO MANZANO VALDEZ
"9208", // IVONNE MARTINEZ ELIZARRARAZ
"9209", // NOEL GARCIA PARRA
"9210", // OMAR MONFIL NIETO
"9211", // CALEB ALBERTO MARQUEZ MUÐOZ
"9212", // ALEJANDRA RIVERA HIDALGO
"9213", // MA. DE LOS ANGELES FARFAN VILLEGAS
"9214", // CLAUDIA LUCIA COHETERO TAPIA
"9215", // JOSE DE JESUS ERNEST GUZMAN CAMPOS
"9216", // HUMBERTO CANIZALES TIRADO
"9217", // MAURICIO NAVARRETE PEREZ
"9218", // HUGO ENRIQUE BALCAZAR MENDEZ
"9219", // GUADALUPE LAZARO LEMA
"9220", // CELINA CLEOFAS RASCON RODRIGUEZ
"9221", // BLANCA LYDIA HERNANDEZ GARCIA
"9222", // ROGELIO DIAZ MEJIA
"9223", // JAIME ORTIZ PLACIDO
"9224", // MARTIN SANTIAGO VAZQUEZ
"9225", // JORGE FRANCISCO DIAZ WONG
"9226", // CARLOS EDUARDO GONZALEZ MONTIEL
"9227", // ROSA PATRICIA GUTIERREZ CHANG
"9228", // GABRIELA MARIA GONZALEZ GUZMAN
"9229", // ALINA GUTIERREZ MAR
"9230", // JUAN CARLOS FAMILIAR DIEZ DE BONILLA
"9231", // FELIPE BALLESTEROS MONTIEL
"9232", // ANTONIA NOLASCO DIAZ
"9233", // RUBEN CABRERA CELIS
"9234", // ASESORES DIRECTIVOS AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9235", // JUAN CARLOS CORRAL FLORES
"9236", // DANIEL CORTES HERNANDEZ
"9237", // TRINIDAD DEL CARMEN MEDINA CEDEÐO
"9238", // G.A.P. AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9239", // BLANCA LORENA GUADAL VELEZ SALTIJERAL
"9240", // YAZMIN MONTES MARTINEZ
"9241", // FABIOLA ISABEL VELAZQUEZ TREJO
"9242", // CARLOS ALBERTO OLVERA ITURRIAGA
"9243", // ELOY MANUEL REQUEJO RAMON
"9244", // JOSE FRANCISCO DIAZ MORALES
"9245", // JOSE LUIS FIGUEROA PRIETO
"9246", // SUSANA CITLALI MENDOZA VAZQUEZ
"9247", // CLARA VALERIO MOLINA
"9248", // MIGUEL MENDOZA GUIZAR
"9249", // WILBERT ENRIQUE CAMBRANIS MEDINA
"9250", // FREDDY DE LA CRUZ BASURTO
"9251", // SEGURO DE CALIDAD
"9252", // MANUEL BASUALDO LOPEZ
"9253", // JUAN CARLOS PONCE DE LEON SERAFIN
"9254", // CLAUDIA DOMINGUEZ RAMON
"9255", // NOEL ARTURO GONZALEZ JAQUEZ
"9256", // VERA LILIAN MUÐOZ CASTELLANOS
"9257", // PROMOTORA DIGITAL AGENTE DE SEGUROS SA DE CV
"9258", // MARTIN FRANCISCO ESCALANTE ESCALANTE
"9259", // ES VIDA AGENTE DE SEGUROS Y DE FIANZAS SA. DE CV.
"9260", // EFRAIN VALENZUELA ZUÐIGA
"9261", // ELIAS RODOLFO COPETE VILLEGAS
"9262", // EDUARDO BAEZA VASQUEZ
"9263", // CLAUDIA PACHECO DOMINGUEZ
"9264", // JESUS ULISES BALLESTEROS CHACON
"9265", // FRANCISCO JAVIER RAMIREZ ORIGEL
"9266", // MARCELA VELAZQUEZ RODRIGUEZ
"9267", // DULCE MARIA CERVANTES GASCA
"9268", // ROBERTO MANUEL CORBI VARGAS
"9269", // EDUARDO DIAZ JIMENEZ
"9270", // CINVESTAV 
"9271", // EVELYN OLIVARES MONTER
"9272", // LUZ ESMERALDA ALFONSO LANDA
"9273", // ROLANDO CRUZ AGUILAR
"9274", // JUAN DANIEL GONZALEZ VALENCIA
"9275", // DIEGO MARTINEZ MANCERA
"9276", // SANDRA LUZ FLORES SANTIAGO
"9277", // LETICIA RIVERA GONZALEZ
"9278", // ZENTICTL BEATRIZ MORENO VAZQUEZ
"9279", // DORA BEATRIZ MAGAÐA GONZALEZ
"9280", // RICARDO ELIAS NAHUAT RAIGOSA
"9281", // ARIMECHU S.C.
"9282", // ARTURO RODRIGUEZ GUTIERREZ
"9283", // AVIO PROMOTORIA AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9284", // MELIDA MARCELA OLMEDO RODAS
"9285", // ESMERALDA RIVERA SANTIAGO
"9286", // JORGE ESTRADA VAZQUEZ
"9287", // MARTHA ALICIA CARVAJAL SANCHEZ
"9288", // CGR AGENTE DE SEGUROS Y FIANZAS SA. DE C.V.
"9289", // JORGE LUIS NISHIMOTO LOPEZ
"9290", // IRVING ANUAR OLIVARES LOPEZ
"9291", // FRANCISCO ANDRES JIMENEZ MEZA
"9292", // I.E.S. CONSULTING DE MEXICO AGENTE DE SEGUROS SA DE CV
"9293", // AUREO ALMAZAN PEREZ
"9294", // BLANCA ANDREA DZUL CAUICH
"9295", // LUIS ALBERTO CETINA MARRUFO
"9296", // RAUL LOPEZ VENEGAS
"9297", // MARIA ISABEL GARCIA MENDEZ
"9298", // MARIA ALEJANDRA NAVA LUNA
"9299", // FELIPE PANTOJA RIOS
"9300", // MARIA BENITA FLORES FRANYUTTI
"9301", // MARIA TERESA MONSERR DOMINGUEZ BELTRAN
"9302", // SAMUEL ANTONIO VARELA ORDOÐEZ
"9303", // RODRIGO ARRIOLA TAMEZ
"9304", // CIRILO BAZAN ARJONA
"9305", // CESAR DAVID LOPEZ SANCHEZ
"9306", // KARLA GABRIELA VELAZQUEZ MONTAÐO
"9307", // KARINA ROMERO VILLEGAS
"9308", // ARMANDO GERMAN RAMIREZ HERNANDEZ
"9309", // JUAN MARES AFANADOR
"9310", // SALVADOR OCTAVIO VASQUEZ OCHOA
"9311", // EDGAR ARMANDO JAQUEZ FIERRO
"9312", // MARTIN HUMBERTO FLORES GONZALEZ
"9313", // CLAUDIA CECILIA FERNANDEZ ROSAS
"9314", // CERTUS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"9315", // MA. VERONICA DEL CASTILLO MARTINEZ
"9316", // NORMA LETICIA ALONSO MUÐOZ
"9317", // MIGUEL ANGEL FLEITES MALDONADO
"9318", // GERARDO ISRAEL ZAPATA ALONZO
"9319", // LIGIA KAREN CORREA ESPINOLA
"9320", // SEGISMUNDO MARQUEZ REYES
"9321", // CESAR JULIO CANCINO ARENAS
"9322", // CIRO PEREZ PEREZ
"9323", // CARLOS ENRIQUE LOPEZ ESCOBAR
"9324", // EGIL AARVIK LOPEZ
"9325", // SERGIO MEDINA URIBE
"9326", // MARTIN LAGUNES FLORES
"9327", // FERNANDO DANIEL LETECHIPIA TORRES
"9328", // JOSE JOAQUIN GONZALEZ FAGOAGA
"9329", // OLIVIA DEL CARMEN ZAMARRIPA MARTINEZ
"9330", // HORACIO CARLOS RODRIGUEZ RODRIGUEZ
"9331", // PEREZ RUBIO AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"9332", // ENRIQUE MENDOZA MORENO
"9333", // ANTONIO OSUNA RAYGOZA
"9334", // MARIA MARCELA BOZZIERE RODRIGUEZ
"9335", // JESUS HUMBERTO MALDONADO ARMAS
"9336", // CRUZ ANGEL GUEVARA ZAVALA
"9337", // JOSE MAURICIO CABAÐAS RAMIREZ
"9338", // RITA MENDOZA SALAS
"9339", // B & R PROTECCION PATRIMONIAL AGENTE DE SEGUROS S.A. DE C.V.
"9340", // MARIA LUISA ABUNDEZ URIZA
"9341", // E & E HACHMEISTER DELGADO CONSULTORES AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9342", // JESUS LEONARDO GARCIA DOMINGUEZ
"9343", // JOSE ANTONIO RAMIREZ VILLELA
"9344", // ADOLFO CORDOVA CHACON
"9345", // MAYRA LETICIA VAZQUEZ CARDENAS
"9346", // GERARDO ANTONIO MOLINAR *
"9347", // ERICK ADRIAN GRANADOS MORALES
"9348", // NORMA ANGELICA RIOS SANDOVAL
"9349", // DIANA IVONNE ARREDONDO ORNELAS
"9350", // NASHLA TANISHA RODRIGUEZ FUENTES
"9351", // GRUPO YANNINI AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9352", // LETICIA GUZMAN MARQUEZ
"9353", // JORGE LUIS MORALES MUÐOZ
"9354", // FILIBERTO SANCHEZ ESPINOSA
"9355", // ROSAURA MORALES HERNANDEZ
"9356", // VEST AGENTE DE SEGUROS SA DE CV
"9357", // MANUEL ALBERTO CENICEROS CANO
"9358", // MARIO JORGE ZAVALA ROLDAN
"9359", // BLANCA RAQUEL ORTIZ RODRIGUEZ
"9360", // JUAN CARLOS RAMIREZ CABRERA
"9361", // ROSA OLIVIA VELA HERNANDEZ
"9362", // LUIS MOISES RANGEL VELAZQUEZ
"9363", // CARLOS CEBALLOS BRITO
"9364", // CLAUDIA PAOLA MARTINEZ LOBATO
"9365", // GUADALUPE JIMENEZ JIMENEZ
"9366", // GABRIELA BETANCOURT MORALES
"9367", // MARIA EUGENIA RAMIREZ QUEZADA
"9368", // OBED NUÐEZ RUIZ
"9369", // HERNAN OSWALDO ALVAREZ AVENDAÐO
"9370", // ELDA MAGDALENA LOPEZ CASTRO
"9371", // LIZARRAGA & GUTIERREZ CONSULTORES AGENTE DE SEGUROS Y DE FIANZAS SAPI DE CV
"9372", // CARLOS ARTURO METELIN LOPEZ
"9373", // DANIEL ALMEIDA ZAMUDIO
"9374", // MANUEL RAMIRO CHAVEZ MENDEZ
"9375", // FELIPE YZQUIERDO PEREZ
"9376", // ALFREDO ARMANDO ZAVALA CAMARGO
"9377", // FAUSTO IRVING DOMINGUEZ BONILLA
"9378", // SANDRA OSORIO RUIZ
"9379", // FABIOLA GRISEL NAVA VILLALVA
"9380", // MARIA DEL PILAR REYNA CASTILLO
"9381", // ADER AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9382", // SAUL ALEJANDRO HOLGUIN AGUIÐAGA
"9383", // SERGIO VIVERO QUIÐONEZ
"9384", // EMILIO ENRIQUE CARDENAS SANTIAGO
"9385", // PATRICIA URREA BALLARDO
"9386", // MIGUEL EFRAIN ZAPATA GUERRERO
"9387", // LUIS GERARDO GOMEZ MARTINEZ
"9388", // MAURICIO MIRAVETE ACEVEDO
"9389", // ROSA ELIA SANTIAGO SANTIAGO
"9390", // ANDREA FERNANDA NAVARRETE LOPEZ
"9391", // MIGUEL ANGEL DURAN LOPEZ
"9392", // JUAN RAMIRO RODAS CAJERO
"9393", // OSCAR ERIC PEREZ ROMERO
"9394", // YOLANDA BASSOCO MADRID
"9395", // EDGAR MAURICIO LOREDO REYNA
"9396", // GASTON DAVID GARCIA AGUILLON
"9397", // LEONARDO OLVERA TRUJEQUE
"9398", // MELISSA MONSERRAT VELAZQUEZ VALVERDE
"9399", // SILVIA ALEJANDRA RAMIREZ RAMIREZ
"9400", // ALBERTO RUIZ COBAXIN
"9401", // EMMANUEL BENITEZ BARRETO
"9402", // ANA CECILIA DEL ANGEL PEREZ
"9403", // NANCY SANCHEZ NAJERA
"9404", // DAN NEFTALI JUAREZ BENITEZ
"9405", // JESUS ALFREDO RENTERIA XIMELLO
"9406", // JOSE RAMON PADRUNO TENORIO
"9407", // ALFREDO HERRERA RAMIREZ
"9408", // LAZARO MUÐOZ CARDENAS
"9409", // YURUHARY ASTUDILLO MORALES
"9410", // HECTOR MIGUEL VARGAS GARCIA
"9411", // JOSE ORTIZ DELGADILLO
"9412", // MARIA DEL CARMEN CASTRO GONZALEZ
"9413", // TERESITA CASTAÐEDA ALPUCHE
"9414", // ANGEL CANDELERO MENDEZ
"9415", // ARMANDO NOVELO CHAVEZ
"9416", // VICTOR MANUEL GONZALEZ NAVA
"9417", // FRANCISCO BETANCOURT DEL ANGEL
"9418", // JAIME ARMANDO CHAUL CHAMUT
"9419", // MAURICIO TORRES KING
"9420", // CARLOS MARIO MARTINEZ CASAS
"9421", // R & R ESTRADA CONSULTORES AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9422", // INDRA RIVERA MENDOZA
"9423", // JACINTO ALBERTO FLOTA ROMERO
"9424", // SER AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9425", // ELON AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9426", // GUSTAVO RODRIGUEZ RIOS
"9427", // JAIME GERMAN ALVARADO MATUS
"9428", // MARTIN GONZALEZ *
"9429", // MANUEL LUNA CORTEZ
"9430", // MARIA ANTONIA QUEVEDO BLANCO
"9431", // DAVID REGINO FIGUEROA PRIETO
"9432", // HERIBERTO JAUREGUI RAMOS
"9433", // JUAN JOSE MORALES FLORES
"9434", // ENRIQUE CALDERON PEREZ
"9435", // LUIS ALFONSO MIRANDA IBARROLA
"9436", // ANDREA ORTEGA TOLEDO
"9437", // YAJAHIRA IVETT HERNANDEZ ROSALES
"9438", // LUIS ENRIQUE RODAS MORENO
"9439", // JOSE ENRIQUE VARELA CATANEO
"9440", // SAMUEL CASILLAS VILLAGOMEZ
"9441", // CLAUDIA LEGARDA HERNANDEZ
"9442", // ARTURO CUEVAS GAVIÐO
"9443", // CESAR TESILLOS HERNANDEZ
"9444", // PRM AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9445", // ANGEL ROMAN ROSAS LAGUNA
"9446", // ALLAN ALMAZAN QUINTERO
"9447", // LIZBETH RAMIREZ ROMO
"9448", // GEOVANNA ORTEGA LOSOYA
"9449", // RAUL ALEJANDRO NAVARRO LOPEZ
"9450", // JORGE KARAM HADDAD
"9451", // FABRICIO LAGUNES FLORES
"9452", // BIBIANO MENDOZA SANCHEZ
"9453", // JULIETA PONCE NECOECHEA
"9454", // LUIS NIETO CAMPOS
"9455", // JUAN FRANCISCO ISLAS RUBIO
"9456", // ENRIQUE AVILA QUIROGA
"9457", // FERNANDO LORENZO SANDOVAL SANTAMARIA
"9458", // ERNESTO MONTIEL ESCALANTE
"9459", // SERGIO ANDRES GALAN RODRIGUEZ
"9460", // OSCAR AGUSTIN CAMPOS TORRES
"9461", // JORGE RICARDO HAMDAN HUERECA
"9462", // ISIIX INTELIGENCIA EN SEGUROS INSTITUCIONALES E INDIVIDUALES AGENTE DE SEGUROS
"9463", // IVAN GONZALEZ GARCIA
"9465", // COMISION NACIONAL DE CULTURA FISICA Y DEPORTE
"9466", // LUIS CARLOS ROMAN PAYAN
"9467", // ERICK RICARDO LOPEZ SANTAMARIA
"9468", // MARIO CUITLAHUAC CASTILLO NUCAMENDI
"9469", // EDUARDO TREJO ENRIQUEZ
"9470", // JOSEFINA SERRANO ESQUIVEL
"9471", // MONCERRAT ESMERALDA PEREZ LEDEZMA
"9472", // PABLO ROMERO BECERRIL
"9473", // LUCILA CONCEPCION ROSAS ROSALES
"9474", // ERIKA MARIA LOPEZ SOTO
"9475", // RAFAEL BOUDIB JURADO
"9476", // OLIVIA LUNA CARRASCO
"9477", // PILAR MARCELA VERDIN MENDOZA
"9478", // MARISOL HERMOSILLO GUTIERREZ
"9479", // MARIA DE JESUS CASTAÐEDA ZALETA
"9480", // MIGUEL ALFONSO VALDUEZA GUADARRAMA
"9481", // ARIADNA GUADALUPE VILLALOBOS VALDEZ
"9482", // COOPERTURA AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9483", // HAZAEL ENRIQUE CAMBRAIS BASTARRACHEA
"9484", // ROSENDA DOLORES GONZALEZ CONSUELOS
"9485", // MARIBEL VAQUERA RODRIGUEZ
"9486", // RIGOBERTO CISNEROS LOPEZ
"9487", // SEGURIDAD ARIEVA AGENTE DE SEGUROS SA DE CV
"9488", // LILIA NOHEMI GOMEZ NERI
"9489", // YASMIN AIDEE MAJALCA CARRILLO
"9490", // SALOMON RANGEL OLVERA
"9491", // ESPERANZA FARRERA NURICUMBO
"9492", // MARIEL DEL CARMEN LOZANO CARRISOZA
"9493", // FLORIBERTO ESCALANTE ROBLERO
"9494", // JOSE EDUARDO CERVANTES BARRON
"9495", // CINDY VANESSA CORTAZAR ARGAEZ
"9496", // JOSE LUIS RODRIGUEZ DIAZ
"9497", // EDUARDO TANUS URZUA
"9498", // MARIA DEL CARMEN BERROA BARBOSA
"9499", // NAYELI HERNANDEZ PULIDO
"9500", // JOSE IVAN MONTELONGO POTENCIANO
"9501", // ENRIQUE ROMANO AGUIRRE
"9502", // GEOVANNI ROMERO HERNANDEZ
"9503", // BENITO TAPIA DIAZ
"9504", // ANA KAREN ANDRADE HERNANDEZ
"9505", // LINDA PATRICIA POCHAT ESELENTE
"9506", // CONCEPCION FLORES SANCHEZ
"9507", // LUIS FERNANDO ESQUIVEL MARURI
"9508", // ANGELICA PALOMARES BECERRIL
"9509", // JESUS ENRIQUE ZEA ZAVALA
"9510", // GABRIELA GOMEZ ORTIZ
"9511", // ISAAC ARAGON ORTIZ
"9512", // RICARDO BARBA GANDARA
"9513", // HECTOR LEGARRETA PEREZ
"9514", // ALEJANDRO LUIS GOMEZ ORTIZ
"9515", // MARCOS ORNELAS VARGAS
"9516", // JUAN PABLO SERRANO BECERRA
"9517", // VICTORIA EUGENIA BALLESTA MASQUITA
"9518", // JOSE ANGEL PEREZ CASTRO
"9519", // VICTOR AGUSTIN VIGUERAS GARCIA
"9520", // JOSE ANTONIO TREJO DELGADILLO
"9521", // GUADALUPE DUARTE YAÐEZ
"9522", // VICTOR EDWARD GOLDSMITH CHESHES
"9523", // SANTOS GOMEZ ORTIZ
"9524", // ORQUIDEA GOMEZ PRIEGO
"9525", // RAFAEL ARMANDO MOSQUEDA CALVILLO
"9526", // JACKELINE CARBALLO DOMINGUEZ
"9527", // MIREYA DEL CARMEN ZURITA PRIEGO
"9528", // BUSTOS Y ASOCIADOS AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9529", // ALVARO REYES MORALES
"9530", // GWENDOLYNE ELENA GAMA BENITEZ
"9531", // DAVID FRANCISCO RENTERIA NAVARRO
"9532", // PROTEC AGENTE DE SEGUROS Y DE FIANZAS S.A.P.I. DE C.V.
"9533", // PABLO CESAR GONZALEZ LOPEZ
"9534", // RAQUEL ORQUIDEA DEL RIO DE LA TORRE
"9535", // JORGE ARMANDO DURAN CRUZ
"9536", // JUDITH LUZ MARIA LANDA LARA
"9537", // HUGO POSADAS TELLO
"9538", // JUAN GABRIEL ROMO PEREZ
"9539", // GUSTAVO SUAREZ GONZALEZ
"9540", // ILIANA JESSICA TELLEZ MARTINEZ
"9541", // MARTHA ISAURA CASTILLO ROJAS
"9542", // MOISES LANIADO KASSIN
"9543", // MARCOS ADLER ROMANO
"9544", // MARIA ELENA CANSECO LEMUS
"9545", // ROSSY VOGEL SADI
"9546", // BERNARDO KLEIN STERN
"9547", // REBECA BALAS LEVY
"9548", // YAZMIN MARTINEZ GALLEGOS
"9549", // WALTER ARTEMIO DOMINGUEZ SILVA
"9550", // MARTHA PATRICIA ROSALDO CRUZ
"9551", // SALVADOR ASSEO ALFIE
"9552", // SANDRA LOKIER GORBACH
"9553", // GUILLERMO JOSEPH SASSON JABER
"9554", // ARMANDO JIMENEZ ESPARZA
"9555", // DANIELA RICALDE TELLEZ
"9556", // ROXANA AVENDAÐO NERI
"9557", // ALDO AUCENCIO DIAZ TORRES
"9558", // PERLA IVETH HERNANDEZ AGUIRRE
"9559", // ALFREDO CISNEROS PEREZ
"9560", // YUDITH CASTRO GOMEZ
"9561", // LILIA GUADALUPE PORTILLO ALDUCIN
"9562", // RAUL ADRIAN GOMEZ LOPEZ
"9563", // GRUPO FID AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9564", // LUIS ORLANDO ALVAREZ MARTINEZ
"9565", // JUAN BERNARDO LOPEZ BECERRA
"9566", // LEONARDO VICENTE SANCHEZ SANCHEZ DRASDO
"9567", // NICOLAS FLORES BALDERAS
"9568", // GINA VERONICA ZAMBRANO GARCIA
"9569", // DANIEL SANCHEZ CID
"9570", // AGUSTIN BARRANCO HERNANDEZ
"9571", // MARCO ANTONIO RAMOS ROMO
"9572", // LILIA IVETH V ALENCIA FARIAS
"9573", // NEYVA DEL ROSARIO CARRILLO MERAZ
"9574", // JORGE EDUARDO ANDRADE LEON
"9575", // CARLOS ALBERTO SANCHEZ GANDARILLA
"9576", // MARTIN PEREZ HUERTA
"9577", // MARIA GUADALUPE URENDA RESENDIZ
"9578", // LUIS MICHE RAMIREZ
"9579", // GMAROTO AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9580", // LUCIA SALAZAR TABOADA
"9581", // JOSE FERNANDO MAYO HERRERA
"9582", // IVAN CORDOVA VELAZQUEZ
"9583", // OSCAR DANIEL SANCHEZ CHANONA
"9584", // ANA MARTHA DOMINGUEZ VALLEJO
"9585", // VIRGINIO FAUSTINO ROSAS VAZQUEZ
"9586", // JORGE FIGUEROA VIDAL
"9587", // RAYMUNDO SALINAS JALPILLA
"9588", // RICARDO ARTURO GARCIA MENA
"9589", // PEDRO ANTONIO CALDERON NAVARRO
"9590", // RAUL MARTIN CARBAJAL
"9591", // ENOC MORALES COLEAZA
"9592", // CAMPANELLA MERIDA AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9593", // ANDREA ORTEGA TOLEDO
"9594", // VICTOR ALEJANDRO ROJAS VILLANUEVA
"9595", // JORGE COBARRUBIAS SERAFIN
"9596", // JOSE CARLOS RODRIGUEZ VILAS
"9597", // CICELY VALLEJOS RUIZ
"9598", // STTATON AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9599", // ALFONSO VALDEZ MONSIVAIS
"9600", // LUIS ALFONSO RODRIGUEZ IRIGOYEN
"9601", // RAFAEL VERAZA PEÐALOZA
"9602", // DALIA LARA LOYA
"9603", // INTERMEDIACION NEXUS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"9604", // ALFREDO GOMEZ MARTINEZ
"9605", // GRUPO PROMOTORA MASIVA DE SEGUROS AGENTE DE SEGUROS SA DE CV
"9606", // NORMA LILIANA CHAVARRIA HERNANDEZ
"9607", // ARMANDO CHAVEZ FERNANDEZ
"9608", // MIGUEL ANGEL CONTRERAS MONROY
"9609", // SALVADOR MEDINA RAZO
"9610", // AGUSTIN AVALOS MORENO
"9611", // LILIANA MARGARITA GARCIA POLA
"9612", // JORGE DE JESUS SEGOVIANO GONZALEZ
"9613", // KARINA MALBELLIN HERNANDEZ PALACIOS
"9614", // FABIOLA LIZBETH HERNANDEZ CHAVEZ
"9615", // LATINO SOCIOS
"9616", // OSWALDO DANIEL MARTINEZ MARTINEZ
"9617", // WUILBERTH EDUARDO CHI HUICHIN
"9618", // ANTONIO GUERRA AGUILETA
"9619", // VICTOR MANUEL VELA RIOS
"9620", // VICTOR ALEJANDRO LOPEZ LARIOS
"9621", // SEGUROS PARA TODOS AGENTE DE SEGUROS SA DE CV
"9622", // CARLOS RAMON IBAÐEZ LEON
"9623", // SERGIO MONTOYA CLETO
"9624", // NORMA RODRIGUEZ QUIROGA
"9625", // SANDRA INES MUÐOZ SANDOVAL
"9626", // DRUZZO CASALE FRAUSTO
"9627", // JESUS SALAZAR AGUIRRE
"9628", // ALEJANDRO VELASCO REYES
"9629", // JUAN FRANCISCO MELERO RUIZ
"9630", // MANUEL ZAMORA ARCINIEGA
"9631", // DAVID ASENCIO HERNANDEZ
"9632", // FOVISSSTE PC
"9633", // ESTEBAN CHAVARRIA BOCANEGRA
"9634", // ANTONIO PEREDO ARENAS
"9635", // ALEJANDRO ARAUJO VILCHIS
"9636", // EMILIO ALEJANDRO RODRIGUEZ REYES
"9637", // CESAR MIGUEL AVILA NAHON
"9638", // ARIADNA MONDRAGON GUERRERO
"9639", // GLORIA MENENDEZ RAMIREZ
"9640", // FRANCISCO JOEL BALTODANO RODRIGUEZ
"9641", // GAPPER AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9642", // MIGUEL ANGEL MARTINEZ HERNANDEZ
"9643", // GLADYS YASMIN AGUAYO LOPEZ
"9644", // JUAN CARLOS ALCANTAR TREJO
"9645", // CASIMIRO HERNANDEZ CORDOBA
"9646", // ROSELIA DEL CARMEN SALDIVAR GUZMAN
"9647", // RENE BAEZA VILLANUEVA
"9648", // MARIO BENAVIDES ZOSAYAS
"9649", // IRMA CAROLINA ROIZ GONZALEZ
"9650", // LUIS ANGEL AGUIRRE SANTIAGO
"9651", // HECTOR CASTRO LOPEZ
"9652", // LOURDES DEL CARMEN POOL AVILA
"9653", // XICOHTENCATL CARRASCO REYES
"9654", // YOSIMAR HERRERA LOPEZ
"9655", // MARIA MARINA COLIN OLIVERA
"9656", // JAVIV PEIMBERT MILLAN
"9657", // GERARDO ARTURO ISLAS SANTOYO
"9658", // MARIA ANTONIETA NORIEGA RUGERIO
"9659", // JOSE LUIS REYES FERNANDEZ
"9660", // VALERIA ALEJANDRA CHAO PERAZA
"9661", // OSVALDO FIGUEROA GARCIA
"9662", // LUDWIG JOSE CHAVEZ MEZQUITA
"9663", // FERNANDO NOVELO STUBBE
"9664", // COMISION NACIONAL BANCARIA Y DE VALORES
"9665", // MARIA CONCEPCION GARCIA CASIMIRO
"9666", // MARGARITA MUÐOZ OSORIO
"9667", // JOSE CARLOS IBARRA HERNANDEZ
"9668", // CESAR DEROSO VELASCO LUIS CASTILLO
"9669", // REBECA GUTIERREZ CALDERON
"9670", // NACIONAL FINANCIERA S.N.C.
"9671", // MAL. DEL CARMEN CASTILLEJA MENDIETA
"9672", // JOSE GUEVARA NARANJOS
"9673", // ABIGAIL AMADOR CRUZ
"9674", // MARIA DE JESUS ROBLEDO LOPEZ
"9675", // DAVID CASTORENA MACIAS
"9676", // JOSE RAUL SALAS LOPEZ
"9677", // ERNESTO REY VALENCIA CELIS
"9678", // ROGELIO VEGA FLORES
"9679", // ADOLFO NAVARRO QUINTERO
"9680", // LICITACIONES  ABR
"9681", // EDGAR YAHIR DE JESUS MONTERRUBIO
"9682", // PEDRO MENDOZA CRUZ
"9683", // LUZ OFELIA VALENCIA PEREZ
"9684", // FRANCISCO JAVIER PULIDO SANCHEZ
"9685", // ALFONSO VICTORIA SOTO
"9686", // ROCIO ESMERALDA LOPEZ RAMIREZ
"9687", // RICCARDO GAMBIRASI ESPINOSA
"9688", // LAURA SAGNITTE GAMBOA CHAPARRO
"9689", // YANINE ANGELICA RODRIGUEZ MERINO
"9690", // CBEMAS AGENTE DE SEGUROS S.A. DE C.V.
"9691", // ELIZABETH JIMENEZ RIVERA
"9692", // IMELDA CITLALLI RUEDA MENA
"9693", // ELVIRA MALDONADO MARTINEZ
"9694", // LUCIA ARREOLA MARQUEZ
"9695", // SERGIO NOTARIO LOPEZ
"9696", // ADRIANA VENZOR GUTIERREZ
"9697", // PAOLA PINELO BOLAÐOS
"9698", // SAUL TELLEZ RUIZ
"9699", // SEBASTIAN RENE NARVAEZ *
"9700", // BLANCA VERENICE CONSUEGRA HERNANDEZ
"9701", // ERNESTO AQUILES ROSEY RODRIGUEZ
"9702", // KARLA YAZMIN CARDENAS LOPEZ
"9703", // ABEL MENDOZA CUEVAS
"9704", // DIANA RUTH HERNANDEZ OSORIO
"9705", // ZAIRA LUISA AVALOS MELENDEZ
"9706", // JERICO NAVARRO PAREDES
"9707", // MANUEL CHAVARRIA MONTES
"9708", // MARTIN JAVIER PRETELIN ALVARADO
"9709", // INNOVAZIONE AGENTE DE SEGUROS SA DE CV
"9710", // CAROLINA CASTRO VIEYRA
"9711", // HECTOR GERARDO CARPY BAUTISTA
"9712", // PAULINA FERRER MEGIAS
"9713", // ADILENE CONTRERAS CISNEROS
"9714", // NELIDA ANAHI SILVA RAZO
"9715", // SANDRA PAULINA MORALES ALCANTARA
"9716", // GUILLERMO OSCAR SANCHEZ SANCHEZ
"9717", // GUILLERMO PASTRANA MUNGUIA
"9718", // MAP  AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9719", // MARCO ANTONIO FIERRO VILLEGAS
"9720", // GUSTAVO NORIEGA TAVERA
"9721", // GUILLERMO PASTRANA MUNGUIA
"9722", // SERVANDO ESCAMILLA DOMINGUEZ
"9723", // JUAN IGNACIO HERNANDEZ GUTIERREZ
"9724", // OSCAR ALVAREZ BENITEZ
"9725", // MIREYA HERNANDEZ VAZQUEZ
"9726", // EDUARDO MENCHACA GALVAN
"9727", // SECRETARIA DE COMUNICACIONES Y TRANSPORTES
"9728", // JOSE ALFREDO RAMOS AGUIRRE
"9729", // ALEJANDRA PASILLAS ARTEAGA
"9730", // JUAN CARLOS CUELLAR LOPEZ
"9731", // JUAN CARLOS ORTIZ PRIETO
"9732", // MAGALY MARQUEZ AQUIRRE
"9733", // MARIA GLAFIRA MANRIQUEZ CALDERA
"9734", // ARMANDO TLALOC RAMIREZ VARGAS
"9735", // MARIA CARIDAD HERNANDEZ MANJARREZ
"9736", // ANA CECILIA SOSA JACOBO
"9737", // PEDRO GALEANA MORALES
"9738", // LUIS NIETO CAMPOS
"9739", // EDUARDO CASTAÐON ZURITA
"9740", // JOSE LUIS CASTILLO LARA
"9741", // MARIA ELENA SIMONIN BONILLA
"9742", // EDUARDO FELIPE BASURTO GOMEZ
"9743", // ESTEBAN FUENTES NIVON
"9744", // ARNULFO ROSAS HERNANDEZ
"9745", // MARIO CONRADO HERRERA OROZCO
"9746", // REYNA SANTOS UBALDO
"9747", // BERNARDO ZERMEÐO TERRAZAS
"9748", // RAQUEL ALEJANDRA MEDINA DZIB
"9749", // ARTURO LINO PRADO
"9750", // MUNICIPIO DE COLIMA
"9751", // SYLVIA LETICIA PALESTINO MANCILLAS
"9752", // JUAN GABRIEL SAUZ LOPEZ
"9753", // VIRIDIANA CECILIA MARTINEZ BARRETO
"9754", // JOSUE MOISES HUIZAR SEGURA
"9755", // LUIS MICHAEL AVALOS SERNA
"9756", // NORA ELIA CRUZ HERNANDEZ
"9757", // DANIEL CAMACHO PEREDA
"9758", // ROLANDO ULISES HERNANDEZ DELGADO
"9759", // JOSE LUIS GUADARRAMA GALLARDO
"9760", // ANA LUISA DUARTE *
"9761", // DANESSE RAMIREZ MONTOYA
"9762", // GERARDO VILLA CHACON
"9763", // GUILLERMO CAMPOS VALENCIA
"9764", // JACQUELINE COLMENERO GONZALEZ
"9765", // JOEL ARTURO ACOSTA DOMINGUEZ
"9766", // JOSE LUIS FAUDOA OLIVAS
"9767", // LORENA GUADALUPE CASTELLANOS ALCANTAR
"9768", // NORMA ANDREA ORTIZ GONZALEZ
"9769", // RAFAELA OLIVIA MARTINEZ CHAVEZ
"9770", // JOSE ANTONIO SEPULVEDA CASTILLO
"9771", // LUIS MANUEL UGALDE NIETO
"9772", // ANEL BELEM FERNANDEZ VALDEZ
"9773", // ELIZABETH AVILES BELLO
"9774", // VANESSA JARENY QUIROZ HERNANDEZ
"9775", // JAIME LIZCANO LIZCANO
"9776", // ALBERTO JOAQUIN DUARTE RUIZ
"9777", // ANA NIDIA NAJERA GOMEZ
"9778", // PAOLA CRISTELA TENA ARANDA
"9779", // MUNICIPIO DE GUANAJUATO
"9780", // CARLOS VALERIO CRUZ
"9781", // ENEDELIA DE LEON SANCHEZ
"9782", // ANA ELENA MUÐOZ MORENO
"9783", // JOSE DE JESUS ALANIS LOPEZ
"9784", // RODOLFO TORRES MARTINEZ
"9785", // VANESSA PEREZ-RUBIO MARTINEZ
"9786", // JOSE ALBERTO MAGAÐA MUÐOZ
"9787", // JORGE ARTURO MATUS ESPINO
"9788", // HECTOR CARLOS GARZA GUERRA
"9789", // ALMA ANGELICA ALVAREZ MATEOS
"9790", // LUIS JOAQUIN GUTIERREZ BERUMEN
"9791", // MIGUEL SALGADO CHAVEZ
"9792", // BERENICE BRACAMONTES GONZALEZ
"9793", // MIGUEL ENRIQUE CERVERA OJEDA
"9794", // HUGO CARDENAS RIOS
"9795", // AGUSTIN IGNACIO ARAMBURU SIERRA
"9796", // ADRIANA PEREZ ANDRADE
"9797", // SANDRA LORENA GARCIA FLORES
"9798", // ROCIO GABRIELA GARCIA PEREZ
"9799", // MIGUEL ANGEL PRECIADO RAMIREZ
"9800", // PABLO ADOUE PERALTA
"9801", // JOS╔ LUIS ANDRADE DUR┴N
"9802", // RAUL FERNANDO CELAYA SALCIDO
"9803", // MARIA LOURDES MARTINEZ CEBALLOS
"9804", // MARIA AMELIA AGUILAR JIMENEZ
"9805", // ALFREDO ARJONA MECALCO
"9806", // FLORINDA COSTILLA MONTOYA
"9807", // IDALIA DARYE GARCIA PRIETO
"9808", // ERIK RUIZ SUAREZ
"9809", // JOSE LUIS SOLIS NIEVES
"9810", // OMAR CASTELLANOS ALVARADO
"9811", // SANDRA ANGELICA VAZQUEZ CASTRO
"9812", // JAZMIN ALEJANDRA MOCTEZUMA GUTIERREZ
"9813", // MARIA ELIZABETH MUNGUIA TELLES
"9814", // ALEJANDRO SOTO SIQUEIROS
"9815", // GUILLERMO ABAD JIMENEZ GARCIA
"9816", // JAIME ALBERTO VALDES ARENAS
"9817", // ENRIQUE CASTILLO DE LA CAMPA
"9818", // TORRE FUERTE Y ASOCIADOS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"9819", // HUMBERTO DE JESUS VILLALPANDO FLORES
"9820", // ADRIANA SILVA PEREDO
"9821", // CARLOS GABRIEL GUAJARDO SANDOVAL
"9822", // ARMANDO HANZ HOFFMANN RIVERA
"9823", // VILMA GABRIELA FLORES NAVARRO
"9824", // LORENA MEDINA URIBE
"9825", // RUFINO VELAZQUEZ HERNANDEZ
"9826", // HECTOR CASTRO MOCTEZUMA
"9827", // FREDYZ ISMAEL PEREZ TEJEDA
"9828", // MIGUEL ANGEL CASTRO PEREZ
"9829", // GRUPO LEVEN AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"9830", // JOSE MANUEL GONZALEZ VILLARREAL
"9831", // ARTURO CAMPERO OLVERA
"9832", // LUIS ANGEL MARTINEZ SANCHEZ
"9833", // CLAUDIA GUADALUPE MORALES SANCHEZ
"9834", // INOCENTE HURTADO SANCHEZ
"9835", // RUPERTO LENIN PAREDES AGUILAR
"9836", // APRIL MEXICO AGENTE DE SEGUROS SA DE CV
"9837", // ABRAHAM SANCHEZ CAN
"9838", // XAVIER VACA ALVAREZ
"9839", // JOSE PABLO VAZQUEZ RAMOS
"9840", // GWANG SUCK LEE
"9841", // JAIME FELIX CABAÐAS OSUNA
"9842", // SERVICIOS INTEGRALES ADEC AGENTE DE SEGUROS S.A. DE C.V.
"9843", // RUBEN HERNANDEZ SANCHEZ
"9844", // BEATRIZ BASSOCO VIELMA
"9845", // FRANCISCO CASTELLANOS ALVAREZ
"9846", // TAURINO PEDRO AGUILAR .
"9847", // DEMETRIO MORENO SAMANIEGO
"9848", // SISTEMA PARA EL DESARROLLO INTEGRAL DE LA FAMILIA DE LA CIUDAD DE MEXICO
"9849", // WILLIAMS JAVIER REYES PERALTA
"9850", // M&M ALVAREZ AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9851", // CLAUDIA CONCEPCION PEREZ PEREZ
"9852", // ALEJANDRO IGNACIO VEYTIA ESQUIVEL
"9853", // ROSA MARIA ALVAREZ RUIZ
"9854", // CLAUDIA TORRES PEREZ
"9855", // ROBERTO ALEJANDRO LUCIO AVILA
"9856", // MONICA ROXANA LIEVANO MORENO
"9857", // ORLANDO RAMIREZ GRAJALES
"9858", // RODOLFO MARTINEZ MENDOZA
"9859", // EDGAR ANTONIO SANCHEZ MORANCHEL
"9860", // EDUARDO VAZQUEZ DURAN
"9861", // JORGE ENRIQUE GOMEZ GARCIA
"9862", // CESAR OCTAVIO BALDERAS DE LEON
"9863", // GRUPO SR AGENTE DE SEGUROS SA DE CV
"9864", // CESAR BRAULIO VILLALOBOS CERVANTES
"9865", // MAURICIO PEREZ CORONA
"9866", // CHRISTIAN NUALART CROW
"9867", // CINTHYA ISABEL NUÐEZ MUÐOZ
"9868", // LILIANA CERVANTES RUIZ
"9869", // MIGUEL LOPEZ LOPEZ
"9870", // OSCAR GUZMAN TURINCIO
"9871", // INSTITUTO NACIONAL DE ELECTRICIDAD Y ENERGIAS LIMPIAS
"9872", // GRUPO PYLC AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"9873", // MACOOLEY BROKERS AGENTE DE SEGUROS S.A. DE C.V.
"9874", // BERNARDO TOMAS EUGEN PALACIOS MACEDO GUTIERREZ
"9875", // ARTURO LOERA ALBARRAN
"9876", // CLAUDIA DEL CARMEN VELASCO VELEZ
"9877", // MAGDA JACQUELINE JIMENEZ ESQUIVEL
"9878", // AUREO ALMAZAN PEREZ
"9879", // RAUL RODRIGUEZ LOPEZ
"9880", // GRUPO PYLC AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"9881", // GRUPO PYLC AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"9882", // GRUPO PYLC AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"9883", // GRUPO PYLC AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"9884", // GRUPO PYLC AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"9885", // RAMON LARA PEÐA
"9886", // LICONSA S.A. DE C.V.
"9887", // ALEJANDRO GALLEGOS VERA
"9888", // JUAN BAUTISTA CEL PECH
"9889", // CARLOS ARTURO HERNANDEZ SANCHEZ
"9890", // GLORIA ADRIANA SALAS QUIÐONES
"9891", // MARIA ELENA ROBLEDO COLLAZO
"9892", // CARLOS ALBERTO CORNELIO ALCUDIA
"9893", // SILVIA LUNA SUAREZ
"9894", // SALVADOR MARTINEZ AGUILAR
"9895", // FERNANDO HERNANDEZ VELAZQUEZ
"9896", // RAMIRO TOVAR CHAVEZ
"9897", // MARIA TERESA ATLITEC SANCHEZ
"9899", // MARIA CRISTINA LUNA ALTAMIRANO
"9901", // DANIEL PENA GARCIA
"9902", // MUNICIPIO DE SAN PEDRO GARZA GARCIA
"9903", // OLGA YOLANDA SUCHOMLINOW AZIZ
"9904", // CLAUDIA QUIJADA PEREZ
"9905", // ITALO RAFFAELE BARBATO DOSAL
"9906", // EDGAR RAYMUNDO BURGUEÐO MORALES
"9907", // COLEGIO DE BACHILLERES DE CHIAPAS 
"9908", // GUADALUPE ERIKA RUIZ GAONA
"9909", // AGUSTINA ELISA AYALA CABRERA
"9910", // RUSVEL TOLEDO CAL Y MAYOR
"9911", // CLAUDIA ANGELICA GODINEZ PALOMAR
"9912", // PAOLA MICHEL REA ARVIZU
"9913", // FELIX GUTIERREZ PEÐA
"9914", // MARIA EUGENIA ESTHER CARRERA CARREON
"9915", // ADID Y ASOCIADOS AGENTE DE SEGUROS SA DE CV
"9916", // DANIEL ISAAC VAZQUEZ SIQUEIROS
"9917", // HECTOR JONATHAN LUCAS JAIMES
"9918", // CONCEPCION HARPER ESCOBAR
"9919", // T&M2 LIFE ADVISORS AGENTE DE SEGUROS S.A. DE C.V.
"9920", // MARIANA RODRIGUEZ SANCHEZ
"9921", // ANA LIDIA VILLALOBOS HERNANDEZ
"9922", // NORMA ANDREA ORTIZ GONZALEZ
"9923", // CARLOS GUILLERMO SAENZ GUERRA
"9924", // J. JESUS LOPEZ SEGURA
"9925", // ALEJANDRO MIRANDA REVILLA
"9926", // UNUS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"9927", // SEI ASESORES AGENTE DE SEGUROS SAPI DE CV
"9928", // GLORIA GEORGINA DUEÐAS MARTINEZ
"9929", // GERARDO REYES CRUZ
"9930", // ERICKA LIZETH LOREDO RODRIGUEZ
"9931", // ALVERDE AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"9932", // SELENE NOLBERTO JIMENEZ
"9933", // ZENAIDA GUADALUPE GOMEZ CHABLE
"9934", // ERIDA VIVEROS AGUIRRE
"9935", // ALBERTO ENRIQUE SOLORZANO OROPEZA
"9936", // CESAR LUIS SANCHEZ RESENDIZ
"9937", // LAURA ELENA GARCIA RAMIREZ
"9938", // PEDRO ROMERO MARTINEZ
"9939", // SAFENOW AGENTE DE SEGUROS  S.A. DE C.V.
"9940", // COLEGIO DE BACHILLERES DE QUERETARO 
"9941", // GUILLERMO ALEJANDRO ARMENDARIZ ZAPATA
"9942", // RITA ESPARZA HERNANDEZ
"9943", // SALVADOR HERRERA BARRAGAN
"9944", // PABLO KIEV ELIAS TAHUILAN
"9945", // IRMA ANGELICA CORREA BASTIDA
"9946", // IRMA VANESSA CHAVEZ ESPINOZA
"9947", // ANGEL TORIBIO MARQUEZ FIGUEROA
"9949", // ADRIANA BAYON PRECIADO
"9950", // GABRIELA HERMAN CAMPOS
"9951", // SONIA TAVITA LOPEZ HERNANDEZ
"9952", // MARIO ALFREDO MENDIOLA MARTINEZ
"9953", // ALEXIS CASTILLO ABURTO
"9954", // EMMA GUADARRAMA MARES
"9955", // ANTONIO VELAZQUEZ DE LEON GARDUÐO
"9956", // CONCEPCIËN IBARRA CERECERES
"9957", // ISAAC RUIZ SUAREZ
"9958", // JESUS VILLANUEVA GALVEZ
"9959", // ROBERTO VARGAS CISNEROS
"9960", // CLEMENTE ALAN TORRES EGUIARTE
"9961", // MIGUEL RODRIGUEZ HINOJOSA
"9962", // BESSON AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"9963", // ALFREDO ALEJO BECERRIL
"9964", // CRISTINA SANCHEZ FLORES
"9965", // CRISTINA VILLASANA VEGA
"9966", // JORGE APOLONIO GONZALEZ MATA
"9967", // ART AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"9968", // OMAR HAZIEL GONZALEZ BUSTAMANTE
"9969", // ARTURO CASTANEDO VELASCO
"9970", // JOSE DE JESUS RAMIREZ PEREZ
"9971", // PATRICIA EUGENIA JIMENEZ VALADEZ
"9972", // NELIDA PAOLA RODRIGUEZ LOZANO
"9973", // JOSE ALBERTO ZEPEDA SANCHEZ
"9974", // IRENE ARELLANO SANTIAGO
"9975", // ISMAEL VELA ESCOBAR
"9976", // RICARDA CARRERA REYES
"9977", // RAMON SEIRA SERRANO
"9978", // RICARDO JIMENEZ GUILLEN
"9979", // PROFIT AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"9980", // ADRIAN JIMENEZ JARAMILLO
"9981", // JUAN DIDIER MARTINEZ SANCHEZ
"9982", // DAVID IGNACIO CERDA DEL PANDO
"9983", // MARIA DE LA LUZ CHAVEZ MARTINEZ
"9984", // PATRICIO GONZALEZ SAN VICENTE
"9985", // JORGE TONATHIU LOPEZ GOMEZ
"9986", // CARLOS RICARDO COLMENARES MILLAN
"9987", // VICTOR MANUEL FLORES GUTIERREZ
"9988", // BRENDA ZUÐIGA GUTIERREZ
"9989", // CARLOS MANUEL HERNANDEZ JUAREZ
"9990", // IVAN ENRIQUE JUAREZ ROSAS
"9992", // JUAN JOSE PANIAGUA MENDOZA
"9993", // EDUARDO ARREAGA SANCHEZ
"9996", // MARCO ANTONIO VAZQUEZ ALBORES
"10000", // ENRIQUE MARTINEZ BENGOA
"10001", // CARLOS ARTURO MEDINA QUINTANAR
"10002", // UNIVERSIDAD NACIONAL AUTONOMA DE MEXICO
"10003", // ESAU MANUEL TORRES MORALES
"10004", // JUAN PABLO CASTILLO DE LA CAMPA
"10005", // GLORIA ARLETTE LAPHOND GONZALEZ
"10006", // JOSABETH MEDINA SILVA
"10007", // JONATAN ALEXIS RAMOS FRAGOSO
"10008", // MARLENE SOSA MARTINEZ
"10009", // FERNANDO CERON VEGA
"10010", // JESSICA ALEJANDRA HERRERA MARTINEZ
"10011", // FELIPE AZAMAR CELEDONIO
"10012", // SOFIA SASSON HAMUI
"10013", // ARMANDO LOZANO TORRES
"10014", // ERICK EDUARDO BADA RUIZ
"10015", // JOSE LUIS CHAVEZ CERVANTES
"10016", // KARLA O'FARRILL CRUZ
"10018", // JOSE PORFIRIO RIVERA HERNANDEZ
"10019", // JORGE MIGUEL GONZALEZ MUNGUIA
"10020", // ALVARO MEJIA PEREZ
"10021", // ABAD GUILLERMO SALAS RODRIGUEZ
"10022", // JORGE ALFREDO BARRERA MARTINEZ
"10023", // ALFREDO LUNA NAVARRO
"10024", // PAHOLA TERESITA CHAVEZ VALLADARES
"10025", // MANUEL ALBA ROCHA
"10026", // MIRIAM SALGADO MARTINEZ
"10027", // FRANCISCO ENRIQUE VARGAS REYES
"10028", // MARISOL VILAR MARIN
"10029", // G.M. ASOCIADOS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10030", // RANGEL GUTIERREZ AGENTE DE SEGUROS S.A. DE C.V.
"10031", // RODRIGO HERNANDEZ GONZALEZ
"10032", // ANA ROSA MACIAS VELAZCO
"10033", // REUNE AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10034", // SERGIO OMAR NAJERA BURCIAGA
"10035", // CARLOS ALBINO CASTAÐEDA NIETO
"10036", // CARLOS RICARDO COLMENARES MILLAN
"10037", // IRAIS VIRIDIANA GUERRERO SALAS
"10038", // PAULO CESAR CRUZ BLANCO
"10039", // RICARDO ISRAEL RODRIGUEZ ARTEAGA
"10040", // CYNTHIA ELENA ORDAZ JURADO
"10041", // JESUS EDUARDO ELIZALDE CASTILLO
"10042", // ANDREA ELIZALDE CANO
"10043", // CARLOS ALBERTO ALMARAZ LECHUGA
"10044", // MARIA DEL ROSARIO TORRES RODRIGUEZ
"10045", // JOSE ROBERTO ASTORGA HERRERA
"10046", // LAURA OLIVIA ASCENCIO MAYORGA
"10047", // DIANA MARICELA CRUZ MOLAR
"10048", // ALEJANDRO GUEVARA VELARDE
"10049", // PRAXEDEZ OLIVIA HEVIA ROSSETTE
"10050", // GERARDO MANUEL A ANDREU RODRIGUEZ
"10051", // ANTONIO ANAYA GARCIA
"10052", // ESA AGENTE DE SEGUROS S.A. DE C.V.
"10053", // ANDRES GALICIA CORTE
"10054", // FELIPE HERRERA PATRACA
"10055", // HUGO DE LA ROSA MUÐOZ
"10056", // CARLOS MOLINAR VARELA
"10057", // DANIEL CALDERON HERNANDEZ
"10058", // JUAN CARLOS GARCIA BONILLA
"10059", // JAYRO MORALES BERNAL
"10060", // LUIS JOAQUIN ALVAREZ MORENO
"10061", // CLAUDIA ADRIANA LICON PEDRAZA
"10062", // CHRISTIAN CARDONA MARTINEZ
"10063", // MARIA LUCIA ROJAS FLORES
"10064", // MARIO PEREZ VILCHIS
"10065", // FERNANDA MARMOLEJO CANCHOLA
"10066", // OMAR FRANCISCO SANCHEZ LUGO
"10067", // MARIA DE LA LUZ COVARRUBIAS RAMIREZ
"10068", // SILVIA ELENA VILLANUEVA CAMPOS
"10069", // SALAMANCA AMADOR ESTRATEGAS PATRIMONIALES AGENTE DE SEGUROS S.A. DE C.V.
"10070", // SEGURISK AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10071", // LUISA FABIOLA BASTIDA MARROQUIN
"10072", // FERNANDO ALBERTO NOVELO GONZALEZ
"10073", // PATRICIA ARRAS JURADO
"10074", // DIANA SILVA SALAZAR
"10075", // CYNTHIA GARZA DE YTA
"10076", // BLACK TOWER GROUP AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10077", // GERARDO EMANUEL REVELES CHAVEZ
"10078", // ROCCO AMAURI CORDOVA GONZALEZ
"10080", // JOSE ENRIQUE CASTILLO DIAZ
"10081", // ALMA ROSA NAVARRO PANDO
"10082", // VICTORIA EUGENIA HAMDAN HUERECA
"10083", // VIRIDIANA SOMARRIBA ZAVALA
"10084", // PLANES CORPORATIVOS Y PATRIMONIALES AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10085", // VICTOR HUGO ORTEGA MUÐOZ
"10086", // MIGUEL ANGEL NIETO LOPEZ
"10087", // MARIA JUANA ROJAS COATE
"10088", // CRISTIAN ORUZ CRUZ CRUZ
"10089", // ANTARES CISNEROS CHANTRE
"10090", // EUDOSIA LETICIA MIER RAMIREZ
"10091", // MOISES MONTIEL CISNEROS
"10092", // SOTERO AGUILAR RIVERA
"10093", // ULICES MONTIEL CISNEROS
"10094", // RUTH LORENA ROBLEDO ZAPATA
"10095", // ALBERTO PRIETO TARIN
"10096", // JESUS ALEJANDRO MONTALVO LOZANO
"10097", // MARIA QUIROZ LOPEZ
"10098", // MONICA VALVERDE BELTRAN
"10099", // JOSE LUIS FLORES VILLANUEVA
"10100", // BLANCA ESTHELA ORNELAS HERNANDEZ
"10101", // CARLOS NIEVES PEREZ
"10102", // MARIO ALEJANDRO BAUTISTA LOPEZ
"10103", // ALMA VIRGINIA IBARRA RAMOS
"10104", // RAYMUNDO JAVIER VAZQUEZ HERNANDEZ
"10105", // MIRIAM BLANCO MOMOX
"10106", // JOSE ALDO SALAS CARBENTE
"10107", // ARTURO GARCIA JIMENEZ
"10108", // CARLOS PASTEN CID
"10109", // JAVIER ANTONIO RAMIREZ CONDE
"10110", // FRANCISCO HOLGUIN MONTOYA
"10111", // HECTOR CID RODRIGUEZ
"10112", // ERICKA DIAZ ASCENCIO
"10113", // ALEJANDRA MONTES DE OCA LOZANO
"10114", // SERGIO SAMUEL ALVARADO REYES
"10115", // ANA BERTHA GONZALEZ GALVAN
"10116", // PABLO ARTURO SANCHEZ GARCIA
"10117", // GRUPO METROPOLI AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"10118", // ERNESTO RAMOS SUAREZ
"10119", // INSTITUTO DEL FONDO NACIONAL DE LA VIVIENDA PARA LOS TRABAJADORES 
"10120", // JOSE ANTONIO PEREZ QUIJANO
"10121", // ROBERTO AUGUSTO CANTO CASTILLO
"10122", // AGUSTIN OCHOA BRAMBILA
"10123", // PEDRO VELA ROJAS
"10124", // ILIANA DE LOS ANGELE CASTELAN BAUTISTA
"10125", // OSCAR GONZALEZ LEGORRETA
"10126", // ANDRES OSORIO GOMEZ
"10127", // ALEJANDRO LADRON DE GUEVARA MARTINEZ
"10128", // LUCINDA LARA SANCHEZ
"10129", // MARGARITA HURTADO GONZALEZ
"10130", // GERARDO HUITRON TREJO
"10132", // MONTSERRAT GONZALEZ BARQUIN
"10133", // MARIA SYLVIA GAMEZ AGUIRRE
"10134", // ISP BROKER AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10135", // MARIA ANALI BERRIOS NAVARRO
"10136", // ERIKA MARIA LUQUIN VELAZQUEZ
"10138", // CAE AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10139", // LUIS FELIPE MORENO NARVAEZ
"10140", // GUSTAVO MELENDEZ HERNANDEZ
"10141", // RAMON CASTRO CALDERON
"10142", // CARLOS DE JESUS GONZALEZ LOPEZ
"10143", // ALVARO AMBROSI CORTES
"10144", // RAMIRO TOLEDO RAMIREZ
"10145", // MIGUEL ANGEL SEGOVIANO REYES
"10146", // JESUS DOMINGUEZ OYERVIDES
"10147", // JOSE MANUEL HUERTA MARTINEZ
"10148", // ALBERTO JUAREZ DE CISNEROS
"10149", // LILIANA YAZMIN ZAVALETA ABAD
"10150", // MANUEL FERNANDO CARRASCO CUEVAS
"10151", // MAURICIO VALES DIAZ
"10152", // ALDO NOE PLATA GARCIA
"10153", // EVELYN ALETSE FREYRE ESCORCIA
"10154", // CESAR EDUARDO HERNANDEZ BARRAGAN
"10155", // ENRIQUE JESUS TALAVERA RUIZ
"10156", // VICTOR MANUEL CHAVARRIA PEREZ
"10157", // FLORENTINO HERNANDEZ VAZQUEZ
"10158", // ALBERTO MIRANDA SIMON
"10159", // ANTONIO NUÐEZ CORREA
"10160", // ARTURO GERARDO OLASCOAGA MORENO
"10161", // JUAN LUIS DAVILA AVILA
"10162", // MIROSLAVA GARCIA LOVERA
"10163", // ROSA MARIA RODRIGUEZ ALFONSO
"10164", // ANALY ESPINOSA CRUZ
"10165", // ALBERTO ALFARO MENDOZA
"10166", // MARIA CRISTINA DIAZ SOLANA
"10167", // MARISSA PADILLA LIZAMA
"10168", // MAURICIO JOSE SIERRA DIAZ
"10169", // ANGEL MANUEL GUILLEN MOLINA
"10170", // JONATHAN JOSUE GOMEZ SANCHEZ
"10171", // GUSTAVO MARTIN EHUAN DORANTES
"10172", // GLORIA LETICIA GONZALEZ CORNEJO
"10173", // EDUARDO RAMON BERNAL ZAMARO
"10174", // MARIA TERESA OLVERA HERNANDEZ
"10175", // ILSE TISCAREÐO MUÐIZ
"10176", // GERMAN VALLE SALCIDO
"10177", // MIRIAM ESTHER AULAR MONTES
"10178", // INVERVA AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"10179", // ISAEL CANDELARIO MASS CAHUICH
"10180", // CONSULTORIA G Y E AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10181", // NANCY YERALDINY GONZALEZ PEREZ
"10182", // GUILLERMO GARCIA ROJAS
"10183", // MIGUEL ANGEL MEDINA ZUÐIGA
"10184", // CARLOS ALEJANDRO PORTILLO ARTALEJO
"10185", // ADRIANA SOTRES KOSOSKY
"10186", // MIGUEL ANGEL BUSTOS OLIVAS
"10187", // CARLOS VALDES MARTIN
"10188", // JUAN ISRAEL DE ATOCH CHI ORIBE
"10190", // PEDRO LOZANO PEREZ
"10191", // JESUS CARDIEL LOPEZ
"10192", // MA. EUGENIA ESTRADA RIOS
"10193", // DAVID ABUT SACAL
"10194", // ARACELY MENDOZA PEREZ
"10195", // PAOLA ILEANA RAMIREZ GUTIERREZ
"10196", // TRIGARANTE AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10197", // MARIA DEL CARMEN MORALES DOMINGUEZ
"10198", // JUAN LIBORIO ESPINOSA PEREZ
"10200", // JESUS ABEL YAÐEZ GARDEA
"10201", // MAURICIO VILLASEÐOR YANNINI
"10202", // FRANCISCA GUADALUPE MACIAS COLORES
"10203", // FEDERICO FUENTES PEREZ
"10204", // JOSE MARIO CARRILLO SHEINBAUM
"10205", // NALLELY ELIZABETH DEL VALLE RAMIREZ
"10206", // MIGUEL ANGEL CAVAZOS DELGADO
"10207", // LUIS GERARDO CERDA CUEVAS
"10208", // RAUL ALBERTO WEBER LEAL
"10209", // OMAR MIGUEL MERINO GOMEZ
"10210", // YOLANDA MARTINEZ REYNOSO
"10212", // MIGUEL MISAEL MARTINEZ OCHOA
"10213", // XOCHITL QUIROZ TENORIO
"10214", // RICARDO ULISES FABELA GONZALEZ
"10215", // MIGUEL ANGEL DEYTA PANTOJA
"10216", // ARTURO LAFARGA BATIZ
"10217", // OSCAR ULISES MANZANILLA DEL CUETO
"10218", // ALEJANDRO SANCHEZ DEL CASTILLO
"10219", // UNIVERSIDAD NACIONAL AUTËNOMA DE M╔XICO
"10220", // JUAN CARLOS CORTES LUNA
"10221", // MARIANA GABRIELA ROMERO ANTONIO
"10222", // SANTIAGO HERNANDEZ VIGIL
"10223", // MIRIAN GOMEZ NAVA
"10224", // LAURA OLIVIA TREJO HERNANDEZ
"10225", // POLIC═A INDUSTRIAL BANCARIA DEL ESTADO DE HIDALGO
"10226", // ANDRES PORTILLA CESPEDES
"10227", // YADIRA MONSERRAT LOPEZ LOPEZ
"10228", // JAVELLY ASESORES AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V
"10229", // ANAHI NAVA VELO
"10230", // GILBERTO DIAZ CORONA
"10231", // OSCAR MENDEZ HERNANDEZ
"10232", // ANA CELINA MARTINEZ GUTIERREZ
"10233", // ARACELY ALBARRAN RODRIGUEZ
"10234", // ERIKA BEATRIZ PUY MAY
"10235", // LUIS ROBERTO BELTRAN RIVERA
"10236", // MANUEL BARCENAS CERVANTES
"10237", // MAGALY CASTAÐEDA ZARAGOZA
"10238", // MANUEL BASUALDO LOPEZ
"10239", // CLAUDIA CALCANEO CEBALLOS
"10240", // MOISES VICENCIO MARTINEZ
"10241", // LAFON Y ASOCIADOS AGENTE DE SEGUROS Y DE FIANZAS S.A.
"10242", // JESUS SALVADOR RAMIREZ DOMINGUEZ
"10243", // IVAN GUTIERREZ SALVADOR
"10244", // PAULINA MICHEL MARTINEZ RIOS
"10245", // LUIS DANIEL RAMIREZ DIAZ
"10246", // THANIA ALEJANDRA PONCE VARGAS
"10247", // ARMANDO GUZMAN ALVAREZ
"10248", // LUIS ALBERTO SANTIAGO CALLEROS
"10249", // JOSE LUIS VELAZQUEZ ALONZO
"10250", // ARACELI DEL CARMEN OROZCO ESPINO
"10251", // LILIANA VELAZQUEZ CAMACHO
"10252", // PABLO GONZALEZ PEREA
"10253", // ARTURO CESAR DE RIQUER RIOS
"10254", // AHTZIRI NAYELI ROMO MORALES
"10255", // ALVARO RAMIRO CAMPOS GOROCICA
"10256", // DONAI EDISON TEODORO ORTIZ
"10257", // ELIZABETH GOMEZ ANGEL
"10258", // ENRIQUE GERARDO MONGE ORTEGA
"10259", // JOSE MANUEL ROMERO RIVAS
"10260", // CUAUHTEMOC ROSENDO TECUAPETLA MANRIQUE
"10261", // CARLOS ALBERTO SALAZAR CAVAZOS
"10262", // FRANCISCO CESAR MORALES ARAIZA
"10263", // OSCAR DOMINGUEZ ROSAS
"10264", // EZEQUIEL HEREDIA PALACIOS
"10265", // ASVISE AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V
"10266", // ANGEL ISRAEL SOTO CRISTOBAL
"10267", // LILIA GALINDO ALDANA
"10268", // ALEJANDRO ANAYA GENTY
"10269", // JUVENAL ARMANDO LLAMAS CHAVARRIA
"10270", // MUNICIPIO DE CHALCO
"10271", // LUZ MARISELA MOORE MARTINEZ
"10272", // J BENJAMIN BECERRA PADILLA
"10273", // JAIME RECILLAS GOMEZ
"10274", // ERNESTO SOBERANES EGUIA
"10275", // ALEJANDRA SANDOVAL OROZCO
"10276", // ALICIA RODRIGUEZ MARTINEZ
"10277", // MARIA DEL SOCORRO CO OROPEZA ROCHA
"10278", // MARIO ALBERTO GONZALEZ OCHOA
"10279", // ERICK AURELIO CASTAÐEDA CAMPOS
"10280", // ERIKA RAYGOZA BARRADAS
"10281", // CARLOS GONZALEZ HERNANDEZ
"10282", // ESTEBAN LEON LARA
"10283", // ALFREDO ALVAREZ CHACON
"10284", // ADRIANA ELSA RUIZ CAMARENA
"10285", // HUGO ALEJANDRO ORTIZ BECERRA
"10286", // MANUEL RODRIGUEZ CARRASCO
"10287", // ROSA MARISELA FEHR WIEBE
"10288", // MISSAEL IBZAN DELGADO REYNA
"10289", // ELSA CHAVEZ ORDOÐEZ
"10290", // ALEJANDRA LOYA SOTO
"10291", // ADRIANA PRIETO JUAREZ
"10292", // ALYS EUGENIA GONZALEZ DE HOYOS
"10293", // VERONICA PALACIOS GUTIERREZ
"10294", // ULISES HERNANDEZ ESCOBAR
"10295", // EDUARDO ARELLANO LAREDO
"10296", // GERARDO ALEJANDRO MENDOZA GONZALEZ
"10297", // PABLO ENRIQUE PEÐALOZA ESPINOZA
"10298", // BRENDA AIDA NAVA RUIZ
"10299", // MARIA ALEJANDRA VILLEGAS VILLEGAS
"10300", // BRENDA MARIA HERNANDEZ HERNANDEZ
"10301", // SOFIA CHAVEZ PEREZ
"10302", // JORGE MUÐOZ CORONADO
"10303", // JOSE GUSTAVO TINAJERO ESQUIVEL
"10304", // RAFAEL LARA LOPEZ
"10305", // JOSE MANUEL VELAZQUEZ TAPIA
"10306", // MIRNA LUZ DOMINGUEZ GARCIA
"10307", // XOCHITL BELTRAN GUEVARA
"10308", // ARMANDO CELAYA CASILLAS
"10309", // LUIS DANIEL LUCIO HERNANDEZ
"10310", // IAN MAURICIO GUAJARDO RODRIGUEZ
"10311", // VICTOR MANUEL GARCIA TREJO
"10312", // MANUEL RAFAEL GONZALEZ CASTILLA
"10313", // MARISELA ORNELAS REBOLLEDO
"10314", // MARTHA ANGELICA CORDOVA RUIZ
"10315", // GERARDO GUAJARDO CASTRO
"10316", // MARCOS EDUARDO LARA ALTAMIRANO
"10317", // TOMAS HERNANDEZ HERNANDEZ
"10318", // SALVADOR PEREZ ESCALANTE
"10319", // MARIA ESTHER MEZA DIAZ
"10320", // ARACELI LETICIA ROSALES ARREDONDO
"10321", // ADRIANA SALDIVAR CONTRERAS
"10322", // CLAUDIA JANNETTE ZAPATA ALVAREZ
"10323", // DIANA SOCORRO FLORES MORENO
"10324", // MARCOS IVAN DIAZ BECERRA
"10325", // MONICA LAURA HEKIMIAN TANUS
"10326", // MGI AGENTE DE SEGUROS S.A. DE C.V.
"10327", // PAUL VALDEZ VALENZUELA
"10328", // ERIC HERNANDEZ FERNANDEZ DEL CAMPO
"10329", // JOSE ALBERTO NASSER SALOMON
"10330", // ELADIO DOÐES RANGEL
"10331", // SANDRA ESPARZA RAMIREZ
"10332", // ELOISA EDITH ZAPATA PEÐA
"10333", // GILBERTO GARCIA CHAVIRA
"10334", // JACQUELINE RAMOS HERNANDEZ
"10335", // DANIEL ALBERTO SALCIDO LOPEZ
"10336", // ERICK JORDAN DELGADILLO CARRANZA
"10337", // MAYELA CONCEPCION HERNANDEZ MONTES DE OCA
"10338", // CLAUDIA STEFANIA ESCALANTE VALDIVIA
"10339", // JANET GARCIA SALVADOR
"10340", // MARY CARMEN ORTEGA NAVA
"10341", // GRUPO ROSALES AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10342", // MARTHA JULIA AMEZQUITA DIAZ
"10343", // OMAR PAULINO SANCHEZ ARENAS
"10344", // LAURA MARIELLA SANCHEZ SANCHEZ
"10345", // ALEJANDRO LOPEZ RUMAYOR
"10347", // COOPERTUS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10348", // LETICIA VANESSA MALDONADO LOZANO
"10349", // JUAN MARTIN ZUANI ROBLES
"10350", // JAIR ALEJANDRO GARCIA GONZALEZ
"10351", // DANIEL OLIVER PROCELL VILLALOBOS
"10352", // JOSE LUIS DIAZ ROMAN
"10353", // JESSICA ANABEL BARRERA SIERRA
"10355", // CENTRO DE INVESTIGACIONES Y ESTUDIOS SUPERIORES EN ANTROPOLOG═A SOCIAL
"10356", // MARCELA MARTINEZ ESCOBAR
"10357", // LAURO ALBERTO SANDEZ RAMIREZ
"10358", // RICARDO AGUILAR ESCOBAR
"10359", // ROLANDO CAMPILLO DURAN
"10360", // REINA HAIDY GARZON MALDONADO
"10361", // MARIA LUISA GABRIELA VAZQUEZ GONZALEZ
"10362", // JOSE LUIS JACINTO MORALES
"10363", // KARINA LIZBETH CAÐEZ MANCILLAS
"10364", // MARIA LILIANA CISNEROS SOLIS
"10366", // ELIAS GARCIA RUIZ
"10367", // ALEJANDRA MANRIQUE MORENO
"10368", // VICTOR EMMANUEL CASTILLO SANCHEZ
"10369", // VERONICA SANDOVAL VILLEGAS
"10370", // LUIS ALBERTO GUZMAN VARGAS
"10371", // JOSE IGNACIO SAINZ NORIEGA
"10372", // DAVID VERDUZCO HIGUERA
"10373", // CARMEN CARMINA MEZA URIAS
"10374", // LORENA TATIANA GARCIA GARCIA
"10375", // GRUPO CORISE AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10376", // CARLOS ALBERTO MORENO OLIVARES
"10377", // OSCAR REYES LOPEZ
"10378", // JOSE JUAN FERNANDEZ CASTILLO
"10379", // LORENZA BRAVO GARIBI
"10380", // FRANCISCO ZAZUETA PAPPATHEODOROU
"10381", // ADAN FERNANDO GONZALEZ OLIVARES
"10382", // JOSE LUIS LOZANO RODRIGUEZ
"10383", // ANA ISABEL DEL VALLE VILLEGAS
"10384", // AOM ASESORES EXPERTOS EN SEGUROS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10385", // RAQUEL BOLAÐOS PORRAS
"10386", // TUMAX AGENTE DE SEGUROS S.A. DE C.V.
"10387", // JUAN ANTONIO LOPEZ SORIA
"10388", // AGENTES DIRECTOS
"10389", // JUAN MANUEL REYNA RIVERA
"10390", // ALONSO ANTONIO SAENZ HAAS
"10391", // JUAN FERNANDO GOMEZ MENENDEZ
"10392", // NORMA ANGELICA PROCUNA HERNANDEZ
"10393", // ROSA YADIRA NAJERA OROZCO
"10394", // EDUARDO ARTURO AG▄ERO CEPEDA
"10395", // KALIDA CONSULTOR EN RIESGOS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10396", // ARMANDO RAFAEL COCOM RUIZ
"10397", // VICTOR HUGO NEVAREZ LOZADA
"10398", // GABRIEL PINEDA CAMPOS
"10399", // PRISMA PHOLETT NIETO PALACIOS
"10400", // VERONICA GUADALUPE SANCHEZ MARQUEZ
"10401", // CARLOS EUSEBIO IRUSTETA MUÐIZ
"10402", // CECILIA MARIA SOCORR RAMOS PEREZ
"10403", // KARLA RESENDIZ ARENAS
"10404", // GERARDO ENRIQUE ROSAS VELAZQUEZ
"10405", // FRANCISCO RUIZ QUINTERO
"10406", // ANA MAYTE RODARTE PONCE
"10407", // SERGIO ARTURO CERVERA DE FRANCHIS
"10408", // FRANCISCO JAVIER ENRIQUEZ HERNANDEZ
"10409", // JUAN RODRIGUEZ CARRILLO
"10410", // JACINTO VAZQUEZ BALTAZAR
"10411", // PREVEX AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10412", // CASTILLO Y ASOCIADOS AGENTE DE SEGUROS S.A. DE C.V.
"10413", // ANTONIO ERHARD LOZANO
"10414", // MANUEL ALEJANDRO APARICIO CUEVAS
"10415", // JOSE ANTONIO REYES LEON
"10416", // GLORIA ALCANTARA CAMPOS
"10417", // SOFIA MARGARITA YAÐEZ ESTRADA
"10418", // GREGORIO CRUZ TREJO
"10419", // CINTHYA MARGARITA ALANIS REYES
"10420", // FLOR ELENA SALAS ACEVES
"10421", // MAGDALENA DEL CARMEN DAVILA RUBIO
"10422", // MARIA EUGENIA PASTOR GOMEZ
"10423", // REYNA SUHEY ALVIDRES SIGALA
"10424", // MARIA LUISA MADRID CAMPOS
"10425", // GABRIELA ESPINOZA AYON
"10426", // MONICA ITZEL SILVA MARTINEZ
"10427", // FRANCISCO JAVIER RAMIREZ FRANCO
"10428", // JESUS DARIO PALACIOS GARZA
"10429", // RISIKO AGENTE DE SEGUROS Y DE FIANZAS S.A DE C.V.
"10430", // IVONNE MARIE PERALTA GIL
"10431", // PRAD ASOCIADOS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10432", // ERICK GARDUZA MAYAGOITIA
"10433", // JESUS ADRIAN LOPEZ SOVERANEZ
"10434", // JOSE ARTURO ORTIZ GONZALEZ
"10435", // RODOLFO DE LA PAZ MEDINA
"10436", // JOSE SAUL RUELAS ESPARZA
"10437", // FABIOLA VIRIDIANA ALVA NOLAZCO
"10439", // MARZELA RODRIGUEZ OYARZABAL
"10440", // ISADORA MACIAS AGUIRRE
"10442", // JOSE LUIS RAUL NAVARRETE SANCHEZ
"10445", // VICTOR MEJIA GONZALEZ
"10446", // CLAUDIA ROSA MARIA MUÐOZ RUIZ
"10447", // RODRIGO DAVID DOMINGUEZ RUBIO
"10448", // JUAN CARLOS PULIDO BORBOA
"10449", // HECTOR MANUEL MARTINEZ ARAGON
"10450", // ALBERTO CARLOS PADILLA CHAVEZ
"10451", // MARCO ANTONIO JIMENEZ LANDWEHR
"10452", // CESAR ARTURO NAVARRO LOPEZ
"10453", // MIGDALEL VARGAS LOZADA
"10454", // JESUS LARA MARTI
"10455", // APOLONIO OLVERA RAMIREZ
"10457", // IRIS JIMENA NUÐEZ BUSTILLOS
"10458", // SERGIO EDUARDO BURRUEL BALMORI
"10459", // EDSON BIGVAI JUAREZ TORRES
"10460", // CERTUS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10461", // EDGAR VALDEZ AGUILAR
"10462", // CYNTHIA GARZA DE YTA
"10463", // ANTONIA TORRES CRUZ
"10464", // MARINA DEL PILAR GARCIA GODINEZ
"10465", // KARLA JUDITH PEREZ SOLIS
"10466", // ANABELLE MAÐUECO PEÐA
"10467", // GUADALUPE ISABEL URIOSTEGUI CARLOS
"10469", // MARCELA NIEVES VALDEZ
"10470", // ERIKA HENKEL LARA
"10471", // NAYELI BERRIEL ARENCIBIA
"10472", // VANESSA MARTINEZ CEJA
"10473", // JERR AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10474", // SAMIR PINEDA PEREZ
"10475", // BULL AND BEAR INSURANCE AGENTE DE SEGUROS S.A. DE C.V.
"10476", // EDUARDO ALBERTO ALAVEZ PITTMAN
"10477", // ANA LILIA GARCIA ARROYO
"10478", // ASESORIA Y PROTECCION AGENTE DE SEGUROS S.A. DE C.V.
"10479", // RODOLFO MARTINEZ MARTINEZ
"10480", // GUILLERMO FERNANDEZ PAVON
"10481", // JOSE FRANCISCO HERNANDEZ RAMOS
"10482", // ARTURO GONZALEZ LIMA
"10483", // CARLOS ALBERTO GONZALEZ SANCHEZ
"10484", // ANA KAREN LARA MAYO
"10486", // LUIS MARTIN DIAZ GARCIA
"10487", // ANA MARIA DE GUADALU TERPAN ACUÐA
"10488", // GLORIA ROSELY CAMPOS GARCIA
"10489", // LORENA GUERRA NAVARRO
"10490", // NADIA ERIVES VARGAS
"10491", // MARTHA FRANCISCA ROMERO SALAZAR
"10492", // SANDRA REYES SILVA
"10493", // JUAN JOSE GARCIA BAUTISTA
"10494", // JOSE DAVID GARCIA VILLARREAL
"10495", // ANGEL ADRIAN CAVAZOS HERNANDEZ
"10496", // BLANCA ZUÐIGA DELGADO
"10497", // CONCEPCION CERECERES HERNANDEZ
"10498", // ELDA IZBETH COLUNGA VELOZ
"10499", // CLAUDIA EMILIA GUTIERREZ CHAVEZ
"10500", // CIRO NARCISO MIJANGOS AGUILAR
"10501", // ARMANDO MEJIA SANABRIA
"10502", // MONICA DANIELA SANDOVAL GONZALEZ
"10503", // MARIA GUADALUPE CARRIZALES PADILLA
"10504", // J JESUS DELGADO ABOYTES
"10505", // BENJAMIN FRANCISCO VALENZUELA VILLALOBOS
"10506", // CARLOS ALBERTO CERDA GUERRERO
"10507", // RODRIGO HERNANDEZ JIMENEZ
"10508", // JORGE OCTAVIO CUETO ROSALES
"10509", // CARLA DIAZ CONTY GAMA
"10510", // ESTELA DE JESUS VALENCIA SOMOHANO
"10511", // LILIA MARIA DE LOURD JIMENEZ MONTAÐO
"10512", // JUAN FRANCISCO POBLETE VALENZUELA
"10513", // RODRIGO CABRAL VAZQUEZ
"10514", // SUGEY GABRIELA CASAVANTES URQUIZA
"10515", // ELIAS HERRERA DIAZ
"10516", // VICENTE ULISES CASTILLO VILLANUEVA
"10517", // CESAR ANTONIO BATTAGLIA BARRON
"10518", // GOBIERNO DEL ESTADO DE HIDALGO
"10519", // MARIO ENRIQUE CAVAZOS VAZQUEZ
"10520", // XAVIER ALVAREZ DE LA GARZA
"10521", // SECRETARIA DE HACIENDA Y CR╔DITO PUBLICO 
"10522", // GENESIS ORIZABA CARREÐO
"10523", // SALOME VASQUEZ TOCHIHUITL
"10524", // ROBERTO CERVANTES HERNANDEZ
"10525", // CHRISTIAN MORONI FRAGOSO BERUMEN
"10526", // MUNICIPIO DE NEZAHUALCOYOTL 
"10527", // REBECA PATIÐO MARTINEZ
"10528", // ARTURO CONTRERAS ACOSTA
"10529", // LOURDES GHISLAINE FIGUEROA HERNANDEZ
"10530", // GUILLERMO ABDIEL RAMIREZ GARCIA
"10531", // VIRIDIANA ARACELY HERNANDEZ VELAZQUEZ
"10532", // OMAR BARRON SALIDO
"10533", // JOSE HUMBERTO MARTINEZ GARZA
"10534", // CHRISTIAN IVAN MACIAS GOMEZ
"10535", // SERGIO RENE VARELA PINEDO
"10536", // JESUS ORENCIO RAMOS GALVEZ
"10537", // CESAR MURATALLA LOPEZ
"10538", // AGUSTIN CERVANTES PINELO
"10539", // ARISAI JOSUE CARREÐO FLORES
"10540", // GRUPO LOMBIC AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10541", // ANA SOFIA TORRES MEZA
"10542", // CARLOS NAHUM LEYVA TELLO
"10543", // FERNANDO AGUSTIN MATUS DIENER
"10544", // JUAN CARLOS SEGURA GARCIA
"10545", // JUAN CARLOS SEGURA ROMERO
"10546", // MARIA DEL CARMEN ELS WOOLFOLK NAVARRO
"10547", // ANA LAURA AGUILERA CAMACHO
"10548", // MARIO RENE VILLASEÐOR GARCIA
"10549", // CASSANDRA BALDERRAMA PEREZ
"10550", // PATRICIA GABRIELA YEOMANS FIGUEROA
"10551", // ANA LUZ PECHI BALCAZAR
"10552", // ROBERTO VASQUEZ SANTOS
"10553", // EDGARDO SANCHEZ RODRIGUEZ
"10554", // DIEGO ESCOBOSA CASTAÐEDA
"10555", // ELIZABETH MUSTRI MISRAHI
"10556", // GIORGIO ZOCCHI POZZI
"10557", // ARMANDO HERNANDEZ OLVERA
"10558", // CARLOS ALFONSO MALDONADO RAMIREZ
"10559", // FRANCISCO JAVIER MEZO DELGADO
"10560", // DORA OLIVIA NERI ALVARADO VIZCARRA
"10561", // RICARDO OCTAVIO MARIN RANGEL
"10562", // JORGE EDGARDO RAMIRO SALDAÐA
"10563", // NORMA SERVIN GARCIA
"10564", // ANDREA MARLEN RAMIREZ RODRIGUEZ
"10565", // ANELL BERENICE BELLO LEON
"10566", // NANCY GABRIELA GARZA GARCIA
"10567", // JOAQUIN ALEJANDRO CANO HERNANDEZ
"10568", // SAUL NOE MEZA RUBIO
"10569", // JAQUELINE DENNISE GUTIERREZ GARCIA
"10570", // OLGA LIDIA AYALA LANDA
"10571", // MARA MARTINEZ MACIAS
"10572", // IVAN MEDINA ROJAS
"10573", // SERGIO ROBERTO MEJIA ROBLES
"10574", // ROSSY ARIADNA GUERRERO GARCIA
"10575", // RAFAEL JOSE RODRIGUEZ ORTIZ
"10576", // BENJAMIN FERNANDEZ DE CORDOVA CARRANCO
"10577", // FRANCISCO JAVIER GARCIA MIER
"10578", // RUBEN MARTIN DEL CAMPO FLORES
"10579", // CLARA JIMENEZ RODRIGUEZ
"10580", // CARLOS EDUARDO ZARATE RODRIGUEZ
"10581", // HECTOR HUERTA VARGAS
"10582", // JUAN FERNANDO ORTIZ ONTIVEROS
"10583", // MARIA DEL CARMEN RAMIREZ MARQUEZ
"10585", // MARCOS ESTANISLAO ZAVALA DIAZ
"10586", // FRANCISCO JAVIER HERNANDEZ BLANCAS
"10587", // ONE COACH COBERTURAS INTERNACIONALES AGENTE DE SEGUROS S.A. DE C.V.
"10588", // ADOLFO ARTURO DEL PINO TAPIA
"10589", // BLANCA GUADALUPE VILLASEÐOR RAMIREZ
"10590", // MARIO RODRIGO ELORZA CAMARILLO
"10591", // BLANCA LETICIA DIAZ ELIZONDO
"10592", // ALAN JONATHAN JARAMILLO BRAVO
"10593", // FLOR DE MARIA MORALES CERVANTES
"10594", // ABDI ESVEYDI ARCOS SAUCEDO
"10595", // ALEJANDRO FAVILA PINEDA
"10596", // VICTOR HUGO DUARTE JIMENEZ
"10597", // ANDREA SALAZAR MARIE
"10598", // SALVADOR PLASCENCIA GONZALEZ
"10599", // GABRIEL EDUARDO LOPEZ ALAVEZ
"10600", // ELIU HAZAEL ROSALES DOMINGUEZ
"10601", // ELIZABETH GRANADOS SAUCEDA
"10602", // CARLOS ALBERTO OSORIO RUELAS
"10603", // REYNALDO PEÐALOZA CONTRERAS
"10604", // MARGARITA JONGUITUD VAZQUEZ
"10605", // VIRGINIA DENISSE CAMPOS DAVILA
"10606", // MARIEL FUENTES MARTINEZ
"10607", // MISAEL CRUZ JIMENEZ
"10608", // AURORA CARRILLO RODRIGUEZ
"10609", // NELLY PAULINA ARANDA MARMOLEJO
"10610", // FEDERICO ANTONIO VAZQUEZ ALVAREZ
"10611", // LIZBETH ZOHRAYA GARCIA BAUTISTA
"10612", // FLOR ANGELICA COELLO GOMEZ
"10613", // LUIS GERARDO LOZANO GARCIA
"10614", // MARIA ANGELICA FLORES MARTINEZ
"10615", // ALICIA GABRIELA MARTINEZ GONZALEZ
"10616", // MARIA LUISA CORONA DANDER
"10617", // ADRIANA ELIZABETH ESPINDOLA ARGUELLO
"10618", // ELENA ALICIA TIJERINA VALENZUELA
"10619", // MARIA DE LOURDES RODRIGUEZ GONZALEZ
"10621", // HECTOR ANTONIO GAMEROS ENRIQUEZ
"10622", // JUAN FRANCISCO TROCHEZ RIOFRIO
"10623", // ALEJANDRO EMILIO EICHELMANN ARIZPE
"10624", // ANALAURA LEDESMA MADRAZO
"10625", // GLORIA ESTELA MUÐIZ RAMIREZ
"10626", // CLAUDIA ARACELI ILLESCAS RAMOS
"10627", // LILLIANA OTAÐEZ MORA
"10628", // MARTA MARIA FERNANDEZ PELLON SILVA
"10629", // MANUEL ALEJANDRO CORONA HERNANDEZ
"10630", // JOSE PONCIANO PUGA PEREZ
"10631", // FRANCISCO JAVIER CORTES MEDINA
"10632", // LILIANA NATALY MUÐOZCANO PATIÐO
"10633", // PABLO GONZALEZ LEON
"10634", // CONCEPCION ROJAS HERNANDEZ
"10635", // MANUEL ROLANDO BARRUETO VIDAURRE
"10636", // FILIBERTO GUTIERREZ JUAREZ
"10637", // LUIS HUMBERTO DE LA TORRE GOMEZ
"10638", // BLANCA ISELA VASQUEZ BRACAMONTES
"10640", // GILBERTO GONZALEZ SAUCEDA
"10641", // JAIRO GABRIEL AGUILAR PANIAGUA
"10642", // JORGE RAUL FARFAN MOGUEL
"10643", // OCG AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10644", // PABLO ALFREDO VARA ARAGON
"10645", // GAPPER 24 AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10646", // A4 ACTUARIA Y ADMINISTRACION AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10647", // FELIPE SUAREZ PEREZ
"10648", // ALFONSO LOPEZ HERNANDEZ
"10649", // DAVID LOPEZ VELAZQUEZ
"10650", // CARLOS YUNES MADRID
"10651", // JUAN MIGUEL JIMENEZ PEREZ
"10652", // RAUL REYNA CAMACHO
"10653", // ARTURO ARIAS JIMENEZ
"10654", // JOSE ISIDRO SOSA BAEZA
"10655", // CARLOS AUGUSTO PAZ SANCHEZ
"10656", // VICTOR GUILLERMO ROBLES FIGUEROA
"10657", // FRANCISCO JAVIER ANDRADE MARTINEZ
"10658", // ALFONSO MARTIN REYES FLORES
"10660", // ROSALBA MARISCAL RAMOS
"10661", // KARLA STEPHANIE MADRID DIAZ
"10662", // RAMON AARON RAMIREZ GASTELUM
"10663", // DIEGO ZAVREL MANCERA
"10664", // EDELMIRA MATILDE PEREYRA GALLAGHER
"10665", // LUIS ROBERTO TREVIÐO PEREZ
"10666", // CARLOS CABAÐAS SASTRE
"10667", // SAMUEL CARLOS BERMUDEZ TAYLOR
"10668", // LAURA YAZMIN GARCIA HERNANDEZ
"10669", // CARLOS MARCELO TORRES OROZCO
"10670", // LUIS ALONSO MONTERO PADILLA
"10671", // PEDRO HORACIO GUZMAN MALDONADO
"10672", // ROBERTO FERNANDEZ CASTILLO
"10673", // ANA BERTHA VILLEGAS OCHOA
"10674", // LUIS JORGE CEJUDO PEREZ
"10675", // MARIA ELENA NUÐEZ RIOS
"10676", // JUAN CARLOS GUERRERO CARRERA
"10677", // DANIEL MARAÐON ACEVEDO
"10678", // ADRIANA GUADALUPE VALENZUELA TORRES
"10679", // MA DE JESUS VARGAS LUNA
"10680", // JUAN JOSE CAUDILLO JIMENEZ
"10681", // ANTONIO TINAJERO ANDRADE
"10682", // RODRIGO RAFAEL VALLE RUIZ
"10684", // ALEJANDRA RAMIREZ ORTIZ
"10685", // CALDMORE INSURANCE AGENTE DE SEGUROS S.A. DE C.V.
"10686", // EDGAR RIVERA PEREZ
"10687", // FATIMA THALIA GUADAL ARCOS CAMPOS
"10688", // RED UNITAS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10689", // MARCOS VICENTE AVILA GOMEZ
"10690", // J PORTUGAL AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10691", // MAURICIO MUCIÐO MACIAS
"10692", // JOSE ISABEL ACEVEDO HERNANDEZ
"10693", // RODRIGO GUERRA GARCIA
"10694", // JOSE LUIS LARA NUÐEZ
"10696", // MARIA DEL CARMEN TEPO GABRIEL
"10697", // ROBERTO VARGAS RENDON
"10698", // JORGE ALEJANDRO YAÐEZ GORDILLO
"10699", // NOE ALVARO DOMINGUEZ CARDENAS
"10700", // RODOLFO VAZQUEZ GUAJARDO
"10701", // CESAR CABRERA AVILA
"10702", // ALEJANDRO CASTILLO CASTRO
"10703", // MARIA MARGARITA MACIAS DIAZ
"10704", // MARIA DEL ROSARIO GONZALEZ RODRIGUEZ
"10706", // JUAN ANDRES LOPEZ MARTINEZ
"10707", // PEDRO PEREZ ONTIVEROS
"10708", // LUZ MARIA BAUTISTA GARCIA
"10709", // PABLO ARTURO SANCHEZ GARCIA
"10710", // MULTISEGUROS ASESORES AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10711", // ANUAR PEÐA ELIAS
"10712", // CARLOS DAVID CARRERA CRUZ
"10713", // ADOLFO SALVADOR MERCADO BOBADILLA
"10714", // DORA ALICIA DUARTE LOPEZ
"10716", // YADIRA ALICIA LEON MORENO
"10717", // VICTOR ROSARIO CITAL RUIZ
"10719", // MARCO ANTONIO JOHNSON MAYTORENA
"10720", // MULTIPROTECK BROKER AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10721", // MAURICIO MARTINEZ GARCIA
"10722", // DAFNE ARIADNA JEREZ SALDAÐA
"10725", // INGRID EILEEN PERAZA OCHOA
"10726", // NORMA ANGELICA LOPEZ MUÐOZ
"10727", // FLAVIO MACIAS BRIONES
"10728", // ELEAZAR MONTIEL MENDOZA
"10729", // CARLOS EDUARDO TOBIAS PINTO
"10730", // EDSON SALDAÐA GODINEZ
"10731", // JOSE JESUS SANCHEZ GOMEZ
"10732", // BLANCA ESTELA RODRIGUEZ PASTOR
"10733", // ALFONSO ANDRES LOPEZ SANCHEZ
"10734", // MARIA ESTHER MOLINA CUEVAS
"10735", // COMPARA EN CASA AGENTE DE SEGUROS S.A. DE C.V.
"10736", // JOSE DAVID RODRIGUEZ ZAZUETA
"10737", // ARELI HERNANDEZ HERNANDEZ
"10738", // GRUPO KIIMS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10739", // SICUREZZA AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10740", // JUAN PABLO BRAVO RIVERO
"10741", // MARIA GUADALUPE RUIZ GAVIRA
"10742", // OSCAR GONZALEZ LEGORRETA
"10743", // MARIA GUADALUPE GARCIA GRANADOS
"10744", // GABRIELA CABRAL PLEHN
"10745", // JAVIER ALEJANDRO FLORES MALDONADO
"10746", // GENARO GARCIA VAZQUEZ
"10747", // FABIOLA CHAVEZ GONZALEZ
"10748", // RUTH NOHEMI LOPEZ VAZQUEZ
"10749", // SOTELO NAVARRO AGENTE DE SEGUROS Y DE FIANZAS S.A.DE C.V.
"10750", // VICTOR HUGO SANABRIA GAONA
"10751", // OLENKA BLANCO HERN┴NDEZ
"10752", // JESUS ADRIAN MARTINEZ LAREDO
"10753", // VICTOR MANUEL HUERTA TORRUCO
"10754", // GERMAN DELGADO PARAMO
"10755", // GERALDINNE ALTUZAR MERIDA
"10756", // JORGE OMAR CAPIN COTA
"10757", // GABRIELA ALEJANDRA MUSSA ESQUIVEL
"10758", // ALAN ARTURO RODRIGUEZ VILLEGAS
"10759", // MARIO FUSTER IBARRA
"10760", // RODRIGO JASSO ESTRADA
"10761", // JOSE ESCALON MENDEZ
"10762", // YOLANDA GALAN GUILLEN
"10763", // IRVIN HERRERA TRUJILO
"10764", // ALEJANDRO GUTIERREZ BUSTAMANTE
"10765", // ADRIAN RUIZ RODRIGUEZ
"10766", // IMPULSA DE MEXICO AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10767", // JESUS ANTONIO CAMPOS LOPEZ
"10768", // PAULA MARINA AGUILAR NAKAMURA
"10769", // ROBERTO FERNANDO REVILLA MORENO
"10770", // DINORAH SILVANA CHAVEZ GARCIA
"10771", // JUAN MANUEL GONZALEZ CASTILLO
"10772", // ANGEL ANTONIO HEREDIA GARCIA
"10773", // JUAN ENRIQUE AGUILAR ARGUELLO
"10774", // CESAR ARTURO NAZARIT PINTOR
"10775", // NATALIA ANAID VALDEZ GALLO
"10776", // FRANCISCO JAVIER MADRIGAL LARIOS
"10777", // JESUS RENE BORBON JAIME
"10778", // ERICK IVAN HUERTA MEJIA
"10779", // VICENTA MORENO ANDRADE
"10780", // ELOISA VAZQUEZ CAPILLA
"10781", // LUIS ALONSO TIRADO FERNANDEZ
"10782", // LIZBETH JANET MANZO MARTINEZ
"10783", // MAYRA CANO QUIROGA
"10784", // NOE JAVIER CAVAZOS TAMEZ
"10785", // ERIKA VANESA GARCIA ROSALES
"10786", // MARIA DEL CARMEN ESPINOSA MARTINEZ
"10787", // SILVANA MAGDALENA GARCIA RUIZ
"10788", // ADRIAN GONZALEZ LARA
"10789", // LORENZO GABRIEL LLANOS PEREZ
"10790", // OSCAR FEREGRINO SANCHEZ PLIEGO
"10791", // PEDRO BELMONTE SANCHEZ
"10792", // ALICIA ZILDAYNE ARELLANO SOTELO
"10793", // VIRIDIANA CRUZ NAVA
"10794", // JESUS ALEJANDRO GARCIA ROJAS
"10795", // MARIANA MADAI ORTEGA ROBLES
"10796", // ALEJANDRO MOZO CRUZ
"10797", // FRANCISCO EMMANUEL ARTEAGA GUTIERREZ
"10798", // CARLOS AMADOR IÐIGO MURRIETA
"10799", // GABRIELA OSORIO GUTIERREZ
"10800", // PROEMPRESA AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10801", // MARIA DEL CARMEN ROMERO MONTALVO
"10802", // ERICK ARMANDO LOPEZ ARGUELLO
"10803", // SERGIO IVAN LOPEZ GUILLEN
"10804", // CINTIA CEJA PADILLA
"10805", // UBBITT S.A. DE C.V.
"10806", // AUGUSTO PALAFOX CELAYA
"10807", // JESUS FLORES CHIN
"10808", // SANDRA LETICIA MADRID MARTINEZ
"10809", // GABRIEL LEYVA PATRON
"10810", // HECTOR MICHEL VAQUERA VILLASEÐOR
"10811", // CARLOS ANDRES DE LA CRUZ RODRIGUEZ
"10812", // UNIDAD ESPECIALIZADA
"10814", // MAURICIO TOMAS BEJARLE PANO
"10815", // ROSARIO IVETTE RODRIGUEZ CASTREJON
"10816", // CARLOS ALBERTO BARRIOS PIZA
"10817", // CESAR ADRIAN SILVA DOMINGUEZ
"10818", // JULIO CESAR MOTA VALDES
"10819", // MARIO OSCAR JACOBO BANUET
"10820", // MIGUEL RODRIGO PADILLA LUNA
"10821", // JORGE ARMANDO AVALOS MOJARRO
"10822", // MYRIAM MARTINEZ SEGURA
"10823", // JOSE JOAQUIN LOPEZ SUAREZ
"10824", // ANUAR KURI KARAM
"10825", // CRA INSURANCE HOLDINGS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10826", // YOSEF HARARI LANIADO
"10827", // LILIANA MUÐOZ ORDOÐEZ
"10828", // SERGIO ARMANDO RODARTE GALLEGOS
"10829", // CLAUDIA ADELAIDA LOZANO BARRERA
"10830", // ROSALIA SALCEDO EGUIA
"10831", // DIEGO ALEJANDRO GAXIOLA GAXIOLA
"10832", // ERICK GAEL CASTILLO BELTRAN
"10833", // SANDRA NATALIA HERNANDEZ RUIZ
"10834", // MARICELA GASCA GUTIERREZ
"10835", // NORMAN PREKOP BERNARD
"10836", // JOSE ANTONIO TORRES ALVAREZ
"10838", // GABRIEL RODRIGUEZ MORALES
"10839", // IVONNE ROJO SEGURA
"10841", // ANA ISABEL DIAZ DE LEON BERDEJA
"10842", // FERNANDA GAILL ROMO GUIDO
"10843", // LINO ARTURO YEIN CHIU CHAVEZ
"10844", // SUPRAINVEST MEXICO AGENTE DE SEGUROS S.A. DE C.V
"10845", // PROYECTOS OPERACIONES
"10846", // HECTOR MANUEL ALCANTARA SANCHEZ
"10847", // MARTIN GARCIA JAQUEZ
"10848", // LOQ AGENTE DE SEGUROS Y DE FIANZAS S.A.
"10849", // MATIAS AMBROSIO VALDEZ ARREDONDO
"10850", // JOSE GILBERTO V. GARZA FLORES
"10851", // JORGE EDUARDO CAREAGA HAYS
"10852", // KARLA VERA AVILA
"10853", // SAUL VAZQUEZ HERNANDEZ
"10854", // ILSE VIRGINIA MALDONADO MANDUJANO
"10855", // GISELA ALEXIS DE LEON ARREOLA
"10856", // RODRIGO JAVIER SALINAS LINARES
"10857", // DEIOSES ROBERTO TAMAYO SALINAS
"10858", // JORGE SALINAS SAIDE
"10859", // IGNACIO BENJAMIN MELO MADRIGAL
"10861", // JUAN JOSE LARA AYALA
"10862", // JOSE LUIS REYNOSO PABLOS
"10863", // JUAN CARLOS ROBLES FONSECA
"10864", // FEANGCAL CONSULTORIA SUSTENTABLE EN RIESGOS AGENTE DE SEGUROS SA
"10865", // VANESSA MADELINE MARTINEZ CASTILLO
"10866", // MANUEL ALBERTO AGUIRRE FIGUEROA
"10867", // MIGUEL ANGEL VALERIO FERNANDEZ
"10868", // ALEJANDRO VIELMA VELAZQUEZ
"10869", // MI COMPA AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"10870", // FAVIOLA ANGUIANO PIÐA
"10871", // WEG AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10872", // INTERSECURUS AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10873", // GABRIELA DEL CARMEN HERNANDEZ CASTORENA
"10875", // DIEGO ANDRES BATTAGLIA BARRON
"10876", // VICTOR ALEJANDRO HUERTA TORRUCO
"10877", // JESUS RAMON CAMPOS CONTRERAS
"10878", // FERNANDO AGUSTIN RAMIREZ ROMERO
"10879", // HECTOR FRANCISCO LAVIN RIOS
"10880", // ROSARIO ISABEL FLORES HERNANDEZ
"10881", // PEDRO AGUILAR ROMERO
"10882", // MIGUEL AGUSTIN DE LA MAZA GONZALEZ
"10883", // OSCAR LOPEZ CHACON
"10884", // JUAN CARLOS TOVAR MORA
"10885", // ALFREDO PEREZ DE CELIS MARTINEZ
"10886", // ALDO HERNANDEZ RABADAN
"10887", // EMMANUEL PADILLA PACHECO
"10888", // PROYECTOS OPERACIONES
"10889", // OSWALDO ANDRES ALONSO GUERRA
"10890", // MARIA FERNANDA LEDON HURTADO
"10891", // RICARDO LOREDO RODRIGUEZ
"10892", // LORENZO ANTONIO AGUILAR RODRIGUEZ
"10893", // MONICA ARACELY CAMPOS AGUILAR
"10894", // GABRIELA ELIAS RAMIREZ
"10895", // ROBERTO GUADALUPE SOLIS PEÐA
"10896", // NATMA
"10897", // JOSE CARLOS HIRIART LUQUIN
"10898", // MARIA EUGENIA TORRES CERDAN
"10899", // CINTHYA BERENICE GUTIERREZ FLORES
"10900", // AZUCENA DEL CARMEN RODRIGUEZ SANDOVAL
"10901", // NICOLL CONDE MARTINEZ
"10902", // EDUARDO LORENZO CASTILLO LEAL
"10903", // IRVING SOTERO RUBIO NICOLAS
"10904", // MARGARITA PATRICIA ARCINIEGA DIAZ
"10905", // SALEM DAHER CERVANTES
"10906", // EDUARDO MARIN PACHECO
"10907", // ANA LUISA ZOLA HERRERA
"10908", // JACQUELINNE ZAIDEN ESCOBEDO CARRILLO
"10909", // CORPORATIVO SLIMPLAN AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"10910", // RH DIRECTO AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10911", // KAREN JEANETH GARCIA SAUCEDO
"10912", // VICTORIA PORTILLO JAQUEZ
"10913", // PEDRO ADRIAN RAMOS MORALES
"10914", // RENE PAUL DELOYA BASURTO
"10915", // JUAN PABLO HUERTA BARRIENTOS
"10916", // CARLOS GERARDO LOZANO VIAMONTE
"10917", // ARTURO ALEJANDRO BURRUEL HUERTA
"10918", // ALDO JORGE BALDERAS ANTONIO
"10919", // IBROK AGENTE DE SEGUROS Y FIANZAS SA DE CV
"10920", // ELI GOMEZ MOLINA
"10921", // HECTOR HOMERO GONZALEZ ESPINOZA
"10923", // MIGUEL ALFREDO ESTRADA RENEAUM
"10924", // ALMA GUADALUPE SALDAÐA SANCHEZ
"10926", // LUIS FLORES HERNANDEZ
"10927", // BITUAJ AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"10929", // MARIA DE LOURDES GONZALEZ ORDOÐEZ
"10930", // ROSINA OLHAGARAY AYALA
"10931", // JESUS DANIEL PAYRO AVALOS
"10932", // LUIS BONOLA VALDEZ
"10933", // JOSE ANTONIO MORENO AVELLANA
"10934", // REYNA LETICIA ESPINOZA TORRECILLAS
"10935", // PEDRO RAFAEL CENTENO ROSADO
"10936", // JUNIOR ABRAHAM ALCAZAR JIMENEZ
"10937", // CARLOS BENJAMIN ARANDA TORRES
"10939", // METRO II GOBIERNO
"10940", // CARLOS CRUZ PAZ
"10941", // MARIO ENRIQUE MARTINEZ MURILLO
"10942", // LUIS MIGUEL RAMIREZ TELLO
"10946", // MARIO RICARDO RUBI LOPEZ
"10947", // JESUS ALFONSO PONCE GONZALEZ
"10948", // AARON ENRIQUE CARRIZALES LEMUS
"10949", // LUIS FERNANDO MAXIMI GONZALEZ PEREGRINA
"10950", // JESUS ALBERTO RAMOS ANAYA
"10951", // CARLOS ARMANDO CAMACHO GUTIERREZ
"10952", // MARIA DE LOURDES HERBERT SILVA
"10953", // ARMANDO MORENO FIERROS
"10954", // HECTOR ALEJANDRO LIRA RODRIGUEZ
"10955", // CHRISTOPHER VICTOR A SEELS GUZMAN
"10956", // MIGUEL ANGEL SALINAS GARZA
"10957", // ALEJANDRO GALLEGOS LUGO
"10958", // ERNESTO DE JESUS FLORES ROMAN
"10959", // VICTOR BERNARDO PEREZ VAZQUEZ
"10960", // FRANCISCO JAVIER POO LOPEZ
"10961", // LUIS ALBERTO MARTINEZ TOVAR
"10962", // CHRISTIAN SAUL ESPINOZA VEGA
"10963", // JOSE ANTONIO UC POOT
"10964", // NELYS VIRGINIA CAMPA RIVERA
"10965", // BIA A.P. AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"10966", // GABRIELA TROVAMALA GARCIA
"10968", // LUZ AURORA ARREOLA JIMENEZ
"10969", // EDUARDO MARTIN POLANCO CARRILLO
"10970", // JUAN CARLOS MENDIETA CORONA
"10971", // ALMA CRISTINA PEREZ NOREÐA
"10972", // EDNA MARCELA YNIESTA LARA
"10973", // LUIS GERARDO SIFUENTES AGUILAR
"10974", // JULIO CESAR PEREZ PERALTA
"10975", // CARLOS ROBERTO MARTINEZ GALVEZ
"10976", // ERIK ADRIAN CRUZ MONTIEL
"10977", // MARIA CAROLINA MELENDEZ LUNA
"10978", // LUZ MARIA LANDA JUAREZ
"10980", // ADRIANA CERVANTES UC
"10982", // ALFREDO VACA MORENO
"10984", // JESUS ARMANDO ACOSTA VILLALOBOS
"10985", // ADRIANA VALDEZ RUIZ
"10986", // JOSE GERARDO GARCIA VINATIER
"10987", // FRANCISCO JAVIER BAHENA AGUIRRE
"10988", // RODRIGO VILLAR RANGEL
"10989", // FELIPE RAUL HOLSCHNEIDER OSUNA
"10990", // EDGAR ANGEL RUIZ GUTIERREZ
"10991", // TECILLI JIMENEZ PEREZ
"10992", // JOSE ARMANDO ARRIOLA GUZMAN
"10993", // BOUTIQUE COBERTURAS AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"10994", // JOSE LUIS CANALES GUTIERREZ
"10995", // YURI ORTIZ SUNDHEIM
"10996", // MANUEL LEYVA BRISEÐO
"10997", // RICARDO ALONSO SALAS ROCHA
"10998", // AURORA GUADALUPE DE CRUZ JIMENEZ
"10999", // FERNANDO SANTANDREU DE WIT
"11000", // CARLOS RUBEN ORTIZ FOURR
"11001", // SERGIO ANTONIO RIVAS ROJAS
"11002", // ARTURO ABAD GARCIA
"11003", // MIGUEL ANGEL FATTEL GARCIA
"11004", // INDIRA RIVERA MENDEZ
"11005", // KARINA PAOLA SAENZ FILIO
"11008", // ALEJANDRO CARRETE MEZA
"11009", // REBECA CONCEPCION REVELO VIONET
"11010", // RODOLFO PADILLA ITURRALDE
"11011", // OSCAR IVAN ARREOLA ARREOLA
"11012", // GELLMY GEORGINA GUEMEZ FLOTA
"11013", // AIL AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"11014", // MARISELA DIAZ JAQUEZ
"11015", // PATRICIO GOMEZ CRUZ
"11016", // MARIA LETICIA PINEDO CARRANZA
"11017", // RAUL GILBERTO UGARTE ZEA
"11018", // CARLOS DAHL .
"11020", // ALEJANDRO SANDOVAL CARREON
"11021", // MARIA ELENA RODRIGO Y VELEZ
"11022", // MARTHA PATRICIA TELLEZ REYNOSO
"11023", // YARA LIBIA OCHOA MORENO
"11024", // ENRIQUE ORTEGA VELASCO
"11025", // LUIS ALBERTO FRAUSTRO RODRIGUEZ
"11026", // JUAN BOSCO JUAREZ SOTO
"11027", // MARLENE LEON RODRIGUEZ
"11028", // NANCY YADIRA HERNANDEZ CAZARES
"11029", // ALEJANDRO HOYO CASTANEDO
"11030", // KARLA PATRICIA DEL FIERRO FIERRO
"11031", // DANIELA KARINA DEL FIERRO FIERRO
"11032", // ENRIQUE DEL FIERRO ORODÐEZ
"11033", // MANUEL BERNARDO MOLINA NOYOLA
"11034", // SI&BG AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"11035", // ELVIS TREJO GONZALEZ
"11036", // HORACIO LOPEZ CASTILLO
"11037", // MARIA GUADALUPE CARLIN USCANGA
"11038", // HUGO ALEXANDRO VALENCIA SEPULVEDA
"11039", // JOSE GUILLERMO MONROY MIRANDA
"11040", // GERARDO ABEL ZARAGOZA CONTRERAS
"11041", // WILMA ARACELLY PECH CHE
"11042", // EDUARDO GUILLERMO TORRES LANDA SNYDER
"11043", // CARLOS ALBERTO ALVAREZ GONZALEZ
"11044", // LUIS IGNACIO ARREDONDO MARTINEZ
"11045", // JESUS BARDOMIANO MEDINA PASILLAS
"11046", // JOSE RICARDO BRISEÐO PEREZ
"11047", // EDER NORBERTO RODRIGUEZ HERNANDEZ
"11048", // EFREN JAIR RODRIGUEZ HERNANDEZ
"11049", // SANDRA GARCIA MORENO
"11050", // ALDO ANDRADE GAONA
"11051", // AGUSTIN SOLANO HERNANDEZ
"11052", // AGUSTIN OCHOA BRAMBILA
"11053", // DAVID CASTILLO TOBIAS
"11054", // FREDDY ENRIQUE AGUILAR QUIJANO
"11056", // ALMENARA AGENTE DE SEGUROS Y DE FIANZAS SA DE CV 
"11057", // ROBERTO JOEL DEL RIO LEON
"11058", // HECTOR HUGO URBINA VILLANUEVA
"11059", // JAIME SALGADO GONZALEZ
"11061", // KARINA JEANETTE MOLINA RUBIO
"11062", // ANA MARGARITA GUZMAN TEODORO
"11063", // HUGO SERGIO DUARTE BAÐUELOS
"11064", // TERESA ROJAS RIOS
"11065", // JESUS ABRAHAM RIVERA LEON
"11066", // ROBERTO CEJA CEJA
"11069", // MIGUEL RAFAEL MEKLER GRANILLO
"11070", // FERNANDO DEL CARMEN CAMARGO SANTIAGO
"11072", // EVER MANUEL SANCHEZ SANCHEZ
"11073", // CLELIA MARIA MORFIN NUÐO
"11074", // MARIO ALBERTO MENDOZA HERNANDEZ
"11075", // RUBEN ISMAEL TERRAZAS NARVAEZ
"11077", // SICUREZZA AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"11078", // CESAR EDUARDO ACEVEDO FLORES
"11079", // MARIA ANDREA GONZALEZ MORTERA
"11080", // DOLORES VILLAFAN FONSECA
"11081", // SEBASTIAN ISAIN CARRILLO PEREZ
"11082", // RIGOBERTO GALVEZ CRUZ
"11083", // CARMEN NEFERTARY ALTAMIRANO RODRIGUEZ
"11084", // KARLA IBETH MIRELES LOZANO
"11085", // SAMANTHA MUÐOZ MARTINEZ
"11086", // SANDRA MUÐOZ MARTINEZ
"11087", // VICTOR HUGO LOPEZ LLANOS
"11088", // ALBERTO CABADAS BATISTA
"11089", // EDUARDO GONZALEZ QUINTERO
"11090", // HECTOR MARCOS MARTINEZ LARA
"11091", // LUIS CARLOS CAZARES RAMIREZ
"11092", // RICARDO BRAVO NAVARRO
"11093", // ROBERTO FERMIN CAZARES BUENDIA
"11095", // ALEJANDRO SERRANO SERRANO
"11096", // ROBERTO AVILA RAMIREZ
"11097", // MIGUEL ANGEL RAMIREZ GONZALEZ
"11098", // GERMAN HERNANDEZ VITE
"11099", // MARIA DEL PILAR HERRERIA VALDES
"11100", // CLAUDIA GUADALUPE JAVIER ALARCON
"11101", // DANIA IMELDA RUIZ GARCIA
"11102", // FRANCISCO CARLOS FIGUEROA ARROYO
"11103", // FERNANDA CONTRERAS CAMPA
"11104", // INNOVA LATINO
"11106", // ABRAHAM METTA SEVILLA
"11107", // JOSE ANTONIO ROJAS CESSA
"11108", // ALMIRANDA CASTELLANOS LOPEZ
"11109", // GUADALUPE PONCE DE LEON GONZALEZ
"11110", // YOLANDA BLANCO GARCIA
"11111", // IRMA ANGELICA BALLESTEROS DE ALBA
"11112", // DALIA OVANDO QUEVEDO
"11113", // HIAFFAR RENE VILCHEZ ESCORCIA
"11114", // SANDRA CECILIA CRUZ JUAREZ
"11115", // FRANCISCO GABRIEL OLVERA SALAZAR
"11116", // ROGELIO RIOS CHAVEZ
"11118", // ISMAEL HUMBERTO ANTILLON CALZADILLAS
"11119", // JESUS ONTIVEROS BACA
"11120", // WILBERTH JESUS NOH PECH
"11121", // GRUPO EMPRESARIAL S.J. SA DE CV
"11122", // DANIELA PELAEZ ORDOÐEZ
"11123", // REBECA HERNANDEZ MOHEDANO
"11124", // MARCO ANTONIO AJA SAINZ TRAPAGA
"11125", // ROCIO LIZET PADILLA SALADO
"11126", // ELENA ZUBIRIA LOPEZ
"11128", // VIELI CONCEPCION IZQUIERDO ALAMILLA
"11129", // MARLON IVAN DE LA ROSA HERRERA
"11130", // DIANA FRANCO RODEA
"11131", // JORGE GUZMAN ARRONA
"11133", // BENIGNO HERNANDEZ HIGUERON
"11134", // ADRIAN ZABAL TRUJILLO
"11136", // ELIZABETH GOMEZ SANDOVAL
"11137", // JORGE ANDRES FIGUEROA LAW
"11138", // BERNARDO ALFARO CUBELLS
"11139", // TRACK AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"11140", // SERGIO ENRIQUE MONTOYA ZENTENO
"11143", // OLIVIA OROZCO ORTIZ
"11144", // JOSE MANUEL URIBE JIMENEZ
"11145", // IMELDA LOYA GONZALEZ
"11146", // VICTORIA DOMINGUEZ GALI
"11147", // JORGE DANIEL CONEJO RANGEL
"11148", // MARIA ARACELI OREA HUERTA
"11149", // CORRAL AGENTE DE SEGUROS Y DE FIANZAS S.A DE C.V
"11150", // FABIOLA BRIZUELA SHAFER
"11151", // HUGO ALBERTO RAMIREZ VALDEZ
"11153", // JOSE FERNANDO DOMINGUEZ GUEVARA
"11154", // MARIA LUCIA VELAZQUEZ RAMIREZ
"11155", // ILIANA PRIEGO JIMENEZ
"11157", // ALAN FELIPE PADILLA SORIA
"11158", // AIDA MONTIEL ARZATE
"11159", // FAUSTO JOAQUIN PAREDES LUNA
"11160", // DANIEL RENE HERNANDEZ TENA
"11161", // ANGEL HORACIO SOTO MEZA
"11162", // ENRIQUE MORENO MARTINEZ
"11163", // GIOVANNY CADENA CARABELI
"11165", // DANIELA MORENO MENDOZA
"11166", // IGNACIO ZARAGOZA RAMIREZ
"11167", // JOSE ANGEL HUITRON CANTU
"11169", // SERGIO ENRIQUE MANCHA FONSECA
"11172", // IMELDA CAROLINA FERREIRA JUAREZ
"11173", // HERNAN MENDOZA SANCHEZ
"11174", // FABIOLA SANCHEZ ORELLAN
"11175", // MARIO RENATO DE LA PEÐA VIDERIQUE
"11176", // MARIA DE LOS ANGELES PAGOLA NICOLINI
"11178", // MARTIN EDUARDO BERNAL DE LA TORRE
"11179", // LEONARDO BARRIENTOS MARTINEZ
"11180", // PATRICIA ARREDONDO SALDAÐA
"11182", // ROBERTO PEÐA HAWAYEK
"11183", // SILVIA GARCIA TAPIA
"11184", // STEFANIA LUCIA MUÐOZ CENOBIO
"11186", // JUAN GUERRERO VAZQUEZ
"11187", // ISAAC FLORES GARCIA
"11188", // EMILIO ANTONIO REYNA RODRIGUEZ
"11190", // RAYMUNDO PLIEGO ALVARADO
"11191", // ANGEL ODILIO SANCHEZ VILLATORO
"11193", // EMMA PINEDA ROMAN
"11194", // LETICIA MARGARITA RULLAN MENDOZA
"11195", // FELIPE FERREIRA Y RENDON
"11196", // JOSE LUIS LOZANO GONZALEZ
"11197", // JOAQUIN ALANIS FUENTES OLIVER
"11199", // OSCAR FABIAN DE LUNA BONALES
"11200", // EFREN ROJAS CISNEROS
"11201", // VIRGINIA CAMACHO MENDEZ
"11202", // JUAN CARLOS NADAL HERNANDEZ
"11203", // GEMMA ALEXANDRA DURAN MIRANDA
"11204", // YAMUEL ISRAEL SANCHEZ FLORES
"11205", // LETICIA MARGARITA CAZARIN RULLAN
"11206", // RODRIGO OCAÐA MUÐOZ
"11207", // ASF PRISMA MEXICO AGENTE DE SEGUROS Y DE FIANZAS
"11208", // JORGE ARTURO SALAZAR URBINA
"11209", // ERANDHI YURAI HUITZIL PALAFOX
"11210", // CLAUDIA GABRIELA GARCIA PADILLA
"11212", // OMAR SAÐUDO CORONA
"11213", // RICARDO DIAZ VILLARREAL
"11214", // ARMANDO CULEBRO TRUJILLO
"11215", // CESAR MARTINEZ LOPEZ
"11216", // RITA ISABEL RUBIO MEDINA
"11217", // ROXANA MORENO CARO
"11218", // LEIDY STEPHANIE OSORIO LOPEZ
"11219", // AURORA SANCHEZ SANCHEZ
"11220", // FERNANDO JOSE DIAZ MANRIQUE DE LARA
"11221", // PATRICIA VAZQUEZ AGUIRRE
"11222", // JAVIER TAPIA CRUZ
"11223", // SALVADOR ZEPEDA VILLAZANA
"11224", // MARCOS HIRAM AVALOS DURAN
"11225", // GERARDO MIGUEL SALGADO BENITEZ
"11226", // SERGIO ALEJANDRO GOMEZ HERNANDEZ
"11227", // CONDE RAMIREZ ESPECIALISTAS EN RIESGOS AGENTE DE SEGUROS Y DE FIANZAS SA DE CV 
"11228", // JESUS ISAAC AGUILAR MARTINEZ
"11229", // GABRIELA MARTINEZ JIMENEZ
"11230", // JOSE MANUEL ESQUINCA ARTEAGA
"11231", // SEBASTIAN MARQUEZ ALANIS
"11233", // LILIA IRAN CARREÐO DIAZ
"11234", // ELOY PEREZ PELAYO
"11235", // ERENDIRA SALGADO GAMA
"11236", // EDGAR MANUEL GOMEZ SANTOYO
"11237", // JONATHAN OMAR VALDEZ ALAMILLO
"11238", // FERNANDO CUAUHTEMOC NUÐEZ COLUNGA
"11239", // DIANA ANDREA CHAVEZ MARQUEZ
"11240", // ALEJANDRO CHAVEZ ESPINOLA
"11241", // LOURDES CARRASCO MORENO
"11242", // ERIKA DANAHE CASTILLO GARNICA
"11243", // LUIS ALEJANDRO GOMEZ ESQUIVEL
"11244", // SERGIO HEIRAS MUELA
"11245", // RAUL ALFONSO SALINAS LOPEZ
"11246", // JOSE ANTONIO GUEVARA LOPEZ
"11247", // YESENIA MORGA ESCOBAR
"11248", // FISCALIA GENERAL DE JUSTICIA ESTADO DE MEXICO
"11249", // DIANA ORTIZ ESPINOSA
"11250", // RICARDO ESQUIVEL GALLEGOS
"11252", // SERGIO AMAURY FLORES CRUZ
"11253", // LUIS JORGE CERDA GOMEZ
"11254", // GUADALUPE TAMEZ CHAVEZ
"11255", // EDUARDO LAGUNA ORTIZ
"11256", // VICTOR MANUEL JASSO GONZALEZ
"11257", // VICTOR LOPEZ MEJIA
"11258", // MARIA GUADALUPE IRMA PRIETO COYOTL
"11259", // JOAQUIN GABRIEL CEDILLO HERNANDEZ
"11260", // MIGUEL ANGEL GUTIERREZ PULIDO
"11261", // VIANKA ALEJANDRA ANAYA ENRIQUEZ
"11262", // ISELA GUTIERREZ GONZALEZ
"11263", // VANESSA ESCARPULLI GARCIA
"11264", // MARISA GALAZ RAMOS
"11265", // SALVADOR SANCHEZ GARCIA
"11266", // ALMA GUADALUPE ITURRIA MACAZAGA
"11267", // IVONNE LIZALDI MIJARES
"11268", // MARIA CLARA DUQUE BRAVO
"11269", // ISRAEL CASTRO AMACOSTA
"11270", // AARON VARGAS ZARATE
"11271", // INTERPAME AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V.
"11272", // MMR & RISIKO AGENTE DE SEGUROS Y DE FIANZAS SA DE CV
"11273", // ALICIA HUIZAR AVILA
"11274", // GEORGINA GUADALUPE GONZALEZ MORALES
"11275", // CESAR RODRIGUEZ MARTINEZ
"11276", // JORGE YAGGER SANTACRUZ PULIDO
"11277", // PEDRO VICTORINO LOPEZ PIEDRA
"11278", // JORGE JESUS OBREGON MALDONADO
"11279", // CARLOS ALBERTO MANILLA CONTRERAS
"11280", // MARIA ESTHER ESTRADA MARQUEZ
"11281", // HECTOR AMBROCIO GONZALEZ TORRES
"11282", // SANDRA CAZARES QUEZADA
"11283", // ALFREDO SALAME SACAL
"11284", // CRISTIAN SALINAS GARCIA
"11285", // JOSUE ABRAHAM RAMIREZ SANTIAGO
"11286", // LUIS ORESTES MARTINEZ FLORES
"11287", // IMELDA BELINDA ARVIZU CUELLAR
"11288", // GUILLERMO VALENCIA RENTERIA
"11289", // NORA ANABEL QUINTERO CASTILLO
"11290", // CESAR ARTURO LOZADA LOPEZ RUIZ
"11291", // MIGUEL GARCIA AGUILAR
"11292", // JORGE ALBERTO GARZA CAVAZOS
"11293", // WENDY CRISTAL ESPINO BLANCO
"11294", // MARIA ELENA FERNANDEZ ORIA
"11295", // CAROLINA RODRIGUEZ SIQUEIROS
"11296", // HECTOR PEREZ DURAN
"11297", // SALVADOR HERNANDEZ PENILLA
"11298", // YAZMIN FACUNDO SOLIS
"11301", // MANUEL GONZALEZ MARTINEZ
"11302", // ASSURISK AND CO AGENTE DE SEGUROS SA DE CV
"11303", // SOLUCIONES LATINO
"11304", // HORACIO RANGEL RAMIREZ
"11305", // CLAUDIA GALLEGOS AVILA
"11306", // JUAN MURILLO FLORES
"11307", // CRISTIAN CALIXTO FLORES
"11308", // NAYELI RENEDO MEDINA
"11309", // ANGELICA VERONICA RAMIREZ SANABRIA
"11310", // IRIS GUADALUPE SUAREZ DOMINGUEZ
"11311", // JONATHAN ORTEGA TORRES
"11312", // EMMANUEL MARTINEZ RAMIREZ
"11313", // MARIA LAURA LOPEZ  GUERRERO SANCHEZ
"11315", // VICTOR MANUEL MELO TELLEZ
"11316", // ALMA FABIOLA GONZALEZ MORENO
"11317", // SERGIO ALBERTO FUENTES SAENZ
"11319", // ABIDAN MACIAS OLVA
"11320", // GRUPO PREVE CONSULTORES AGENTE DE SEGUROS Y DE FIANZAS S.A DE C.V
"11321", // UTILITARIOS LATINO
"11322", // MARIA ESTHER NOHEMI HERNANDEZ LUGO
"11323", // MISAEL AMARO MARTINEZ
"11324", // CARLOS VALENTIN GARCIA ESCUTIA
"11326", // CARLOS DOMINGUEZ ROBLES
"11328", // ERIKA AMIEVA CARLOS
"11329", // CETINA PACHECO AGENTE DE SEGUROS SA DE CV
"11332", // HILDA ALICIA ELENA AROUESTY VILLA
"11333", // JULIO CESAR OCEGUEDA PAREDES
"11335", // ASESOR PROFESIONAL
"11336", // EQUINOX MERIDA AGENTE DE SEGUROS Y DE FIANZAS S.A. DE C.V. 
"11337", // ANA LAURA ARANZABAL BRAVO
"11339", // LAURA VILLANUEVA LUNA
"11340", // ESMERALDA YAZMIN MARTINEZ REYES
"11341", // VIDAL ALFONSO VALENCIA BARAJAS
"11342", // JOSE LUIS CURIEL RUIZ
"11343", // ALMA LIZZETE CASTILLO MARTELL
"11344", // JESSICA PAOLA ARALUCE HERNANDEZ
"11345", // PROMASE, AGENTE DE SEGUROS SA DE CV
"11346", // MARIANA DEL CASTILLO AMARO
"11347", // GABRIEL RODRIGUEZ RODRIGUEZ
"11348", // LAURA LIZETH RODRIGUEZ RUIZ
"11349", // FERNANDO JOSE LOPEZ PLA
"11350", // LUIS ENRIQUE NAVAS IZARRARAS
"11351", // LUIS NARVAEZ GRIJALVA
"11352", // ENRIQUE MANUEL ABURTO SAPIEN
"11353", // ANTONIO VICENTE RODRIGUEZ
"11354", // MARIANA ELIZABETH NUÑEZ ALARCON
"11355", // JOSE LUIS GUTIERREZ OLGUIN
"11356", // SUSANA ABASCAL DIAZ BARREIRO
"11357", // OSMAR RICARDO PEREYRA REYES
"11358", // JULIO CESAR AGUILAR CASTELLANOS
"11359", // MARIA SARA MONDRAGON BARRIENTOS
"11361", // RODOLFO ALONSO LANDAVERDE
"11362", // OSCAR ARTURO OSORIO ROJAS
"11367", // DIANA LAURA PEREZ BRETON
"11368", // GABRIEL BAGUNDO MEDINA
"11371", // LUIS ALEJANDRO MORA GAYTAN
"11375", // RAUL GREGORIO HERNANDEZ VILLAR
"11378", // ESTHER LOPEZ HERRERA
"11383", // GILBERTO OMAR GONZALEZ VALENCIA
"11360", // MARCO ANTONIO RAUL ESTRADA VARGAS
"11621", //	REYDESEL FLORES PEREZ	
"cobranza" // área de cobranza

];